export const battery0 = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .battery0-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g2"
     transform="matrix(0.47169811,0,0,0.47169811,-17.476416,-22.452831)">
     <g
       id="bat-border"
       class="battery0-styling"
     >
    <rect
       x="60.400002"
       y="-130.5"
       width="59.200001"
       height="91.699997"
       rx="5"
       ry="5"
       transform="rotate(90)"
       />
    <rect
       x="77.900002"
       y="-141.3"
       width="24.1"
       height="10.7"
       transform="rotate(90)"
       />
     </g>
  </g>
  `
]
export const battery100 = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .battery100-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g7"
     transform="matrix(0.47169811,0,0,0.47169811,-17.476416,-22.452831)">
    <g id="bat-border"
       class="battery100-styling">
    <rect
       x="60.400002"
       y="-130.5"
       width="59.200001"
       height="91.699997"
       rx="5"
       ry="5"
       transform="rotate(90)"
        />
    <rect
       x="77.900002"
       y="-141.3"
       width="24.1"
       height="10.7"
       transform="rotate(90)"
    />
    </g>
    <g id="bat-level-100"
       class="e-board-svg-bat-level-100 battery100-styling">
    <line
      stroke="inherit"
       x1="51.299999"
       y1="69.5"
       x2="51.299999"
       y2="110.3"
        />
    <line
      stroke="inherit"
       x1="65"
       y1="69.5"
       x2="65"
       y2="110.3"
        />
    <line
      stroke="inherit"
       x1="78.300003"
       y1="69.5"
       x2="78.300003"
       y2="110.3"
      />
    <line
      stroke="inherit"
       x1="91.5"
       y1="69.5"
       x2="91.5"
       y2="110.3"
        />
    <line
      stroke="inherit"
       x1="104.2"
       y1="69.5"
       x2="104.2"
       y2="110.3"
        />
    <line
      stroke="inherit"
       x1="117.4"
       y1="69.5"
       x2="117.4"
       y2="110.3"
       />
    </g>
  </g>
  `
]
export const battery20 = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .battery20-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g2"
     transform="matrix(0.47169811,0,0,0.47169811,-17.476416,-22.452831)">
     <g
       id="bat-border"
     >
    <rect
       class="battery20-styling"
       x="60.400002"
       y="-130.5"
       width="59.200001"
       height="91.699997"
       rx="5"
       ry="5"
       transform="rotate(90)"
       />
    <rect
       class="battery20-styling"
       x="77.900002"
       y="-141.3"
       width="24.1"
       height="10.7"
       transform="rotate(90)"
       />
    </g>
    <line
       id="bat-level-20"
       class="e-board-svg-bat-level-20 battery20-styling"
       x1="51.299999"
       y1="69.5"
       x2="51.299999"
       y2="110.3"
     />
  </g>
  `
]
export const battery40 = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .battery40-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g4"
     transform="matrix(0.47169811,0,0,0.47169811,-17.476416,-22.452831)">
     <g
       id="bat-border"
       class="battery40-styling"
     >
    <rect
       x="60.400002"
       y="-130.5"
       width="59.200001"
       height="91.699997"
       rx="5"
       ry="5"
       transform="rotate(90)"
        />
    <rect
       x="77.900002"
       y="-141.3"
       width="24.1"
       height="10.7"
       transform="rotate(90)"
       />
      </g>
      <g
       id="bat-level-40"
       class="e-board-svg-bat-level-40 battery40-styling"
      >
    <line
       x1="51.299999"
       y1="69.5"
       x2="51.299999"
       y2="110.3"
        />
    <line
       x1="65"
       y1="69.5"
       x2="65"
       y2="110.3" />
    <line
       x1="78.300003"
       y1="69.5"
       x2="78.300003"
       y2="110.3" /></g>
  </g>
  `
]
export const battery60 = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .battery60-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g5"
     transform="matrix(0.47169811,0,0,0.47169811,-17.476416,-22.452831)">
     <g id="bat-border"
       class="battery60-styling">
    <rect
       x="60.400002"
       y="-130.5"
       width="59.200001"
       height="91.699997"
       rx="5"
       ry="5"
       transform="rotate(90)"
      />
    <rect
       x="77.900002"
       y="-141.3"
       width="24.1"
       height="10.7"
       transform="rotate(90)"
        /> </g>
       <g id="bat-level-60" class="e-board-svg-bat-level-60 battery60-styling">
    <line
       x1="51.299999"
       y1="69.5"
       x2="51.299999"
       y2="110.3"
       />
    <line
       x1="65"
       y1="69.5"
       x2="65"
       y2="110.3"
        />
    <line
       x1="78.300003"
       y1="69.5"
       x2="78.300003"
       y2="110.3"
       />
    <line
       x1="91.5"
       y1="69.5"
       x2="91.5"
       y2="110.3"
        /></g>
  </g>
  `
]
export const battery80 = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .battery80-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g6"
     transform="matrix(0.47169811,0,0,0.47169811,-17.476416,-22.452831)">
     <g id="bat-border"
       class="battery80-styling">
    <rect
       x="60.400002"
       y="-130.5"
       width="59.200001"
       height="91.699997"
       rx="5"
       ry="5"
       transform="rotate(90)"
       />
    <rect
       x="77.900002"
       y="-141.3"
       width="24.1"
       height="10.7"
       transform="rotate(90)"
       /></g>
       <g id="bat-level-80"
       class="e-board-svg-bat-level-80 battery80-styling">
    <line
       stroke="inherit"
       x1="51.299999"
       y1="69.5"
       x2="51.299999"
       y2="110.3"
       />
    <line
       stroke="inherit"
       x1="65"
       y1="69.5"
       x2="65"
       y2="110.3"
      />
    <line
       stroke="inherit"
       x1="78.300003"
       y1="69.5"
       x2="78.300003"
       y2="110.3"
       />
    <line
       stroke="inherit"
       x1="91.5"
       y1="69.5"
       x2="91.5"
       y2="110.3"
       />
    <line
       stroke="inherit"
       x1="104.2"
       y1="69.5"
       x2="104.2"
       y2="110.3"
       />
   </g>
  </g>
  `
]
export const chp = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .chp-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g7"
     transform="matrix(0.52246601,0,0,0.52246601,-23.066875,-28.772202)">
    <rect
       class="chp-styling"
       x="45.900002"
       y="60.400002"
       width="39.299999"
       height="66.900002"
       id="rect1" />
    <rect
       class="chp-styling"
       x="116"
       y="59.400002"
       width="11"
       height="40.400002"
       rx="5.5"
       ry="5.5"
       id="rect2" />
    <rect
       class="chp-styling"
       x="127.1"
       y="59.299999"
       width="11"
       height="40.400002"
       rx="5.5"
       ry="5.5"
       id="rect3" />
    <rect
       class="chp-styling"
       x="105.1"
       y="59.400002"
       width="11"
       height="40.400002"
       rx="5.5"
       ry="5.5"
       id="rect4" />
    <path
       class="chp-styling"
       d="m 127.9,127.4 c -4.8,0 -8.8,-3.9 -8.8,-8.8 v 0 c 0,-4.8 3.9,-8.8 8.8,-8.8 z"
       id="path4" />
    <line
       class="chp-styling"
       x1="104.3"
       y1="74"
       x2="85.199997"
       y2="74"
       id="line4" />
    <line
       class="chp-styling"
       x1="119.1"
       y1="118.6"
       x2="85.199997"
       y2="118.6"
       id="line5" />
    <line
       class="chp-styling"
       x1="127.9"
       y1="114.4"
       x2="138.10001"
       y2="114.4"
       id="line6" />
    <line
       class="chp-styling"
       x1="127.9"
       y1="123.1"
       x2="138.10001"
       y2="123.1"
       id="line7" />
  </g>
  `
]
export const container = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .container-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g7"
     transform="matrix(0.44692737,0,0,0.44692737,-13.480447,-22.413407)">
    <polygon
       class="container-styling"
       points="37.1,117.2 37.1,72.6 94.2,51.9 94.2,137.9 "
       id="polygon1" />
    <polyline
       class="container-styling"
       points="94.2 51.9 135.1 62.4 135.1 128 94.2 137.9"
       id="polyline1" />
    <line
       class="container-styling"
       x1="117"
       y1="131.5"
       x2="117"
       y2="58.5"
       id="line1" />
    <line
       class="container-styling"
       x1="83.099998"
       y1="123.1"
       x2="83.099998"
       y2="66.599998"
       id="line2" />
    <line
       class="container-styling"
       x1="71.800003"
       y1="118.9"
       x2="71.800003"
       y2="71.400002"
       id="line3" />
    <line
       class="container-styling"
       x1="59.5"
       y1="115.4"
       x2="59.5"
       y2="74.900002"
       id="line4" />
    <line
       class="container-styling"
       x1="48.200001"
       y1="111.3"
       x2="48.200001"
       y2="79.599998"
       id="line5" />
    <line
       class="container-styling"
       x1="109"
       y1="100.5"
       x2="109"
       y2="90"
       id="line6" />
    <line
       class="container-styling"
       x1="124"
       y1="99.099998"
       x2="124"
       y2="91.5"
       id="line7" />
  </g>
  `
]
export const containerAlarm = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .tecget-container-alarm-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g7"
     transform="matrix(0.44692737,0,0,0.44692737,-13.480447,-22.413407)">
     <g transform="matrix(0.9,0,0,0.9,10,15)">
    <polygon
       class="tecget-container-alarm-styling"
       points="37.1,117.2 37.1,72.6 94.2,51.9 94.2,137.9 "
       id="polygon1" />
    <polyline
       class="tecget-container-alarm-styling"
       points="94.2 51.9 135.1 62.4 135.1 128 94.2 137.9"
       id="polyline1" />
    <line
       class="tecget-container-alarm-styling"
       x1="117"
       y1="131.5"
       x2="117"
       y2="58.5"
       id="line1" />
    <line
       class="tecget-container-alarm-styling"
       x1="83.099998"
       y1="123.1"
       x2="83.099998"
       y2="66.599998"
       id="line2" />
    <line
       class="tecget-container-alarm-styling"
       x1="71.800003"
       y1="118.9"
       x2="71.800003"
       y2="71.400002"
       id="line3" />
    <line
       class="tecget-container-alarm-styling"
       x1="59.5"
       y1="115.4"
       x2="59.5"
       y2="74.900002"
       id="line4" />
    <line
       class="tecget-container-alarm-styling"
       x1="48.200001"
       y1="111.3"
       x2="48.200001"
       y2="79.599998"
       id="line5" />
    <line
       class="tecget-container-alarm-styling"
       x1="109"
       y1="100.5"
       x2="109"
       y2="90"
       id="line6" />
    <line
       class="tecget-container-alarm-styling"
       x1="124"
       y1="99.099998"
       x2="124"
       y2="91.5"
       id="line7" />
    </g>
    <circle
       style="fill:#f92224;fill-opacity:1;stroke:inherit;stroke-width:1;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:17;stroke-dasharray:none;stroke-opacity:1"
       id="path499"
       cx="50"
       cy="62"
       r="11" />
</g>
  `
]
export const containerOk = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .tecget-container-ok-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g7"
     transform="matrix(0.44692737,0,0,0.44692737,-13.480447,-22.413407)">
    <g transform="matrix(0.9,0,0,0.9,10,15)">
    <polygon
       class="tecget-container-ok-styling"
       points="37.1,117.2 37.1,72.6 94.2,51.9 94.2,137.9 "
       id="polygon1" />
    <polyline
       class="tecget-container-ok-styling"
       points="94.2 51.9 135.1 62.4 135.1 128 94.2 137.9"
       id="polyline1" />
    <line
       class="tecget-container-ok-styling"
       x1="117"
       y1="131.5"
       x2="117"
       y2="58.5"
       id="line1" />
    <line
       class="tecget-container-ok-styling"
       x1="83.099998"
       y1="123.1"
       x2="83.099998"
       y2="66.599998"
       id="line2" />
    <line
       class="tecget-container-ok-styling"
       x1="71.800003"
       y1="118.9"
       x2="71.800003"
       y2="71.400002"
       id="line3" />
    <line
       class="tecget-container-ok-styling"
       x1="59.5"
       y1="115.4"
       x2="59.5"
       y2="74.900002"
       id="line4" />
    <line
       class="tecget-container-ok-styling"
       x1="48.200001"
       y1="111.3"
       x2="48.200001"
       y2="79.599998"
       id="line5" />
    <line
       class="tecget-container-ok-styling"
       x1="109"
       y1="100.5"
       x2="109"
       y2="90"
       id="line6" />
    <line
       class="tecget-container-ok-styling"
       x1="124"
       y1="99.099998"
       x2="124"
       y2="91.5"
       id="line7" />
         </g>
   <circle
       style="fill:#5ec44e;fill-opacity:1;stroke:inherit;stroke-width:1;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:17;stroke-dasharray:none;stroke-opacity:1"
       id="path499"
       cx="50"
       cy="62"
       r="11" />
       </g>
  `
]
export const containerWarning = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .tecget-container-warning-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g7"
     transform="matrix(0.44692737,0,0,0.44692737,-13.480447,-22.413407)">
     <g transform="matrix(0.9,0,0,0.9,10,15)">
    <polygon
       class="tecget-container-warning-styling"
       points="37.1,117.2 37.1,72.6 94.2,51.9 94.2,137.9 "
       id="polygon1" />
    <polyline
       class="tecget-container-warning-styling"
       points="94.2 51.9 135.1 62.4 135.1 128 94.2 137.9"
       id="polyline1" />
    <line
       class="tecget-container-warning-styling"
       x1="117"
       y1="131.5"
       x2="117"
       y2="58.5"
       id="line1" />
    <line
       class="tecget-container-warning-styling"
       x1="83.099998"
       y1="123.1"
       x2="83.099998"
       y2="66.599998"
       id="line2" />
    <line
       class="tecget-container-warning-styling"
       x1="71.800003"
       y1="118.9"
       x2="71.800003"
       y2="71.400002"
       id="line3" />
    <line
       class="tecget-container-warning-styling"
       x1="59.5"
       y1="115.4"
       x2="59.5"
       y2="74.900002"
       id="line4" />
    <line
       class="tecget-container-warning-styling"
       x1="48.200001"
       y1="111.3"
       x2="48.200001"
       y2="79.599998"
       id="line5" />
    <line
       class="tecget-container-warning-styling"
       x1="109"
       y1="100.5"
       x2="109"
       y2="90"
       id="line6" />
    <line
       class="tecget-container-warning-styling"
       x1="124"
       y1="99.099998"
       x2="124"
       y2="91.5"
       id="line7" />
    </g>
    <circle
       style="fill:#fafb5c;fill-opacity:1;stroke:inherit;stroke-width:1;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:17;stroke-dasharray:none;stroke-opacity:1"
       id="path499"
       cx="50"
       cy="62"
       r="11" />
</g>
  `
]
export const dashboardCenterIcon = [
  '1080 1080',
  `
  <!-- Generator: Adobe Illustrator 29.8.2, SVG Export Plug-In . SVG Version: 2.1.1 Build 3)  -->
  <defs
     id="defs212">
    <style
       id="style148">
      .tecget-dashboard-center-icon-styling-0, .tecget-dashboard-center-icon-styling-1, .tecget-dashboard-center-icon-styling-2, .tecget-dashboard-center-icon-styling-3, .tecget-dashboard-center-icon-styling-4, .tecget-dashboard-center-icon-styling-5, .tecget-dashboard-center-icon-styling-6, .tecget-dashboard-center-icon-styling-7, .tecget-dashboard-center-icon-styling-8, .tecget-dashboard-center-icon-styling-9, .tecget-dashboard-center-icon-styling-10 {
        fill: none;
      }
      .tecget-dashboard-center-icon-styling-11 {
        fill: #f1f1f1;
      }
      .tecget-dashboard-center-icon-styling-12 {
        fill: #3c3c3b;
      }
      .tecget-dashboard-center-icon-styling-13 {
        fill: #e26768;
      }
      .tecget-dashboard-center-icon-styling-14 {
        fill: #f1f3be;
        opacity: .3;
      }
      .tecget-dashboard-center-icon-styling-14, .tecget-dashboard-center-icon-styling-15, .tecget-dashboard-center-icon-styling-16, .tecget-dashboard-center-icon-styling-17, .tecget-dashboard-center-icon-styling-18, .tecget-dashboard-center-icon-styling-19, .tecget-dashboard-center-icon-styling-20, .tecget-dashboard-center-icon-styling-21, .tecget-dashboard-center-icon-styling-22, .tecget-dashboard-center-icon-styling-23, .tecget-dashboard-center-icon-styling-24, .tecget-dashboard-center-icon-styling-25 {
        isolation: isolate;
      }
      .tecget-dashboard-center-icon-styling-26 {
        fill: #202f40;
      }
      .tecget-dashboard-center-icon-styling-27 {
        fill: #acb1b1;
      }
      .tecget-dashboard-center-icon-styling-28 {
        fill: #73879f;
      }
      .tecget-dashboard-center-icon-styling-29 {
        fill: url(#Unbenannter_Verlauf);
      }
      .tecget-dashboard-center-icon-styling-15 {
        opacity: 0;
      }
      .tecget-dashboard-center-icon-styling-15, .tecget-dashboard-center-icon-styling-30, .tecget-dashboard-center-icon-styling-18 {
        fill: #62686c;
      }
      .tecget-dashboard-center-icon-styling-15, .tecget-dashboard-center-icon-styling-16, .tecget-dashboard-center-icon-styling-17, .tecget-dashboard-center-icon-styling-18, .tecget-dashboard-center-icon-styling-31, .tecget-dashboard-center-icon-styling-21 {
        mix-blend-mode: multiply;
      }
      .tecget-dashboard-center-icon-styling-32 {
        fill: url(#Unbenannter_Verlauf_2);
      }
      .tecget-dashboard-center-icon-styling-33 {
        fill: url(#Unbenannter_Verlauf_4);
      }
      .tecget-dashboard-center-icon-styling-34 {
        fill: url(#Unbenannter_Verlauf_3);
      }
      .tecget-dashboard-center-icon-styling-35 {
        fill: url(#Unbenannter_Verlauf_6);
      }
      .tecget-dashboard-center-icon-styling-36 {
        fill: url(#Unbenannter_Verlauf_5);
      }
      .tecget-dashboard-center-icon-styling-1 {
        stroke-dasharray: 1.3 14.7;
      }
      .tecget-dashboard-center-icon-styling-1, .tecget-dashboard-center-icon-styling-2, .tecget-dashboard-center-icon-styling-3, .tecget-dashboard-center-icon-styling-4, .tecget-dashboard-center-icon-styling-5 {
        stroke-width: 6.6px;
      }
      .tecget-dashboard-center-icon-styling-1, .tecget-dashboard-center-icon-styling-2, .tecget-dashboard-center-icon-styling-3, .tecget-dashboard-center-icon-styling-4, .tecget-dashboard-center-icon-styling-5, .tecget-dashboard-center-icon-styling-6, .tecget-dashboard-center-icon-styling-7, .tecget-dashboard-center-icon-styling-8, .tecget-dashboard-center-icon-styling-9 {
        stroke-linejoin: round;
      }
      .tecget-dashboard-center-icon-styling-1, .tecget-dashboard-center-icon-styling-2, .tecget-dashboard-center-icon-styling-3, .tecget-dashboard-center-icon-styling-4, .tecget-dashboard-center-icon-styling-5, .tecget-dashboard-center-icon-styling-6, .tecget-dashboard-center-icon-styling-7, .tecget-dashboard-center-icon-styling-9, .tecget-dashboard-center-icon-styling-10 {
        stroke-linecap: round;
      }
      .tecget-dashboard-center-icon-styling-1, .tecget-dashboard-center-icon-styling-3, .tecget-dashboard-center-icon-styling-4 {
        stroke: #cb1237;
      }
      .tecget-dashboard-center-icon-styling-16 {
        fill: #2f1d00;
      }
      .tecget-dashboard-center-icon-styling-16, .tecget-dashboard-center-icon-styling-18, .tecget-dashboard-center-icon-styling-37 {
        opacity: .2;
      }
      .tecget-dashboard-center-icon-styling-2, .tecget-dashboard-center-icon-styling-5, .tecget-dashboard-center-icon-styling-9 {
        stroke: #41aa34;
      }
      .tecget-dashboard-center-icon-styling-17, .tecget-dashboard-center-icon-styling-38 {
        fill: #b8b8b9;
      }
      .tecget-dashboard-center-icon-styling-39 {
        fill: #6b7377;
      }
      .tecget-dashboard-center-icon-styling-40 {
        fill: #606262;
      }
      .tecget-dashboard-center-icon-styling-41 {
        fill: #c3c8cb;
      }
      .tecget-dashboard-center-icon-styling-42 {
        fill: #efefef;
      }
      .tecget-dashboard-center-icon-styling-43 {
        fill: #63696d;
      }
      .tecget-dashboard-center-icon-styling-44 {
        fill: #c1c1c1;
      }
      .tecget-dashboard-center-icon-styling-45 {
        fill: #414343;
      }
      .tecget-dashboard-center-icon-styling-4 {
        stroke-dasharray: 1.3 14.5;
      }
      .tecget-dashboard-center-icon-styling-46 {
        fill: #ee9059;
      }
      .tecget-dashboard-center-icon-styling-47 {
        fill: #328529;
      }
      .tecget-dashboard-center-icon-styling-48 {
        fill: #a4aebb;
      }
      .tecget-dashboard-center-icon-styling-49 {
        fill: #5c5c5c;
      }
      .tecget-dashboard-center-icon-styling-50 {
        fill: #f9a469;
      }
      .tecget-dashboard-center-icon-styling-51 {
        fill: #cfcfd0;
      }
      .tecget-dashboard-center-icon-styling-5 {
        stroke-dasharray: 1.1 12.5;
      }
      .tecget-dashboard-center-icon-styling-6 {
        stroke-width: 2.1px;
      }
      .tecget-dashboard-center-icon-styling-6, .tecget-dashboard-center-icon-styling-7 {
        stroke: #fff;
      }
      .tecget-dashboard-center-icon-styling-7, .tecget-dashboard-center-icon-styling-8 {
        stroke-width: 2.2px;
      }
      .tecget-dashboard-center-icon-styling-8 {
        stroke: #d0d2d3;
      }
      .tecget-dashboard-center-icon-styling-20, .tecget-dashboard-center-icon-styling-52 {
        fill: #6d7478;
      }
      .tecget-dashboard-center-icon-styling-20, .tecget-dashboard-center-icon-styling-23, .tecget-dashboard-center-icon-styling-24 {
        opacity: .4;
      }
      .tecget-dashboard-center-icon-styling-53 {
        clip-path: url(#clippath-1);
      }
      .tecget-dashboard-center-icon-styling-54 {
        clip-path: url(#clippath-3);
      }
      .tecget-dashboard-center-icon-styling-55 {
        clip-path: url(#clippath-4);
      }
      .tecget-dashboard-center-icon-styling-56 {
        clip-path: url(#clippath-2);
      }
      .tecget-dashboard-center-icon-styling-57 {
        clip-path: url(#clippath-5);
      }
      .tecget-dashboard-center-icon-styling-58 {
        fill: #404079;
      }
      .tecget-dashboard-center-icon-styling-59, .tecget-dashboard-center-icon-styling-60, .tecget-dashboard-center-icon-styling-61 {
        fill-opacity: 0;
      }
      .tecget-dashboard-center-icon-styling-59, .tecget-dashboard-center-icon-styling-21 {
        fill: #001230;
      }
      .tecget-dashboard-center-icon-styling-9 {
        stroke-dasharray: 1.3;
        stroke-width: 5.4px;
      }
      .tecget-dashboard-center-icon-styling-62 {
        fill: #adacac;
      }
      .tecget-dashboard-center-icon-styling-63 {
        fill: #1383c4;
      }
      .tecget-dashboard-center-icon-styling-64, .tecget-dashboard-center-icon-styling-60 {
        fill: #fff;
      }
      .tecget-dashboard-center-icon-styling-21, .tecget-dashboard-center-icon-styling-65 {
        opacity: .5;
      }
      .tecget-dashboard-center-icon-styling-66 {
        fill: #767878;
      }
      .tecget-dashboard-center-icon-styling-67 {
        fill: #e8edf3;
      }
      .tecget-dashboard-center-icon-styling-10 {
        stroke: #cb0935;
        stroke-miterlimit: 10;
        stroke-width: 1.3px;
      }
      .tecget-dashboard-center-icon-styling-68 {
        fill: #a4abae;
      }
      .tecget-dashboard-center-icon-styling-69 {
        fill: #cb0935;
      }
      .tecget-dashboard-center-icon-styling-70 {
        fill: #bebec0;
      }
      .tecget-dashboard-center-icon-styling-71 {
        fill: #a6acb0;
      }
      .tecget-dashboard-center-icon-styling-72 {
        fill: #dddedf;
      }
      .tecget-dashboard-center-icon-styling-73 {
        fill: #b9bcbe;
      }
      .tecget-dashboard-center-icon-styling-74 {
        fill: #87ad54;
      }
      .tecget-dashboard-center-icon-styling-75 {
        fill: #cacacb;
      }
      .tecget-dashboard-center-icon-styling-76 {
        fill: #889094;
      }
      .tecget-dashboard-center-icon-styling-77 {
        fill: #cb1237;
      }
      .tecget-dashboard-center-icon-styling-78 {
        fill: #41aa34;
      }
      .tecget-dashboard-center-icon-styling-22 {
        fill: #005a56;
        opacity: .7;
      }
      .tecget-dashboard-center-icon-styling-79 {
        fill: #999fa2;
      }
      .tecget-dashboard-center-icon-styling-80 {
        fill: #888;
      }
      .tecget-dashboard-center-icon-styling-81 {
        fill: #79828c;
      }
      .tecget-dashboard-center-icon-styling-82 {
        clip-path: url(#clippath);
      }
      .tecget-dashboard-center-icon-styling-23 {
        fill: url(#Unbenannter_Verlauf_7);
      }
      .tecget-dashboard-center-icon-styling-24 {
        fill: url(#Unbenannter_Verlauf_8);
      }
      .tecget-dashboard-center-icon-styling-25 {
        fill: #282828;
        opacity: .8;
      }
    </style>
    <clipPath
       id="clippath">
      <path
         class="teecget-dashboard-center-icon-styling-0"
         d="M895.5,607c-.7,4.9-.8,8.6-9.8,9-10.5.5-30.1-3.2-30.7-9,0,0,1-42.6,13.2-71.9,12.2-29.4,11.1-88.1,12.1-99.3s6.1-16.7,6.1-16.7l9.1,8s2,52.3,0,71.5c-2,19.3-6.6,38.7-8.1,60.1-1.3,17.9,8.1,48.3,8.1,48.3h0Z"
         id="path150" />
    </clipPath>
    <linearGradient
       id="Unbenannter_Verlauf"
       data-name="Unbenannter Verlauf"
       x1="575.9"
       y1="457.1"
       x2="825.7"
       y2="457.1"
       gradientUnits="userSpaceOnUse">
      <stop
         offset="0"
         stop-color="#e8e7e7"
         id="stop153" />
      <stop
         offset=".3"
         stop-color="#fff"
         id="stop155" />
      <stop
         offset=".7"
         stop-color="#c5c5c5"
         id="stop157" />
      <stop
         offset="1"
         stop-color="#8f8c8d"
         id="stop159" />
    </linearGradient>
    <linearGradient
       id="Unbenannter_Verlauf_2"
       data-name="Unbenannter Verlauf 2"
       x1="617"
       y1="388.4"
       x2="803.2"
       y2="388.4"
       gradientUnits="userSpaceOnUse">
      <stop
         offset="0"
         stop-color="#626464"
         id="stop162" />
      <stop
         offset="1"
         stop-color="#989898"
         id="stop164" />
    </linearGradient>
    <linearGradient
       id="Unbenannter_Verlauf_3"
       data-name="Unbenannter Verlauf 3"
       x1="-871.7"
       y1="794.1"
       x2="-864.1"
       y2="794.1"
       gradientTransform="matrix(-1,0,0,1,-429.9,0)"
       gradientUnits="userSpaceOnUse">
      <stop
         offset="0"
         stop-color="#d9d9d9"
         id="stop167" />
      <stop
         offset="1"
         stop-color="#9c9b9b"
         id="stop169" />
    </linearGradient>
    <linearGradient
       id="Unbenannter_Verlauf_4"
       data-name="Unbenannter Verlauf 4"
       x1="-792.8"
       y1="834"
       x2="-784.1"
       y2="834"
       gradientTransform="matrix(-1,0,0,1,-429.9,0)"
       gradientUnits="userSpaceOnUse">
      <stop
         offset="0"
         stop-color="#d9d9d9"
         id="stop172" />
      <stop
         offset="1"
         stop-color="#9c9b9b"
         id="stop174" />
    </linearGradient>
    <linearGradient
       id="Unbenannter_Verlauf_5"
       data-name="Unbenannter Verlauf 5"
       x1="-749.9"
       y1="786.4"
       x2="-747.5"
       y2="787.1"
       gradientTransform="matrix(-1,0,0,1,-429.9,0)"
       gradientUnits="userSpaceOnUse">
      <stop
         offset="0"
         stop-color="#fbfbfb"
         id="stop177" />
      <stop
         offset="1"
         stop-color="#a4aebb"
         id="stop179" />
    </linearGradient>
    <linearGradient
       id="Unbenannter_Verlauf_6"
       data-name="Unbenannter Verlauf 6"
       x1="-772.9"
       y1="696.1"
       x2="-778"
       y2="784.3"
       gradientTransform="matrix(-1,0,0,1,-429.9,0)"
       gradientUnits="userSpaceOnUse">
      <stop
         offset="0"
         stop-color="#fbfbfb"
         id="stop182" />
      <stop
         offset="1"
         stop-color="#fff"
         stop-opacity="0"
         id="stop184" />
    </linearGradient>
    <linearGradient
       id="Unbenannter_Verlauf_7"
       data-name="Unbenannter Verlauf 7"
       x1="-798.3"
       y1="815.6"
       x2="-778.8"
       y2="806.5"
       gradientTransform="matrix(-1,0,0,1,-429.9,0)"
       gradientUnits="userSpaceOnUse">
      <stop
         offset="0"
         stop-color="#fbfbfb"
         id="stop187" />
      <stop
         offset="1"
         stop-color="#fff"
         stop-opacity="0"
         id="stop189" />
    </linearGradient>
    <linearGradient
       id="Unbenannter_Verlauf_8"
       data-name="Unbenannter Verlauf 8"
       x1="-847.1"
       y1="787.9"
       x2="-825.8"
       y2="770.3"
       gradientTransform="matrix(-1,0,0,1,-429.9,0)"
       gradientUnits="userSpaceOnUse">
      <stop
         offset="0"
         stop-color="#fbfbfb"
         id="stop192" />
      <stop
         offset="1"
         stop-color="#fff"
         stop-opacity="0"
         id="stop194" />
    </linearGradient>
    <clipPath
       id="clippath-1">
      <polygon
         class="teecget-dashboard-center-icon-styling-0"
         points="423.4 576.9 423.4 688.6 486.8 691.5 486.8 541 423.4 576.9"
         id="polygon197" />
    </clipPath>
    <clipPath
       id="clippath-2">
      <path
         class="teecget-dashboard-center-icon-styling-0"
         d="M176.5,697.4c3.5,1,8.4,2.5,8.4,12.5s.3,6.8.8,12.6c.2,3,.5,9,.3,10.1-.8,6.8-.5,16.7-.5,16.7-.1,1.7-5.6,2-5.5-1.9,0-1.9-2.9-5-3-5.9,0-1.1.3-6.1.3-6.1l.9-3.7v-5.7l1-13.5-2.7-15.2h0Z"
         id="path200" />
    </clipPath>
    <clipPath
       id="clippath-3">
      <path
         class="teecget-dashboard-center-icon-styling-0"
         d="M163.3,821.5s-1.1-.3-2.8-.2c-1.7.2-5.1,2-5.9,1.7-.8-.3-2-1.4-2-1.4,0,0-1.1-13-1.1-15.5s-.8-12.5-.6-14.6c.2-2,.5-4.3.3-5.6s.3-20.4-.2-23.7-.6-8.7-.4-13.2c.2-4.5,2.3-10.3,2.3-10.3,0,0,2.2,3.2,6.5,3.4s13.2.5,16.3-.6,3.6-2.8,3.6-2.8c0,0,2.6,13.2,2.8,15.5s-1.4,25.1-1.5,28c-.2,2.9-1.5,6-1.4,8.1.2,2-1.2,17.5-1.2,19.2s1.5,2.5,1.4,3.7c-.2,1.2.3,3.9-2,3.9s-4.2,2.2-5.6,2.3-3.3-.8-3.3-.8c0,0,.2-2.5.6-4.5.5-2,.3-4,.5-5,.2-.9-1.1-13.5-1.1-16.6s.8-6.5.5-7.7-1.5-18.6-1.5-18.6c0,0-4.3,19.7-4.5,21.8-.2,2.2-1.1,4.8-.8,6.8s-.7,22.5-.3,22.6c.4.2,1.6,3.9,1.6,3.9l-.2.2h0Z"
         id="path203" />
    </clipPath>
    <clipPath
       id="clippath-4">
      <path
         class="teecget-dashboard-center-icon-styling-0"
         d="M148.5,714.3c-.6-3.7-2.5-11.6-.9-13.3,1.5-1.7,7.1-3.5,7.1-3.5l2.4-3.5,2.5-.4h2.2l4.7.8,3.4.7,2.3-.7,2.6,2.4,6.3,2.7s-1.7,7.2-.7,10.7c.9,3.6,0,10.8-.8,12.4-.8,1.5,1,3.2.7,5.7s-.3,4.5.5,6-1.1,2.8-1.4,4.5c0,0,.3.8-2.4,2.6-2.6,1.9-6.7,1.8-11.6,1.8s-12.7-2.7-12.7-2.7c0,0-1.4-2.5-1.4-3.3s.4-2.2.9-2.2c-.4-.5-.9-1.5-.9-2.2,0-1.2,1.2-1.9,1.1-5.9-.2-4-3.3-9-3.9-12.7h0Z"
         id="path206" />
    </clipPath>
    <clipPath
       id="clippath-5">
      <path
         class="teecget-dashboard-center-icon-styling-0"
         d="M147.5,700.9s-1.8,1.1-2.9,3.4c-2.9,6-3.3,12.9-3.6,15-.3,2.2-1.8,9.2-1.9,11.4,0,1.5-.3,3.6-.2,4.1,1,2.7,3.1,4.8,9.3,4.5s9.5-3.3,11.1-3.6c1.5-.3,4.1-2.3,4.1-2.3-1.7-1.9-3.9-4.4-1.1-6.4h-2.2l-10.4,1.2s1.9-2.3,2.2-5.6-.2-12.7-.6-13.8c-.5-1.1-3.7-8.1-3.7-8.1v.2h-.1Z"
         id="path209" />
    </clipPath>
  </defs>
  <g
     id="g16188">
    <g
       id="g302"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none">
      <g
         id="g220"
         style="stroke:none">
        <path
           class="tecget-dashboard-center-icon-styling-15"
           d="m 973.1,611.8 c 0,14 -34.6,25.4 -77.3,25.4 -42.7,0 -77.3,-11.4 -77.3,-25.4 0,-14 34.6,-25.4 77.3,-25.4 42.7,0 77.3,11.4 77.3,25.4 z"
           id="path216"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-18"
           d="m 913.2,609.8 c 0,5.7 -15.8,10.4 -35.4,10.4 -19.6,0 -35.4,-4.6 -35.4,-10.4 0,-5.8 15.8,-10.4 35.4,-10.4 19.6,0 35.4,4.6 35.4,10.4 z"
           id="path218"
           style="stroke:none" />
      </g>
      <g
         id="g234"
         style="stroke:none">
        <path
           class="tecget-dashboard-center-icon-styling-39"
           d="m 895.5,607 c -0.7,4.9 -0.8,8.6 -9.8,9 -10.5,0.5 -30.1,-3.2 -30.7,-9 0,0 1,-42.6 13.2,-71.9 12.2,-29.4 11.1,-88.1 12.1,-99.3 1,-11.2 6.1,-16.7 6.1,-16.7 l 9.1,8 c 0,0 2,52.3 0,71.5 -2,19.3 -6.6,38.7 -8.1,60.1 -1.3,17.9 8.1,48.3 8.1,48.3 z"
           id="path222"
           style="stroke:none" />
        <g
           class="tecget-dashboard-center-icon-styling-82"
           clip-path="url(#clippath)"
           id="g232"
           style="stroke:none">
          <g
             id="g230"
             style="stroke:none">
            <path
               class="tecget-dashboard-center-icon-styling-40"
               d="m 884,618.4 c 0,0 -11.8,-37.6 -6.5,-54.3 5.3,-16.7 13.7,-75.2 13.7,-85.1 0,-9.9 1.5,-35 -3,-38.8 -4.6,-3.8 -9.1,6.8 -9.1,6.8 0,0 -6.8,-39.5 -4.6,-39.5 2.2,0 49.4,4.6 49.4,4.6 l -20.5,177.8 0.8,22 -20.1,6.5 z"
               id="path224"
               style="stroke:none" />
            <path
               class="tecget-dashboard-center-icon-styling-45"
               d="m 858.6,557.6 c 0,0 10.6,-3.9 12.3,-1.4 1.8,2.5 0.4,3.2 3.9,8.8 3.5,5.6 15.5,5.3 16.6,4.6 1.1,-0.7 13.4,-0.4 10.9,-4.2 -2.5,-3.9 1.1,-36.7 -5.3,-37.4 -6.3,-0.7 -33.9,-2.8 -33.9,-1.8 0,1 -4.6,31.4 -4.6,31.4 v 0 z"
               id="path226"
               style="stroke:none" />
            <path
               class="tecget-dashboard-center-icon-styling-40"
               d="m 863.6,617.4 c 0,0 -1,-20.6 0,-30.6 1,-10 5,-11 4.6,-18 -0.4,-7 -3.5,-13.8 -3.5,-13.8 0,0 -2.3,8.1 -3.5,14.1 -1.2,6 -1.6,16.2 -2,22.6 -0.4,6.4 0,22.4 0,22.4 l 4.5,3.1 v 0.2 0 z"
               id="path228"
               style="stroke:none" />
          </g>
        </g>
      </g>
      <g
         id="g268"
         style="stroke:none">
        <path
           class="tecget-dashboard-center-icon-styling-78"
           d="m 970.6,516.2 c 9.3,-6.9 15.4,-18 15.4,-30.5 0,-12.5 -7.2,-25.6 -18,-32.3 -0.4,-25.9 -20.6,-47.1 -46.2,-47.9 -6.1,-0.2 -11.9,0.9 -17.3,2.9 -1.5,-24.9 -21.3,-44.9 -46.1,-45.6 -26.3,-0.7 -48.2,20.5 -48.9,47.4 -0.3,11 3,21.3 8.8,29.6 v 0.2 c -22.6,3.2 -40.4,22.7 -41,46.9 0,3.7 0.2,7.2 0.9,10.7 -4.8,7.4 -4.1,17.5 2.3,24.3 3.4,3.7 7.9,5.8 12.4,6.3 2.3,18.8 18.1,33.3 37.4,33.3 19.3,0 31.6,-11.6 36.2,-27.4 8.1,2.7 17.3,1.9 25.2,-2.9 8.1,7.6 18.8,12.4 30.7,12.7 8.2,0.2 15.9,-1.7 22.7,-5.2 3.1,3.8 7.8,6.2 13.1,6.2 9.4,0 17.1,-7.7 17.1,-17.1 0,-9.4 -1.8,-8.6 -4.6,-11.7 h -0.1 z"
           id="path236"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 851.1,377.2 c 21.9,-5 30.7,-0.6 44.9,6.4 -8.3,-12.2 -22,-20.3 -37.6,-20.8 -26.3,-0.7 -48.2,20.5 -48.9,47.4 -0.3,11 3,21.3 8.8,29.6 v 0.2 c -22.6,3.2 -40.4,22.7 -41,46.9 0,2.4 0,4.7 0.3,7 4.1,-9.2 23.4,-43.2 51,-36.9 16.8,3.8 20.4,3.2 29.5,-2.8 3.3,-2.2 0,-3.5 -13.8,-7.8 -30.3,-9.4 -34.5,-59.7 6.9,-69.1 h -0.1 z"
           id="path238"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 884.4,417.4 c -5,6.9 0.7,7.4 14.1,3.8 7.8,-2.1 22.6,-5.4 36,-4.4 4.9,0.4 16.4,3 19.7,3.1 -8.3,-8.6 -19.7,-14 -32.4,-14.4 -6.1,-0.2 -11.9,0.9 -17.3,2.9 0,0 -15.1,2.1 -20.1,9 z"
           id="path240"
           style="stroke:none" />
        <g
           class="tecget-dashboard-center-icon-styling-65"
           id="g254"
           style="stroke:none">
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 985.9,485.6 c 0,-13.7 -7.2,-25.6 -18,-32.3 0,-4.5 -0.8,-8.8 -1.9,-12.9 -2.4,3.9 -6.1,7.9 -11.9,9.6 -13.2,4 -5,10.9 -5,10.9 0,0 -8,-19.4 -36.9,-2 -12.2,7.4 -16.7,18.2 -32,14.6 -18.2,-4.3 -21.1,4.3 -21.5,12.8 -0.5,8.5 2.9,33.1 -30.2,42.1 -15.7,4.3 -31.6,-11.3 -31.6,-11.3 0,0 -2.3,0.9 -11.1,1.1 h -8 c 0.7,1.3 1.6,2.5 2.6,3.6 3.4,3.7 7.9,5.8 12.4,6.3 2.3,18.8 18.1,33.3 37.4,33.3 19.3,0 31.6,-11.6 36.2,-27.4 8.1,2.7 17.3,1.9 25.2,-2.9 8.1,7.6 18.8,12.4 30.7,12.7 8.2,0.2 15.9,-1.7 22.7,-5.2 3.1,3.8 7.8,6.2 13.1,6.2 9.4,0 17.1,-7.7 17.1,-17.1 0,-9.4 -1.8,-8.6 -4.6,-11.7 9.3,-6.9 15.4,-18 15.4,-30.5 h -0.1 z"
             id="path242"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 944.8,491.3 c 0,5.7 -4.6,10.3 -10.3,10.3 -5.7,0 -10.3,-4.6 -10.3,-10.3 0,-5.7 4.6,-10.3 10.3,-10.3 5.7,0 10.3,4.6 10.3,10.3 z"
             id="path244"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 923.8,501.6 c 0,3.6 -2.9,6.5 -6.5,6.5 -3.6,0 -6.5,-2.9 -6.5,-6.5 0,-3.6 2.9,-6.5 6.5,-6.5 3.6,0 6.5,2.9 6.5,6.5 z"
             id="path246"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 820.5,512.5 c 0,3.6 -2.9,6.5 -6.5,6.5 -3.6,0 -6.5,-2.9 -6.5,-6.5 0,-3.6 2.9,-6.5 6.5,-6.5 3.6,0 6.5,2.9 6.5,6.5 z"
             id="path248"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 941,474.7 c 0,2.7 -2.1,4.8 -4.8,4.8 -2.7,0 -4.8,-2.2 -4.8,-4.8 0,-2.6 2.1,-4.8 4.8,-4.8 2.7,0 4.8,2.2 4.8,4.8 z"
             id="path250"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 830.1,501 c 0,2.6 -2.2,4.8 -4.8,4.8 -2.6,0 -4.8,-2.2 -4.8,-4.8 0,-2.6 2.1,-4.8 4.8,-4.8 2.7,0 4.8,2.2 4.8,4.8 z"
             id="path252"
             style="stroke:none" />
        </g>
        <path
           class="tecget-dashboard-center-icon-styling-74"
           d="m 960.7,523.6 c 0,3.6 -2.9,6.5 -6.5,6.5 -3.6,0 -6.5,-2.9 -6.5,-6.5 0,-3.6 2.9,-6.5 6.5,-6.5 3.6,0 6.5,2.9 6.5,6.5 z"
           id="path256"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-74"
           d="m 966.7,513 c 0,2.3 -1.9,4.2 -4.2,4.2 -2.3,0 -4.2,-1.9 -4.2,-4.2 0,-2.3 1.9,-4.2 4.2,-4.2 2.3,0 4.2,1.9 4.2,4.2 z"
           id="path258"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 846.2,398.9 c 0,3.6 -2.9,6.5 -6.5,6.5 -3.6,0 -6.5,-2.9 -6.5,-6.5 0,-3.6 2.9,-6.5 6.5,-6.5 3.6,0 6.5,2.9 6.5,6.5 z"
           id="path260"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 828.8,469.9 c 0,5.9 -4.8,10.7 -10.7,10.7 -5.9,0 -10.7,-4.8 -10.7,-10.7 0,-5.9 4.8,-10.7 10.7,-10.7 5.9,0 10.7,4.8 10.7,10.7 z"
           id="path262"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 849.7,387.1 c 0,1.7 -1.4,3.1 -3.1,3.1 -1.7,0 -3.1,-1.4 -3.1,-3.1 0,-1.7 1.4,-3.1 3.1,-3.1 1.7,0 3.1,1.4 3.1,3.1 z"
           id="path264"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 883.5,428.3 c 0,1.7 -1.4,3.1 -3.1,3.1 -1.7,0 -3.1,-1.4 -3.1,-3.1 0,-1.7 1.4,-3.1 3.1,-3.1 1.7,0 3.1,1.4 3.1,3.1 z"
           id="path266"
           style="stroke:none" />
      </g>
      <g
         id="g300"
         style="stroke:none">
        <path
           class="tecget-dashboard-center-icon-styling-78"
           d="m 985.4,493 c -5.1,-2 -10.8,-0.6 -14.5,3.2 -6.3,-8.4 -16.9,-12.4 -26.9,-9.9 1.3,-5.4 1,-11.3 -1.4,-16.8 -5.7,-13.5 -21.1,-19.9 -34.2,-14.3 -12.4,5.3 -18.5,19.4 -14.3,32.3 -3.1,0 -6.3,0.7 -9.3,2 -13.2,5.6 -19.2,21.1 -13.5,34.6 1.2,2.8 2.8,5.2 4.6,7.3 -0.6,4.6 0,9.5 1.9,14.1 5.7,13.5 21.1,19.9 34.2,14.3 4.1,-1.8 7.6,-4.5 10.1,-7.9 0.3,0 0.5,0.3 0.8,0.4 8.4,3.3 17.8,-0.9 21.1,-9.4 0.7,-1.6 1,-3.3 1.1,-5 5,1.1 10.4,0.8 15.5,-1.4 3,-1.3 5.6,-3.1 7.8,-5.2 1.1,1.5 2.5,2.8 4.4,3.5 5,2 10.8,-0.6 12.8,-5.7 1.4,-3.5 0.7,-7.3 -1.5,-10 3.8,-1.2 7.1,-4.1 8.7,-8.2 2.8,-7.1 -0.6,-15 -7.5,-17.7 V 493 Z"
           id="path270"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 922.3,467 c 1,2.5 -0.2,5.3 -2.7,6.2 -2.5,1 -5.3,-0.2 -6.3,-2.7 -1,-2.5 0.2,-5.3 2.7,-6.3 2.5,-1 5.3,0.2 6.3,2.7 v 0 z"
           id="path272"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 910.9,469 c 0.5,1.2 0,2.5 -1.3,2.9 -1.2,0.5 -2.5,-0.1 -2.9,-1.3 -0.5,-1.2 0,-2.5 1.3,-2.9 1.2,-0.5 2.5,0.1 2.9,1.3 z"
           id="path274"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 978.9,497.1 c 0.5,1.2 0,2.5 -1.3,2.9 -1.2,0.5 -2.5,-0.1 -2.9,-1.3 -0.5,-1.2 0,-2.5 1.3,-2.9 1.2,-0.5 2.5,0.1 2.9,1.3 z"
           id="path276"
           style="stroke:none" />
        <g
           class="tecget-dashboard-center-icon-styling-65"
           id="g290"
           style="stroke:none">
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 912,559.6 c 4.1,-1.8 7.6,-4.5 10.1,-7.9 0.3,0 0.5,0.3 0.8,0.4 8.4,3.3 17.8,-0.9 21.1,-9.4 0.7,-1.6 1,-3.3 1.1,-5 5,1.1 10.4,0.8 15.5,-1.4 3,-1.3 5.6,-3.1 7.8,-5.2 1.1,1.5 2.5,2.8 4.4,3.5 5,2 10.8,-0.6 12.8,-5.7 1.4,-3.5 0.7,-7.3 -1.5,-10 3.8,-1.2 7.1,-4.1 8.7,-8.2 2.4,-6.1 0.3,-12.8 -4.8,-16.3 0,4.4 -0.5,10 -2.1,12.9 -2.9,5.3 -10.8,-0.9 -16.9,-3.5 -6.1,-2.6 -6.2,2.9 -11.1,8.4 -4.8,5.4 -12.9,2.3 -23.2,3 -10.3,0.7 -21.1,19.9 -25.6,23.6 -4.5,3.8 -10.4,11.5 -21.6,10.9 -3.6,-0.2 -6.5,-1.2 -9,-2.5 6.3,12.2 20.8,17.7 33.3,12.4 z"
             id="path278"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 952.8,506.3 c 1.1,2.9 -0.3,6.1 -3.1,7.2 -2.9,1.1 -6.1,-0.3 -7.2,-3.1 -1.1,-2.8 0.3,-6.1 3.1,-7.2 2.9,-1.1 6.1,0.3 7.2,3.1 z"
             id="path280"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 892,523.4 c 0.9,2.4 -0.2,5.1 -2.6,6.1 -2.4,0.9 -5.1,-0.2 -6,-2.6 -0.9,-2.4 0.2,-5.1 2.6,-6.1 2.4,-0.9 5.1,0.2 6,2.6 z"
             id="path282"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 958.5,502.3 c 0.5,1.3 0,2.8 -1.4,3.3 -1.3,0.5 -2.8,-0.1 -3.3,-1.4 -0.5,-1.3 0,-2.8 1.4,-3.3 1.3,-0.5 2.8,0.1 3.3,1.4 z"
             id="path284"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 881.1,527.2 c 0.5,1.3 0,2.8 -1.4,3.3 -1.3,0.5 -2.8,0 -3.3,-1.4 -0.5,-1.3 0,-2.8 1.4,-3.3 1.3,-0.5 2.8,0 3.3,1.4 z"
             id="path286"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 891.7,515.4 c 0.5,1.3 0,2.8 -1.5,3.4 -1.3,0.5 -2.9,0 -3.4,-1.5 -0.5,-1.3 0,-2.8 1.5,-3.4 1.3,-0.5 2.8,0 3.4,1.5 z"
             id="path288"
             style="stroke:none" />
        </g>
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 908.3,455.1 c -12.4,5.3 -18.5,19.4 -14.3,32.3 -3.1,0 -6.3,0.7 -9.3,2 -9.2,3.9 -14.8,12.6 -15.5,22 7.4,-11.8 24.5,-16 33.1,-17.4 0.7,-0.1 1.2,-0.7 1.4,-1.3 0,-0.7 -0.2,-1.4 -0.8,-1.7 l -3.6,-1.9 c -1.1,-0.6 -1.7,-1.8 -1.5,-3 1.2,-7.2 7.2,-30.5 35.1,-28.5 -7.1,-4.7 -16.2,-5.9 -24.4,-2.4 h -0.2 z"
           id="path292"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 944,486.1 c -12.7,6.7 -19.3,17.8 -19.3,17.8 0,0 13.6,-10.4 27.9,-14.4 2,-0.6 5.5,-1 9.1,-1.1 -5.4,-2.7 -11.6,-3.6 -17.7,-2.1 v 0 z"
           id="path294"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-22"
           d="m 931,530.3 c 1,2.5 -0.2,5.3 -2.7,6.3 -2.5,1 -5.3,-0.3 -6.3,-2.7 -1,-2.5 0.3,-5.3 2.7,-6.2 2.5,-1 5.3,0.2 6.2,2.7 v 0 z"
           id="path296"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-22"
           d="m 929.4,522.2 c 0.5,1.2 0,2.5 -1.3,2.9 -1.2,0.5 -2.5,0 -2.9,-1.3 -0.5,-1.2 0,-2.5 1.3,-2.9 1.2,-0.5 2.5,0 2.9,1.3 z"
           id="path298"
           style="stroke:none" />
      </g>
    </g>
    <g
       id="g324"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate">
      <g
         id="g310">
        <line
           class="tecget-dashboard-center-icon-styling-2"
           x1="127.8"
           y1="550.79999"
           x2="127.8"
           y2="550.09998"
           id="line304" />
        <line
           class="tecget-dashboard-center-icon-styling-5"
           x1="127.8"
           y1="537.59998"
           x2="127.8"
           y2="530.20001"
           id="line306" />
        <line
           class="tecget-dashboard-center-icon-styling-2"
           x1="127.8"
           y1="524"
           x2="127.8"
           y2="523.29999"
           id="line308" />
      </g>
      <g
         id="g318">
        <line
           class="tecget-dashboard-center-icon-styling-2"
           x1="127.8"
           y1="640.20001"
           x2="127.8"
           y2="639.5"
           id="line312" />
        <line
           class="tecget-dashboard-center-icon-styling-5"
           x1="127.8"
           y1="627"
           x2="127.8"
           y2="619.59998"
           id="line314" />
        <line
           class="tecget-dashboard-center-icon-styling-2"
           x1="127.8"
           y1="613.40002"
           x2="127.8"
           y2="612.70001"
           id="line316" />
      </g>
      <polyline
         class="tecget-dashboard-center-icon-styling-9"
         points="114.7 517.9 127.8 500.8 140.9 517.9"
         id="polyline320" />
      <polyline
         class="tecget-dashboard-center-icon-styling-9"
         points="140.9 646.9 127.8 664 114.8 647"
         id="polyline322" />
    </g>
    <g
       id="g344"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none">
      <path
         class="tecget-dashboard-center-icon-styling-52"
         d="m 64.5,582.6 c 0,1.5 0,2.7 -0.4,3.8 -0.2,1 -0.7,1.9 -1.3,2.5 -0.6,0.6 -1.4,1.1 -2.3,1.4 -1,0.3 -2.2,0.5 -3.6,0.5 -1.4,0 -1.8,0 -2.5,-0.3 -0.7,-0.3 -1.2,-0.5 -1.6,-0.9 v 6.3 h -4.2 v -15 c 0,-1.5 0.2,-2.8 0.5,-3.8 0.3,-1 0.8,-1.8 1.4,-2.5 0.6,-0.6 1.5,-1.1 2.5,-1.3 1,-0.2 2.2,-0.4 3.7,-0.4 1.5,0 2.6,0 3.6,0.4 1,0.3 1.8,0.7 2.4,1.3 0.6,0.6 1.1,1.5 1.4,2.5 0.3,1 0.4,2.4 0.4,3.9 v 1.5 0 z m -8,4.8 c 0.8,0 1.4,0 1.9,-0.2 0.5,-0.2 0.9,-0.3 1.1,-0.7 0.3,-0.3 0.5,-0.8 0.6,-1.4 0.1,-0.6 0,-1.4 0,-2.4 v -1.6 c 0,-1 0,-1.9 -0.2,-2.5 0,-0.6 -0.3,-1.1 -0.6,-1.4 -0.3,-0.3 -0.6,-0.6 -1.1,-0.7 -0.5,0 -1.1,-0.2 -1.9,-0.2 -0.8,0 -1.4,0 -1.8,0.2 -0.5,0 -0.9,0.3 -1.1,0.6 -0.3,0.3 -0.5,0.8 -0.6,1.4 0,0.6 -0.2,1.4 -0.2,2.4 v 2.3 c 0,0.8 0,1.5 0.2,2.1 0,0.6 0.3,1 0.6,1.3 0.3,0.3 0.7,0.5 1.1,0.6 0.5,0 1.1,0.2 1.8,0.2 z"
         id="path326"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-52"
         d="m 76.3,572.9 c 1.4,0 2.7,0 3.7,0.4 1,0.3 1.8,0.7 2.5,1.3 0.6,0.6 1.1,1.4 1.4,2.5 0.3,1 0.4,2.3 0.4,3.9 v 1.7 c 0,1.6 0,2.8 -0.4,3.9 -0.3,1 -0.8,1.9 -1.4,2.5 -0.6,0.6 -1.5,1.1 -2.5,1.3 -1,0.3 -2.2,0.4 -3.7,0.4 -1.5,0 -2.7,0 -3.7,-0.4 -1,-0.3 -1.8,-0.7 -2.5,-1.3 -0.7,-0.6 -1.1,-1.4 -1.4,-2.5 -0.3,-1.1 -0.4,-2.3 -0.4,-3.9 V 581 c 0,-1.6 0,-2.8 0.4,-3.9 0.3,-1 0.8,-1.9 1.4,-2.5 0.6,-0.6 1.5,-1.1 2.5,-1.3 1,-0.3 2.3,-0.4 3.7,-0.4 z m 3.8,8 c 0,-1 0,-1.8 -0.2,-2.4 0,-0.6 -0.3,-1.1 -0.6,-1.4 -0.3,-0.3 -0.6,-0.5 -1.1,-0.6 -0.5,-0.1 -1.1,-0.2 -1.9,-0.2 -0.8,0 -1.4,0 -1.9,0.2 -0.5,0 -0.9,0.3 -1.1,0.6 -0.3,0.3 -0.5,0.8 -0.6,1.4 -0.1,0.6 -0.2,1.4 -0.2,2.4 v 1.9 c 0,1 0,1.8 0.2,2.4 0,0.6 0.3,1.1 0.6,1.4 0.3,0.3 0.7,0.5 1.1,0.6 0.5,0 1.1,0.2 1.9,0.2 0.8,0 1.4,0 1.9,-0.2 0.5,-0.2 0.9,-0.3 1.1,-0.6 0.2,-0.3 0.5,-0.8 0.6,-1.4 0,-0.6 0.2,-1.4 0.2,-2.4 z"
         id="path328"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-52"
         d="m 103.8,585.9 3.1,-12.5 h 4 l -5,16.8 h -4.2 l -2.9,-11.7 -3,11.7 h -4.3 l -4.9,-16.8 h 4.2 l 2.9,12.4 3.2,-12.4 h 3.8 l 3,12.5 z"
         id="path330"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-52"
         d="m 117.3,583.2 v 1.9 c 0,0.5 0.3,0.9 0.5,1.2 0.3,0.3 0.6,0.5 1.1,0.6 0.5,0.1 1.1,0.2 1.9,0.2 h 6.2 l -0.6,3.2 h -5.7 c -1.5,0 -2.8,-0.2 -3.8,-0.5 -1,-0.3 -1.8,-0.8 -2.3,-1.5 -0.6,-0.6 -1,-1.4 -1.2,-2.4 -0.2,-1 -0.3,-2 -0.3,-3.2 v -1.8 c 0,-1.3 0,-2.4 0.4,-3.4 0.2,-1 0.7,-1.8 1.2,-2.5 0.6,-0.7 1.4,-1.2 2.4,-1.5 1,-0.3 2.3,-0.5 3.8,-0.5 1.5,0 2.6,0.2 3.5,0.5 0.9,0.3 1.7,0.7 2.3,1.3 0.6,0.6 1,1.2 1.2,2 0.2,0.8 0.4,1.6 0.4,2.5 v 0.6 c 0,0.7 0,1.3 -0.1,1.8 0,0.5 -0.2,0.8 -0.4,1.1 -0.2,0.3 -0.5,0.4 -0.8,0.5 h -9.6 l -0.2,-0.2 h 0.1 z m 3.5,-7.1 c -0.7,0 -1.3,0 -1.8,0.2 -0.5,0 -0.8,0.3 -1.1,0.6 -0.3,0.3 -0.4,0.7 -0.5,1.3 v 2 h 7 v -0.7 c 0,-0.6 0,-1.2 -0.2,-1.6 0,-0.4 -0.3,-0.8 -0.5,-1 -0.3,-0.3 -0.6,-0.4 -1.1,-0.6 -0.5,0 -1,-0.2 -1.7,-0.2 z"
         id="path332"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-52"
         d="m 136.4,590.2 h -4.2 v -11.1 c 0,-1.1 0.2,-2 0.5,-2.7 0.3,-0.7 0.7,-1.3 1.3,-1.8 0.6,-0.5 1.3,-0.8 2.1,-1 0.8,-0.2 1.8,-0.3 2.9,-0.3 h 3.8 l -0.7,3.5 h -2.7 c -0.7,0 -1.2,0 -1.6,0.2 -0.4,0.2 -0.7,0.3 -0.9,0.6 -0.2,0.2 -0.4,0.6 -0.4,0.9 v 11.7 z"
         id="path334"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-52"
         d="m 153.1,566.1 h 2.1 l -0.4,1.7 h -1.6 c -1,0 -1.8,0 -2.5,0.2 -0.7,0 -1.2,0.4 -1.6,0.8 -0.4,0.4 -0.7,1 -0.8,1.8 -0.2,0.8 -0.2,1.8 -0.2,3 h 6.2 l -0.4,1.6 H 148 v 15 h -1.9 v -16.8 c 0,-1.4 0.1,-2.5 0.4,-3.4 0.2,-0.9 0.6,-1.7 1.2,-2.2 0.6,-0.6 1.3,-1 2.1,-1.2 0.9,-0.2 1.9,-0.4 3.2,-0.4 v 0 z m 3.6,0.1 h 1.9 v 24 h -1.9 z"
         id="path336"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-52"
         d="m 170.9,573.1 c 1.3,0 2.4,0 3.3,0.4 0.9,0.2 1.7,0.7 2.3,1.2 0.6,0.6 1,1.4 1.3,2.3 0.3,1 0.4,2.2 0.4,3.6 v 2.5 c 0,1.4 -0.1,2.7 -0.4,3.6 -0.3,1 -0.7,1.8 -1.3,2.3 -0.6,0.6 -1.4,1 -2.3,1.3 -0.9,0.2 -2,0.4 -3.3,0.4 -1.3,0 -2.4,0 -3.3,-0.4 -0.9,-0.2 -1.7,-0.7 -2.3,-1.3 -0.6,-0.6 -1,-1.4 -1.3,-2.3 -0.3,-1 -0.4,-2.2 -0.4,-3.6 v -2.5 c 0,-1.4 0.1,-2.7 0.4,-3.6 0.3,-1 0.7,-1.7 1.3,-2.3 0.6,-0.6 1.4,-1 2.3,-1.3 0.9,-0.2 2,-0.4 3.3,-0.4 v 0 z m 5.4,7.6 c 0,-1.2 0,-2.2 -0.3,-2.9 -0.3,-0.7 -0.5,-1.4 -0.9,-1.8 -0.4,-0.4 -1,-0.7 -1.7,-0.9 -0.7,-0.2 -1.5,-0.3 -2.5,-0.3 -1,0 -1.8,0 -2.5,0.2 -0.7,0.2 -1.2,0.5 -1.7,0.9 -0.4,0.4 -0.7,1 -0.9,1.8 -0.2,0.8 -0.3,1.8 -0.3,3 v 2.5 c 0,1.2 0,2.2 0.3,3 0.2,0.8 0.5,1.4 0.9,1.8 0.4,0.4 1,0.7 1.7,0.9 0.7,0.2 1.5,0.3 2.5,0.3 1,0 1.8,0 2.5,-0.2 0.7,-0.2 1.2,-0.5 1.7,-0.9 0.4,-0.4 0.7,-1 0.9,-1.8 0.2,-0.8 0.3,-1.8 0.3,-3 v -2.5 0 z"
         id="path338"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-52"
         d="m 192.3,576 -4.1,14.2 h -2 l -5,-16.6 h 1.9 l 4.1,14.5 4.2,-14.5 h 1.9 l 4.1,14.6 4.2,-14.6 h 1.8 l -5,16.6 h -2 z"
         id="path340"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-69"
         d="m 212.1,571.8 h 3 v 2.5 h -3 v 3.1 h -2.7 v -3.1 h -3 v -2.5 h 3 v -3.1 h 2.7 z"
         id="path342"
         style="stroke:none" />
    </g>
    <g
       id="g350"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none">
      <path
         class="tecget-dashboard-center-icon-styling-78"
         d="m 93.5,337.1 v 0 l 15.6,-9 c 2.6,-1.2 5.9,-0.9 9.5,1.1 l 31.1,17.9 c 8.6,5 15.5,18.2 15.5,29.7 v 65.5 c 0,5.8 -1.8,10 -4.7,12.1 l -15.7,9.1 v 0 c -2.8,1.9 -6.5,1.9 -10.7,-0.5 L 103,445.1 c -8.6,-5 -15.5,-18.2 -15.5,-29.7 v -65.5 c 0,-6.7 2.4,-11.2 6,-12.9 v 0 z"
         id="path346"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-47"
         d="M 132.8,359.8 104.3,343.3 C 96.4,338.8 90,343.6 90,354.1 v 60.2 c 0,10.5 6.4,22.7 14.3,27.3 l 28.5,16.5 c 7.9,4.5 14.3,-0.3 14.3,-10.8 v -60.2 c 0,-10.5 -6.4,-22.7 -14.3,-27.3 z"
         id="path348"
         style="stroke:none" />
    </g>
    <g
       id="g378"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate">
      <g
         id="g362">
        <polygon
           class="tecget-dashboard-center-icon-styling-6"
           points="707.3,173.8 751.7,173.8 759.4,207.9 699.7,207.9 "
           id="polygon352" />
        <line
           class="tecget-dashboard-center-icon-styling-6"
           x1="722.09998"
           y1="173.8"
           x2="719.59998"
           y2="207.89999"
           id="line354" />
        <line
           class="tecget-dashboard-center-icon-styling-6"
           x1="736.90002"
           y1="173.8"
           x2="739.5"
           y2="207.89999"
           id="line356" />
        <polyline
           class="tecget-dashboard-center-icon-styling-6"
           points="704.8 185.2 721.3 185.2 737.8 185.2 754.3 185.2"
           id="polyline358" />
        <polyline
           class="tecget-dashboard-center-icon-styling-6"
           points="702.2 196.5 720.4 196.5 738.7 196.5 756.9 196.5"
           id="polyline360" />
      </g>
      <g
         id="g374">
        <line
           class="tecget-dashboard-center-icon-styling-6"
           x1="729.5"
           y1="152.7"
           x2="729.5"
           y2="155.89999"
           id="line364" />
        <line
           class="tecget-dashboard-center-icon-styling-6"
           x1="744.90002"
           y1="168.10001"
           x2="741.70001"
           y2="168.10001"
           id="line366" />
        <line
           class="tecget-dashboard-center-icon-styling-6"
           x1="717.29999"
           y1="168.10001"
           x2="714.20001"
           y2="168.10001"
           id="line368" />
        <line
           class="tecget-dashboard-center-icon-styling-6"
           x1="740.40002"
           y1="157.2"
           x2="738.20001"
           y2="159.5"
           id="line370" />
        <line
           class="tecget-dashboard-center-icon-styling-6"
           x1="720.90002"
           y1="159.5"
           x2="718.70001"
           y2="157.2"
           id="line372" />
      </g>
      <path
         class="tecget-dashboard-center-icon-styling-6"
         d="m 722.3,167.7 c 0,-4 3.2,-7.2 7.2,-7.2 4,0 7.2,3.2 7.2,7.2"
         id="path376" />
    </g>
    <polygon
       class="tecget-dashboard-center-icon-styling-29"
       points="825.7,443.9 704.1,270.2 575.9,302.5 575.9,502.7 825.7,644.1 "
       id="polygon380"
       style="isolation:isolate;fill:url(#Unbenannter_Verlauf);stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <polygon
       class="tecget-dashboard-center-icon-styling-30"
       points="704.1,270.2 409.7,434 284.8,466.3 575.9,302.5 "
       id="polygon382"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <polygon
       class="tecget-dashboard-center-icon-styling-76"
       points="704.1,270.2 590.2,333.6 713.7,506.9 825.7,443.9 "
       id="polygon384"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <polygon
       class="tecget-dashboard-center-icon-styling-72"
       points="713.7,707.1 825.7,644.1 825.7,443.9 713.7,506.9 "
       id="polygon386"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <polygon
       class="tecget-dashboard-center-icon-styling-70"
       points="713.7,707.1 713.7,506.9 590.2,333.6 590.2,631.2 "
       id="polygon388"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <polygon
       class="tecget-dashboard-center-icon-styling-39"
       points="846,662.9 535.1,838.2 535.1,829.9 846,654.7 "
       id="polygon390"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <polygon
       class="tecget-dashboard-center-icon-styling-39"
       points="265.1,686.2 535.1,838.2 535.1,829.9 265.1,677.9 "
       id="polygon392"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <polygon
       class="tecget-dashboard-center-icon-styling-70"
       points="284.8,666.4 409.7,737.1 409.7,434 284.8,466.3 "
       id="polygon394"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <polygon
       class="tecget-dashboard-center-icon-styling-72"
       points="409.7,737.1 590.2,631.2 590.2,333.6 409.7,434 "
       id="polygon396"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <polygon
       class="tecget-dashboard-center-icon-styling-28"
       points="733.9,718 535.1,829.9 389.2,748.2 590.2,631.2 "
       id="polygon398"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <polygon
       class="tecget-dashboard-center-icon-styling-68"
       points="733.9,718 535.1,829.9 389.2,748.2 590.2,631.2 "
       id="polygon400"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <g
       id="g422"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)">
      <polygon
         class="tecget-dashboard-center-icon-styling-39"
         points="376,553.3 312.7,517.4 312.7,608.2 376,644.1 "
         id="polygon402"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-39"
         points="312.7,608.2 312.7,517.4 322,522.7 322,613.5 "
         id="polygon404"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-41"
         points="376,636.3 376,644.1 312.7,608.2 322,605.9 "
         id="polygon406"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-11"
         d="m 322,522.7 v 83.1 l 54,30.5 v -83 z M 372.9,631 325.1,604 v -76 l 47.8,27.1 z"
         id="path408"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-39"
         points="325.1,604.1 325.1,528.1 328.4,529.9 328.4,605.9 "
         id="polygon410"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-75"
         points="372.8,627.9 372.8,631 325.1,604.1 328.4,603.2 "
         id="polygon412"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-11"
         points="346.5,618.9 346.5,538.9 345.1,538.9 345.1,617.1 "
         id="polygon414"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-39"
         points="348.2,617.1 348.2,541.1 346.5,540.1 346.5,616.1 "
         id="polygon416"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-11"
         points="372.9,578.6 325.1,551.5 325.1,549.6 372.9,576.6 "
         id="polygon418"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-11"
         points="372.9,605.9 325.1,578.8 325.1,576.8 372.9,603.9 "
         id="polygon420"
         style="stroke:none" />
    </g>
    <g
       id="g432"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)">
      <polygon
         class="tecget-dashboard-center-icon-styling-63"
         points="423.4,576.9 486.8,541 486.8,691.5 423.4,727.4 "
         id="polygon424"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-39"
         points="486.8,691.5 486.8,541 423.4,576.9 423.4,657.3 "
         id="polygon426"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-68"
         points="423.4,719.7 423.4,729.1 486.8,691.5 423.4,657.3 "
         id="polygon428"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-72"
         points="414.6,586.2 423.4,586 423.4,634.4 414.6,634.5 "
         id="polygon430"
         style="stroke:none" />
    </g>
    <g
       id="g454"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)">
      <polygon
         class="tecget-dashboard-center-icon-styling-76"
         points="738.5,535.7 801.9,499.8 801.9,590.6 738.5,626.5 "
         id="polygon434"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-39"
         points="801.9,590.6 801.9,499.8 792.5,505.1 792.5,595.9 "
         id="polygon436"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-41"
         points="738.5,618.7 738.5,626.5 801.9,590.6 792.5,588.3 "
         id="polygon438"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-11"
         d="m 738.5,535.7 v 83 l 54,-30.5 v -83.1 z m 3.1,1.8 47.8,-27.1 v 76 l -47.8,27 z"
         id="path440"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-39"
         points="789.4,586.5 789.4,510.5 786.2,512.3 786.2,588.3 "
         id="polygon442"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-75"
         points="741.7,610.2 741.7,613.4 789.4,586.5 786.2,585.6 "
         id="polygon444"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-11"
         points="768.1,601.3 768.1,521.3 769.5,521.3 769.5,599.5 "
         id="polygon446"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-39"
         points="766.3,599.5 766.3,523.5 768.1,522.5 768.1,598.5 "
         id="polygon448"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-11"
         points="741.6,561 789.4,533.9 789.4,532 741.6,559 "
         id="polygon450"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-11"
         points="741.6,588.3 789.4,561.2 789.4,559.2 741.6,586.3 "
         id="polygon452"
         style="stroke:none" />
    </g>
    <polygon
       class="teecget-dashboard-center-icon-styling-0"
       points="619.9,305.9 619.9,310.8 598.5,322.9 598.5,290.4 "
       id="polygon456"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <polygon
       class="teecget-dashboard-center-icon-styling-0"
       points="619.9,310.8 619.9,305.9 652.1,287.6 652.1,292.7 "
       id="polygon458"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <polygon
       class="teecget-dashboard-center-icon-styling-0"
       points="631.2,265.5 595.8,285.6 619.4,302.7 654.8,282.6 "
       id="polygon460"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <polygon
       class="teecget-dashboard-center-icon-styling-0"
       points="645.6,282.1 619.7,296.8 605,286.1 630.9,271.4 "
       id="polygon462"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <polygon
       class="teecget-dashboard-center-icon-styling-0"
       points="654.8,282.6 654.8,287.5 619.4,307.6 619.4,302.7 "
       id="polygon464"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <polygon
       class="teecget-dashboard-center-icon-styling-0"
       points="619.4,307.6 619.4,302.7 595.8,285.6 595.8,290.5 "
       id="polygon466"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <polygon
       class="teecget-dashboard-center-icon-styling-0"
       points="630.9,271.4 630.9,290.4 645.6,282.1 "
       id="polygon468"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <g
       id="g604"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)">
      <polygon
         class="tecget-dashboard-center-icon-styling-32"
         points="803.2,427.7 710.1,480.8 617,350.1 710.2,296 "
         id="polygon470"
         style="fill:url(#Unbenannter_Verlauf_2);stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-72"
         points="803.4,425.6 710.2,478.8 617.1,348.1 710.3,294 "
         id="polygon472"
         style="stroke:none" />
      <g
         id="g602"
         style="stroke:none">
        <g
           id="g488"
           style="stroke:none">
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="644.4,356.9 635.8,361.9 627.1,349.8 635.8,344.7 "
             id="polygon474"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="656.8,349.8 648.1,354.7 639.5,342.6 648.2,337.6 "
             id="polygon476"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="669.2,342.7 660.5,347.6 651.9,335.5 660.5,330.5 "
             id="polygon478"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="681.5,335.5 672.9,340.5 664.3,328.4 672.9,323.3 "
             id="polygon480"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="693.9,328.4 685.3,333.3 676.7,321.2 685.3,316.2 "
             id="polygon482"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="706.3,321.3 697.7,326.2 689.1,314.1 697.7,309.1 "
             id="polygon484"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="718.7,314.1 710.1,319.1 701.4,307 710.1,301.9 "
             id="polygon486"
             style="stroke:none" />
        </g>
        <g
           id="g504"
           style="stroke:none">
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="655.1,372.5 646.4,377.4 637.8,365.3 646.4,360.3 "
             id="polygon490"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="667.4,365.4 658.8,370.3 650.2,358.2 658.8,353.2 "
             id="polygon492"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="679.8,358.2 671.2,363.2 662.6,351 671.2,346 "
             id="polygon494"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="692.2,351.1 683.6,356 675,343.9 683.6,338.9 "
             id="polygon496"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="704.6,344 696,348.9 687.3,336.8 696,331.8 "
             id="polygon498"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="717,336.8 708.3,341.8 699.7,329.6 708.4,324.6 "
             id="polygon500"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="729.4,329.7 720.7,334.6 712.1,322.5 720.7,317.5 "
             id="polygon502"
             style="stroke:none" />
        </g>
        <g
           id="g520"
           style="stroke:none">
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="665.7,388.1 657.1,393 648.5,380.9 657.1,375.9 "
             id="polygon506"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="678.1,380.9 669.5,385.8 660.9,373.7 669.5,368.7 "
             id="polygon508"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="690.5,373.8 681.9,378.7 673.2,366.6 681.9,361.6 "
             id="polygon510"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="702.9,366.7 694.2,371.6 685.6,359.5 694.3,354.5 "
             id="polygon512"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="715.3,359.5 706.6,364.4 698,352.3 706.6,347.3 "
             id="polygon514"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="727.6,352.4 719,357.3 710.4,345.2 719,340.2 "
             id="polygon516"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="740,345.3 731.4,350.2 722.8,338.1 731.4,333.1 "
             id="polygon518"
             style="stroke:none" />
        </g>
        <g
           id="g536"
           style="stroke:none">
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="676.4,403.6 667.8,408.5 659.1,396.4 667.8,391.4 "
             id="polygon522"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="688.8,396.5 680.1,401.4 671.5,389.3 680.2,384.3 "
             id="polygon524"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="701.2,389.4 692.5,394.3 683.9,382.2 692.5,377.2 "
             id="polygon526"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="713.5,382.2 704.9,387.1 696.3,375 704.9,370 "
             id="polygon528"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="725.9,375.1 717.3,380 708.7,367.9 717.3,362.9 "
             id="polygon530"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="738.3,368 729.7,372.9 721.1,360.8 729.7,355.8 "
             id="polygon532"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="750.7,360.8 742.1,365.7 733.4,353.6 742.1,348.6 "
             id="polygon534"
             style="stroke:none" />
        </g>
        <g
           id="g552"
           style="stroke:none">
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="687.1,419.2 678.4,424.1 669.8,412 678.4,407 "
             id="polygon538"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="699.4,412 690.8,417 682.2,404.9 690.8,399.8 "
             id="polygon540"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="711.8,404.9 703.2,409.8 694.6,397.7 703.2,392.7 "
             id="polygon542"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="724.2,397.8 715.6,402.7 707,390.6 715.6,385.6 "
             id="polygon544"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="736.6,390.6 728,395.6 719.3,383.5 728,378.4 "
             id="polygon546"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="749,383.5 740.3,388.4 731.7,376.3 740.4,371.3 "
             id="polygon548"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="761.4,376.4 752.7,381.3 744.1,369.2 752.7,364.2 "
             id="polygon550"
             style="stroke:none" />
        </g>
        <g
           id="g568"
           style="stroke:none">
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="697.7,434.7 689.1,439.7 680.5,427.6 689.1,422.5 "
             id="polygon554"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="710.1,427.6 701.5,432.5 692.9,420.4 701.5,415.4 "
             id="polygon556"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="722.5,420.5 713.9,425.4 705.2,413.3 713.9,408.3 "
             id="polygon558"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="734.9,413.3 726.2,418.3 717.6,406.2 726.3,401.1 "
             id="polygon560"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="747.3,406.2 738.6,411.1 730,399 738.6,394 "
             id="polygon562"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="759.6,399.1 751,404 742.4,391.9 751,386.9 "
             id="polygon564"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="772,391.9 763.4,396.9 754.8,384.8 763.4,379.7 "
             id="polygon566"
             style="stroke:none" />
        </g>
        <g
           id="g584"
           style="stroke:none">
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="708.4,450.3 699.8,455.2 691.1,443.1 699.8,438.1 "
             id="polygon570"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="720.8,443.2 712.2,448.1 703.5,436 712.2,431 "
             id="polygon572"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="733.2,436 724.5,440.9 715.9,428.8 724.5,423.8 "
             id="polygon574"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="745.5,428.9 736.9,433.8 728.3,421.7 736.9,416.7 "
             id="polygon576"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="757.9,421.8 749.3,426.7 740.7,414.6 749.3,409.6 "
             id="polygon578"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="770.3,414.6 761.7,419.6 753.1,407.4 761.7,402.4 "
             id="polygon580"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="782.7,407.5 774.1,412.4 765.4,400.3 774.1,395.3 "
             id="polygon582"
             style="stroke:none" />
        </g>
        <g
           id="g600"
           style="stroke:none">
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="719.1,465.9 710.4,470.8 701.8,458.7 710.4,453.7 "
             id="polygon586"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="731.4,458.7 722.8,463.6 714.2,451.5 722.8,446.5 "
             id="polygon588"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="743.8,451.6 735.2,456.5 726.6,444.4 735.2,439.4 "
             id="polygon590"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="756.2,444.5 747.6,449.4 739,437.3 747.6,432.3 "
             id="polygon592"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="768.6,437.3 760,442.2 751.3,430.1 760,425.1 "
             id="polygon594"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="781,430.2 772.4,435.1 763.7,423 772.4,418 "
             id="polygon596"
             style="stroke:none" />
          <polygon
             class="tecget-dashboard-center-icon-styling-45"
             points="793.4,423.1 784.7,428 776.1,415.9 784.7,410.9 "
             id="polygon598"
             style="stroke:none" />
        </g>
      </g>
    </g>
    <polyline
       class="tecget-dashboard-center-icon-styling-10"
       points="602.1 638.2 602.1 499.6 631.3 515.9"
       id="polyline606"
       style="isolation:isolate;stroke:#cb0935;stroke-opacity:1"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <g
       id="g624"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)">
      <polygon
         class="tecget-dashboard-center-icon-styling-45"
         points="630.2,488.3 671.4,512.8 658.6,520.1 617.4,495.5 "
         id="polygon608"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-39"
         points="658.6,541 658.6,520.1 671.4,512.8 671.4,533.8 "
         id="polygon610"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-45"
         points="658.6,541 617.4,516.5 617.4,495.5 658.6,520.1 "
         id="polygon612"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-73"
         points="654.6,535.5 621.4,515.7 621.4,512.8 654.6,532.6 "
         id="polygon614"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-51"
         points="654.6,521.5 621.4,501.7 621.4,501.2 654.6,521 "
         id="polygon616"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-51"
         points="654.6,523.7 621.4,503.9 621.4,503.4 654.6,523.2 "
         id="polygon618"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-51"
         points="654.6,525.8 621.4,506.1 621.4,505.6 654.6,525.3 "
         id="polygon620"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-51"
         points="654.6,528 621.4,508.3 621.4,507.8 654.6,527.5 "
         id="polygon622"
         style="stroke:none" />
    </g>
    <polygon
       class="tecget-dashboard-center-icon-styling-68"
       points="410.6,737.7 390,748.7 265.1,677.9 284.8,666.4 "
       id="polygon626"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <polygon
       class="tecget-dashboard-center-icon-styling-68"
       points="846,654.7 733.9,718 713.7,707.1 825.7,644.1 "
       id="polygon628"
       style="isolation:isolate;stroke:none"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)" />
    <polyline
       class="tecget-dashboard-center-icon-styling-10"
       points="376.7 679.5 376.9 727.3 402.2 742 474.3 698.9"
       id="polyline632"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate" />
    <g
       id="g652"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none">
      <path
         class="tecget-dashboard-center-icon-styling-48"
         d="m 369.4,659.9 v 0 l 5,-2.9 c 0.8,-0.4 1.9,-0.3 3.1,0.4 l 10,5.8 c 2.8,1.6 5,5.9 5,9.6 v 21.1 c 0,1.9 -0.6,3.2 -1.5,3.9 l -5.1,2.9 v 0 c -0.9,0.6 -2.1,0.6 -3.5,0 l -10,-5.8 c -2.8,-1.6 -5,-5.9 -5,-9.6 v -21.1 c 0,-2.1 0.8,-3.6 1.9,-4.2 h 0.1 z"
         id="path634"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-40"
         d="m 369.4,659.9 v 0 l 5,-2.9 c 0.8,-0.4 1.9,-0.3 3.1,0.4 l 10,5.8 c 2.8,1.6 5,5.9 5,9.6 v 21.1 c 0,1.9 -0.6,3.2 -1.5,3.9 l -5.1,2.9 v 0 c -0.9,0.6 -2.1,0.6 -3.5,0 l -10,-5.8 c -2.8,-1.6 -5,-5.9 -5,-9.6 v -21.1 c 0,-2.1 0.8,-3.6 1.9,-4.2 h 0.1 z"
         id="path636"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-48"
         d="m 382,667.3 -9.2,-5.3 c -2.5,-1.5 -4.6,0 -4.6,3.5 v 19.4 c 0,3.4 2.1,7.3 4.6,8.8 l 9.2,5.3 c 2.5,1.5 4.6,0 4.6,-3.5 v -19.4 c 0,-3.4 -2.1,-7.3 -4.6,-8.8 z"
         id="path638"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-45"
         d="m 382,667.3 -9.2,-5.3 c -2.5,-1.5 -4.6,0 -4.6,3.5 v 19.4 c 0,3.4 2.1,7.3 4.6,8.8 l 9.2,5.3 c 2.5,1.5 4.6,0 4.6,-3.5 v -19.4 c 0,-3.4 -2.1,-7.3 -4.6,-8.8 z"
         id="path640"
         style="stroke:none" />
      <g
         id="g650"
         style="stroke:none">
        <path
           class="tecget-dashboard-center-icon-styling-64"
           d="m 374.8,669.1 3.9,2.3 c 0.5,0.3 1,1.1 1,1.7 l 1.4,0.8 c 0.9,0.5 1.6,1.7 1.6,2.7 v 14.5 c 0,1 -0.7,1.4 -1.6,0.9 l -8.7,-5 c -0.9,-0.5 -1.6,-1.7 -1.6,-2.7 v -14.5 c 0,-1 0.7,-1.4 1.6,-0.9 l 1.4,0.8 c 0,-0.6 0.4,-0.9 1,-0.6"
           id="path642"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-49"
           d="m 372.6,680.3 8.3,4.8 c 0.4,0.3 0.8,0 0.8,-0.6 v -2.4 c 0,-0.6 -0.4,-1.3 -0.8,-1.5 l -8.3,-4.8 c -0.4,-0.3 -0.8,0 -0.8,0.6 v 2.4 c 0,0.6 0.4,1.3 0.8,1.5 z"
           id="path644"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-44"
           d="m 372.6,674.7 8.3,4.8 c 0.4,0.3 0.8,0 0.8,-0.6 v -2.4 c 0,-0.6 -0.4,-1.3 -0.8,-1.5 l -8.3,-4.8 c -0.4,-0.3 -0.8,0 -0.8,0.6 v 2.4 c 0,0.6 0.4,1.3 0.8,1.5 z"
           id="path646"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-49"
           d="m 372.6,686 8.3,4.8 c 0.4,0.3 0.8,0 0.8,-0.6 v -2.4 c 0,-0.6 -0.4,-1.3 -0.8,-1.5 l -8.3,-4.8 c -0.4,-0.3 -0.8,0 -0.8,0.6 v 2.4 c 0,0.6 0.4,1.3 0.8,1.5 z"
           id="path648"
           style="stroke:none" />
      </g>
    </g>
    <g
       id="g750"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none">
      <polygon
         class="tecget-dashboard-center-icon-styling-43"
         points="312.2,858 322.5,852 325,842.3 312.2,849.7 "
         id="polygon654"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-43"
         d="m 333.4,837.5 -21.2,12.3 c 0,-13.5 9.5,-18.9 21.2,-12.3 z"
         id="path656"
         style="stroke:none" />
      <g
         id="g748"
         style="stroke:none">
        <path
           class="tecget-dashboard-center-icon-styling-43"
           d="m 223.4,774 -21.2,12.3 c 0,-13.5 9.5,-18.9 21.2,-12.3 z"
           id="path658"
           style="stroke:none" />
        <g
           id="g746"
           style="stroke:none">
          <g
             id="g742"
             style="stroke:none">
            <g
               id="g738"
               style="stroke:none">
              <g
                 id="g666"
                 style="stroke:none">
                <path
                   class="tecget-dashboard-center-icon-styling-12"
                   d="m 321.4,843.1 h 0.1 c 0.4,-0.3 0.9,-0.6 1.4,-0.8 l 12.8,-7.4 c 0.4,-0.3 0.9,-0.6 1.4,-0.8 h 0.2 c 2.8,-1.2 6.5,-0.8 10.5,1.6 8.9,5.1 16,17.5 16,27.7 0,10.2 -1.8,8.6 -4.7,10.3 v 0 l -14.2,8.2 v 0 c -2.9,1.6 -6.9,1.4 -11.3,-1.2 -8.9,-5.1 -16,-17.5 -16,-27.7 0,-10.2 1.5,-7.9 3.9,-9.7 v -0.2 0 z"
                   id="path660"
                   style="stroke:none" />
                <path
                   class="tecget-dashboard-center-icon-styling-64"
                   d="m 321.4,856.7 c 0,6.8 4.8,15 10.7,18.4 5.9,3.4 10.7,0.7 10.7,-6.1 0,-6.8 -4.8,-15 -10.7,-18.4 -5.9,-3.4 -10.7,-0.7 -10.7,6.1 z"
                   id="path662"
                   style="stroke:none" />
                <path
                   class="tecget-dashboard-center-icon-styling-25"
                   d="m 328.2,859 c 0,3.4 2.4,7.5 5.3,9.2 2.9,1.7 5.3,0.3 5.3,-3 0,-3.3 -2.4,-7.5 -5.3,-9.2 -3,-1.7 -5.3,-0.3 -5.3,3 z"
                   id="path664"
                   style="stroke:none" />
              </g>
              <g
                 id="g674"
                 style="stroke:none">
                <path
                   class="tecget-dashboard-center-icon-styling-12"
                   d="m 211.4,779.6 h 0.1 c 0.4,-0.3 0.9,-0.6 1.4,-0.8 l 12.8,-7.4 c 0.4,-0.3 0.9,-0.6 1.4,-0.8 h 0.2 c 2.8,-1.2 6.5,-0.8 10.5,1.6 8.9,5.1 16,17.5 16,27.7 0,10.2 -1.8,8.6 -4.7,10.3 v 0 l -14.2,8.2 v 0 c -2.9,1.6 -6.9,1.4 -11.3,-1.2 -8.9,-5.1 -16,-17.5 -16,-27.7 0,-10.2 1.5,-7.9 3.9,-9.7 v -0.2 0 z"
                   id="path668"
                   style="stroke:none" />
                <path
                   class="tecget-dashboard-center-icon-styling-64"
                   d="m 211.5,793.2 c 0,6.8 4.8,15 10.7,18.4 5.9,3.4 10.7,0.7 10.7,-6.1 0,-6.8 -4.8,-15 -10.7,-18.4 -5.9,-3.4 -10.7,-0.7 -10.7,6.1 z"
                   id="path670"
                   style="stroke:none" />
                <path
                   class="tecget-dashboard-center-icon-styling-25"
                   d="m 218.2,795.5 c 0,3.4 2.4,7.5 5.3,9.2 3,1.7 5.3,0.3 5.3,-3 0,-3.3 -2.4,-7.5 -5.3,-9.2 -2.9,-1.7 -5.3,-0.3 -5.3,3 z"
                   id="path672"
                   style="stroke:none" />
              </g>
              <path
                 class="tecget-dashboard-center-icon-styling-67"
                 d="M 360.4,844.7 200.1,752.1 c -3,-1.7 -3.8,-4.3 -2,-6.6 16.2,-20 43.7,-35.2 76.2,-44 3.8,-1 8.4,-0.6 11.3,1.2 l 160.3,92.6 c 3,1.7 3.8,4.3 2,6.6 -16.2,20 -43.7,35.2 -76.2,44 -3.8,1 -8.4,0.6 -11.3,-1.2 z"
                 id="path676"
                 style="stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-72"
                 d="M 353.4,828.3 200.2,739.8 c -3,-1.7 -3.8,-4.3 -2,-6.6 16.2,-20 43.7,-35.2 76.2,-44 3.8,-1 8.4,-0.6 11.3,1.2 l 153.2,88.5 c 3,1.7 3.8,4.3 2,6.6 -16.2,20 -43.7,35.2 -76.2,44 -3.8,1 -8.4,0.6 -11.3,-1.2 z"
                 id="path678"
                 style="stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-72"
                 d="M 314.3,772.8 218,717.2 c 12.5,-17.4 36.1,-30.3 64.1,-37 l 96.3,55.6 c -12.5,17.4 -36.1,30.3 -64.1,37 z"
                 id="path680"
                 style="stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-39"
                 d="m 314.3,772.8 9.1,27.9 c 0.4,1.4 1.9,2.2 3.3,1.8 28.3,-7.2 52.2,-20.1 66.3,-37.3 1.5,-1.9 1.6,-4.5 0.3,-6.5 l -14.9,-23 c -2.8,3.8 -6.1,7.4 -9.8,10.8 -13.3,12 -32.5,21 -54.3,26.2 v 0 z"
                 id="path682"
                 style="stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-39"
                 d="m 210.1,737.3 110.8,64 c 1.2,0.7 2.5,-0.4 2.1,-1.7 l -8.7,-26.8 -90.8,-52.4 -5.5,-3.2 -8.8,16.9 c -0.6,1.2 -0.2,2.6 0.9,3.2 z"
                 id="path684"
                 style="stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-70"
                 d="m 200.1,752.1 16.1,9.3 144.3,83.3 c 3,1.7 7.5,2.2 11.3,1.2 22.5,-6.1 42.5,-15.2 58.1,-26.9 7,-5.2 13,-10.9 18,-17.1 0.6,-0.8 1,-1.6 1,-2.5 v 32.9 c 0,0.8 -0.3,1.7 -1,2.5 -16.2,20 -43.7,35.2 -76.1,44 -3.8,1 -8.4,0.6 -11.3,-1.2 l -5.5,-3.2 v 0 c 0,-13.5 -9.6,-30.1 -21.4,-36.9 -11.8,-6.8 -21.4,-1.4 -21.4,12.2 v 0 L 245,810.9 v 0 c 0,-13.5 -9.6,-30.1 -21.4,-36.9 -11.8,-6.8 -21.4,-1.4 -21.4,12.2 v 0 c -1.8,-1.1 -4.9,-7.2 -5,-8.7 v -29.4 c 0,1.4 1.1,2.8 2.9,3.9 v 0 z"
                 id="path686"
                 style="stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-81"
                 d="m 348.6,841.2 11.8,6.8 c 3,1.7 7.5,2.2 11.3,1.2 22.5,-6.1 42.5,-15.2 58.1,-26.9 7,-5.2 13,-10.9 18,-17.1 0.6,-0.8 1,-1.6 1,-2.5 v 1.6 c 0,0.8 -0.3,1.7 -1,2.5 -5,6.2 -11.1,11.9 -18,17.1 -15.6,11.7 -35.7,20.8 -58.1,26.9 -3.8,1 -8.4,0.6 -11.3,-1.2 l -11.8,-6.8 -1.3,-4.1 0.7,0.4 0.7,2 h -0.1 z"
                 id="path688"
                 style="stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-39"
                 d="m 200.1,760.4 23.2,13.6 v 0 c -11.7,-6.6 -21.1,-1.2 -21.1,12.3 v 0 c -3.1,-1.8 -5,-5.1 -5,-8.7 v -21.1 c 0,1.4 1.1,2.8 2.9,3.9 z"
                 id="path690"
                 style="stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-75"
                 d="M 197.2,735.7 V 748 c 0,1.5 1,3 2.9,4.1 l 153.2,88.5 c 3,1.7 7.5,2.2 11.3,1.2 32.5,-8.8 59.9,-24 76.2,-44 0.6,-0.7 0.9,-1.5 0.9,-2.3 v -12.3 c 0,0.8 -0.3,1.5 -0.9,2.3 -1.3,1.6 -2.6,3.1 -4,4.6 -16.5,17.7 -42.2,31.2 -72.1,39.4 -3.8,1 -8.4,0.6 -11.3,-1.2 L 202.2,741 l -2,-1.2 c -1.9,-1.1 -2.9,-2.6 -2.9,-4.1 z"
                 id="path692"
                 style="stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-13"
                 d="m 200.1,743.9 2,1.2 v 4.1 l -2,-1.2 c -1.9,-1.1 -2.9,-2.6 -2.9,-4.1 v -4.1 c 0,1.5 1,3 2.9,4.1 z"
                 id="path694"
                 style="stroke:none" />
              <g
                 class="tecget-dashboard-center-icon-styling-37"
                 id="g698"
                 style="stroke:none">
                <path
                   class="tecget-dashboard-center-icon-styling-26"
                   d="m 251.1,736.8 59.2,34.2 9.6,29.7 h -14.1 v 40.8 l -57.3,-33.1 c -1.1,-9 -5.4,-18.9 -11.8,-27 V 761.2 H 251 v -24.4 m -0.3,-0.7 v 24.7 h -14.3 v 20.8 c 6.2,7.9 10.7,17.9 11.8,27.1 l 58.1,33.6 v -41.1 h 14.2 l -9.9,-30.4 -60,-34.7 v 0 z"
                   id="path696"
                   style="stroke:none" />
              </g>
              <path
                 class="tecget-dashboard-center-icon-styling-13"
                 d="m 200.1,752.1 2,1.2 v 4.1 l -2,-1.2 c -1.9,-1.1 -2.9,-2.6 -2.9,-4.1 V 748 c 0,1.5 1,3 2.9,4.1 z"
                 id="path700"
                 style="stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-12"
                 d="m 428.7,806 c -11.9,10.2 -27.1,18.7 -44.4,25.3 v -4.1 c 17.3,-6.5 32.4,-15 44.4,-25.3 z"
                 id="path702"
                 style="stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-34"
                 d="m 436.8,792.5 c 1.4,-1.5 2.8,-3 4,-4.6 0.6,-0.7 0.9,-1.5 0.9,-2.3 v 7.4 c 0,0.8 -0.3,1.5 -0.9,2.3 -2,2.5 -4.3,5 -6.7,7.3 v -7.4 c 0.9,-0.9 1.8,-1.8 2.6,-2.7 z"
                 id="path704"
                 style="fill:url(#Unbenannter_Verlauf_3);stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-33"
                 d="m 350.9,829.3 2.5,1.4 c 3,1.7 7.5,2.2 11.3,1.2 4.3,-1.2 8.4,-2.4 12.5,-3.8 v 7.4 c -4.1,1.4 -8.2,2.6 -12.5,3.8 -3.6,1 -7.9,0.6 -10.8,-0.9 z"
                 id="path706"
                 style="fill:url(#Unbenannter_Verlauf_4);stroke:none" />
              <polygon
                 class="tecget-dashboard-center-icon-styling-13"
                 points="349.4,830.1 351.1,835.2 345,831.7 343.4,826.6 "
                 id="polygon708"
                 style="stroke:none" />
              <polygon
                 class="tecget-dashboard-center-icon-styling-81"
                 points="353.1,841.3 354.7,846.3 348.6,842.8 347,837.8 "
                 id="polygon710"
                 style="stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-36"
                 d="m 317,772.2 v 0 l 9.9,30.4 v 0 c -1.7,0.4 -3.5,0.2 -5,-0.7 l -1.2,-0.7 -9.9,-30.4 1.2,0.7 c 1.5,0.9 3.3,1.1 5,0.7 z"
                 id="path712"
                 style="fill:url(#Unbenannter_Verlauf_5);stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-39"
                 d="m 333.5,837.4 26.9,15.5 c 3,1.7 7.5,2.2 11.3,1.2 32.5,-8.8 59.9,-23.9 76.1,-44 0.6,-0.8 1,-1.6 1,-2.5 v 24.7 c 0,0.8 -0.3,1.7 -1,2.5 -16.2,20 -43.7,35.2 -76.1,44 -3.8,1 -8.4,0.6 -11.3,-1.2 l -5.5,-3.2 c 0,-13.5 -9.6,-30.1 -21.4,-36.9 v 0 -0.2 0 z"
                 id="path714"
                 style="stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-39"
                 d="m 384.3,874.9 c 23.1,-7.8 42.9,-18.9 57,-32.9 v -8 c 0,-1.6 -1.9,-2.5 -3.1,-1.4 -13.1,11.9 -30.4,21.6 -50.3,28.7 -2.1,0.8 -3.5,2.7 -3.5,5 v 8.6 z"
                 id="path716"
                 style="stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-30"
                 d="m 388.1,748.6 5.3,3 c 0.5,0.4 1.2,0.4 1.7,0 1.9,-1.3 2.6,-2.6 2.6,-2.6 0.5,-1.9 0.2,-4.3 0,-5.4 -0.2,-1.1 -0.2,-0.8 -0.5,-1.2 -0.5,-0.7 -1.4,-1.4 -2.1,-2 -0.8,-0.7 -2,-0.8 -2.8,-0.2 -1.4,1 -2.7,2.2 -3.4,3.1 -0.7,0.9 -0.8,1.4 -0.8,2.2 v 3 0 z"
                 id="path718"
                 style="stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-39"
                 d="m 448.9,807.6 0.9,0.5 c 0.9,0.5 1.4,1.4 1.4,2.5 v 15.3 c 0,2.6 -0.8,5.2 -2.2,7.4 l -1,1.5 1,-27.1 v 0 z"
                 id="path720"
                 style="stroke:none" />
              <polygon
                 class="tecget-dashboard-center-icon-styling-48"
                 points="250.7,760.8 247.2,758.7 247.2,734.1 250.7,736.1 "
                 id="polygon722"
                 style="stroke:none" />
              <polygon
                 class="tecget-dashboard-center-icon-styling-12"
                 points="243.6,769 257.8,777.2 257.8,781.4 243.6,773.1 "
                 id="polygon724"
                 style="stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-39"
                 d="M 383.8,748.2 373.1,742 c 1.4,-1.4 2.6,-2.9 3.8,-4.4 l 6.8,10.6 z"
                 id="path726"
                 style="stroke:none" />
              <polygon
                 class="tecget-dashboard-center-icon-styling-39"
                 points="312.1,857.5 244.9,818.7 244.9,810.4 312.1,849.2 "
                 id="polygon728"
                 style="stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-35"
                 d="m 323.4,800.8 -9.1,-27.9 c 21.8,-5.2 41,-14.2 54.3,-26.2 3.8,-3.4 7,-7 9.8,-10.8 -8.3,39 -51.7,66.8 -51.7,66.8 l -2.4,-0.5 c -0.4,-0.3 -0.7,-0.8 -0.9,-1.3 v 0 z"
                 id="path730"
                 style="fill:url(#Unbenannter_Verlauf_6);stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-23"
                 d="m 351.8,801.8 27.2,15.7 -42.8,-10.9 c 5.4,-1.4 10.6,-3 15.6,-4.8 z"
                 id="path732"
                 style="fill:url(#Unbenannter_Verlauf_7);stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-24"
                 d="m 402.8,768.1 18.9,24.7 -27.2,-15.7 c 3.1,-2.9 5.8,-5.9 8.3,-9 z"
                 id="path734"
                 style="fill:url(#Unbenannter_Verlauf_8);stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-41"
                 d="m 198.1,733.3 c 5.5,-6.8 12.4,-13.1 20.3,-18.7 h 1.5 c -0.7,1 -1.4,1.8 -2,2.7 v 0 l -8.8,16.9 c -0.6,1.2 -0.2,2.6 0.9,3.3 l 110.5,63.8 v 0 l 1.2,0.7 c 0.9,0.5 1.8,0.8 2.8,0.9 H 309 L 307.7,802.1 200,739.9 c -3,-1.7 -3.8,-4.3 -2,-6.6 v 0 z"
                 id="path736"
                 style="stroke:none" />
            </g>
            <polygon
               class="teecget-dashboard-center-icon-styling-0"
               points="209.3,761.7 220,767.8 220,755.6 209.3,749.4 "
               id="polygon740"
               style="stroke:none" />
          </g>
          <path
             class="tecget-dashboard-center-icon-styling-30"
             d="m 301.9,787 c -6.4,0.6 -10.7,5.6 -10.7,5.6 v 2.4 c 7.7,7 15.6,1.7 15.6,1.7 v -3.2 c -1.4,-2.5 -4.9,-6.5 -4.9,-6.5 z"
             id="path744"
             style="stroke:none" />
        </g>
      </g>
    </g>
    <g
       id="g764"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none">
      <polygon
         class="tecget-dashboard-center-icon-styling-40"
         points="539.4,746.3 598.2,781.4 681.1,734.9 623.9,701.5 "
         id="polygon754"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-66"
         points="674.5,738.6 681.1,734.9 623.9,701.5 623.9,709 "
         id="polygon756"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-80"
         d="m 559.2,746.3 c 3.5,-1.9 8.9,-1.8 11.3,-0.4 l 1.8,1.1 v 0 l 34.1,20.8 c 1.7,1.1 5.5,0.6 8,-0.8 2.5,-1.4 2.7,-3.1 1,-4.2 L 581.3,742 v 0 l -1.8,-1.1 c -2.4,-1.5 -2.2,-4.6 1.3,-6.5 3.5,-1.9 9,-1.9 11.5,-0.4 l 1.8,1.1 v 0 l 34.1,20.8 c 1.7,1.1 5.6,0.5 8.1,-0.8 2.5,-1.4 2.6,-3.1 0.9,-4.1 l -34.1,-20.8 v 0 l -1.8,-1.1 c -2.4,-1.5 -2.5,-4.6 1.1,-6.5 3.5,-1.9 9.2,-1.9 11.7,-0.4 l 1.8,1.1 v 0 l 6.2,3.8 v 0 l 28,17 c 1.7,1.1 5.7,0.7 8.2,-0.7 2.5,-1.4 2.6,-3.2 0.8,-4.2 L 625,718.4 v 0 l -1.8,-1.1 c -2.4,-1.5 -1.6,-4.2 1.9,-6.2 l 1.2,-0.7 1.3,0.8 -1.2,0.7 c -2.5,1.4 -3.1,3.3 -1.4,4.4 l 5.7,3.5 v 0 l 30.2,18.4 c 2.4,1.5 2,4.6 -1.6,6.5 -3.5,1.9 -8.7,1.9 -11.2,0.4 l -6.6,-4 v 0 l -1.3,-0.8 v 0 l -27.6,-16.8 c -1.7,-1.1 -5.5,-1 -8,0.2 -3.1,1.5 -3.2,3.4 -1.5,4.4 l 5.7,3.5 v 0 L 639,750 c 2.4,1.5 2.1,4.7 -1.4,6.6 -3.5,1.9 -8.9,1.8 -11.3,0.3 l -1.8,-1.1 v 0 L 590.4,735 c -1.7,-1.1 -5.6,-0.8 -8.1,0.5 -3,1.6 -2.7,3.4 -0.9,4.5 l 5.7,3.5 v 0 l 30.2,18.4 c 2.4,1.5 2.1,4.8 -1.4,6.7 -3.5,1.9 -8.9,1.8 -11.4,0.3 l -1.8,-1.1 v 0 L 568.6,747 c -1.7,-1.1 -5.8,-0.7 -8.3,0.7 -2.5,1.4 -2.4,3.2 -0.7,4.3 l 5.7,3.5 v 0 l 30.2,18.4 c 2.1,1.3 1.7,3.7 -0.8,5.6 l -1.8,-1.1 c 1.7,-1.2 2.3,-2.5 0.8,-3.4 l -34.1,-20.8 v 0 l -1.8,-1.1 c -2.4,-1.5 -2.1,-4.7 1.4,-6.6 z"
         id="path758"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-62"
         d="m 581.4,738.9 5.7,3.5 v 0 l 30.2,18.4 c 2.4,1.5 2.1,4.8 -1.4,6.7 -3.5,1.9 -8.9,1.8 -11.4,0.3 l -1.8,-1.1 v 0 l -34.1,-20.8 c -1.7,-1.1 -5.8,-0.7 -8.3,0.7 -2.5,1.4 -2.4,3.2 -0.7,4.3 l 5.7,3.5 v 0 l 30.2,18.4 c 2.4,1.4 1.5,4.3 -1.7,6.2 l -1.9,-1.1 c 2.2,-1.3 3.4,-3 1.7,-4 l -34.1,-20.8 v 0 l -1.8,-1.1 c -2.4,-1.5 -2.1,-4.7 1.4,-6.6 3.5,-1.9 8.9,-1.8 11.3,-0.4 l 1.8,1.1 v 0 l 34.1,20.8 c 1.7,1.1 5.5,0.6 8,-0.8 2.5,-1.4 2.7,-3.1 1,-4.2 l -34.1,-20.8 v 0 l -1.8,-1.1 c -2.4,-1.5 -2.2,-4.6 1.3,-6.5 3.5,-1.9 9,-1.9 11.5,-0.4 l 1.8,1.1 v 0 l 34.1,20.8 c 1.7,1.1 5.6,0.5 8.1,-0.8 2.5,-1.4 2.6,-3.1 0.9,-4.1 L 603,729.3 v 0 l -1.8,-1.1 c -2.4,-1.5 -2.5,-4.6 1.1,-6.5 3.5,-1.9 9.2,-1.9 11.7,-0.4 l 1.8,1.1 v 0 l 6.2,3.8 v 0 l 28,17 c 1.7,1.1 5.7,0.7 8.2,-0.7 2.5,-1.4 2.6,-3.2 0.8,-4.2 l -34.1,-20.8 v 0 l -1.8,-1.1 c -2.4,-1.5 -1.6,-4.2 1.9,-6.2 h 0.2 l 1.3,0.7 c 0,0 -0.3,0 -0.3,0.2 -2.5,1.4 -3.1,3.3 -1.4,4.4 l 5.7,3.5 v 0 l 30.2,18.4 c 2.4,1.5 2,4.6 -1.6,6.5 -3.5,1.9 -8.7,1.9 -11.2,0.4 l -6.6,-4 v 0 l -1.3,-0.8 v 0 l -27.6,-16.8 c -1.7,-1.1 -5.5,-1 -8,0.2 -3.1,1.5 -3.2,3.4 -1.5,4.4 l 5.7,3.5 v 0 l 30.2,18.4 c 2.4,1.5 2.1,4.7 -1.4,6.6 -3.5,1.9 -8.9,1.8 -11.3,0.3 l -1.8,-1.1 v 0 l -34.1,-20.8 c -1.7,-1.1 -5.6,-0.8 -8.1,0.5 -3,1.6 -2.7,3.4 -0.9,4.5 z"
         id="path760"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-45"
         points="546,750.2 539.4,746.3 623.9,701.5 623.9,709 "
         id="polygon762"
         style="stroke:none" />
    </g>
    <polyline
       class="tecget-dashboard-center-icon-styling-10"
       points="464.2 611.7 463.9 679.1 451.1 685.9 474.3 698.9"
       id="polyline766"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none" />
    <polyline
       class="tecget-dashboard-center-icon-styling-10"
       points="654.5 401.3 643.3 408 590.4 377.9 590.2 614.1 486.7 674.3 468.7 664.5 468.7 614.3"
       id="polyline768"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate" />
    <polyline
       class="tecget-dashboard-center-icon-styling-10"
       points="459.9 613.8 459.9 660.8 446.9 654.5"
       id="polyline770"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none" />
    <polyline
       class="tecget-dashboard-center-icon-styling-10"
       points="474 698.8 590.2 631.3 714.2 706.4 745.2 689"
       id="polyline772"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none" />
    <polyline
       class="tecget-dashboard-center-icon-styling-10"
       points="749.4 693.3 678.3 733.2 665.6 725.9 665.6 733.4"
       id="polyline774"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none" />
    <g
       id="g784"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none">
      <polygon
         class="tecget-dashboard-center-icon-styling-27"
         points="614.4,563.7 657.7,589.5 655.1,590.7 611.8,564.9 "
         id="polygon776"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-39"
         points="655.1,639.1 655.1,590.7 657.7,589.5 657.7,637.9 "
         id="polygon778"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-71"
         points="655.1,639.1 611.8,613.4 611.8,564.9 655.1,590.7 "
         id="polygon780"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-39"
         points="613.7,612.3 653.3,635.9 653.3,591.7 613.7,568.1 "
         id="polygon782"
         style="stroke:none" />
    </g>
    <g
       id="g814"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none">
      <polygon
         class="tecget-dashboard-center-icon-styling-20"
         points="536,666.4 609.2,709.9 563.8,735.6 490.7,692 "
         id="polygon786"
         style="stroke:none" />
      <g
         id="g792"
         style="stroke:none">
        <polygon
           class="tecget-dashboard-center-icon-styling-41"
           points="564,727.1 564,719.9 560.6,720.6 560.6,728.6 "
           id="polygon788"
           style="stroke:none" />
        <polygon
           class="tecget-dashboard-center-icon-styling-79"
           points="560.6,728.6 560.6,720.6 558.3,721.2 558.3,727.7 "
           id="polygon790"
           style="stroke:none" />
      </g>
      <g
         id="g798"
         style="stroke:none">
        <polygon
           class="tecget-dashboard-center-icon-styling-41"
           points="499.9,690.4 499.9,683.3 496.4,683.9 496.4,691.9 "
           id="polygon794"
           style="stroke:none" />
        <polygon
           class="tecget-dashboard-center-icon-styling-79"
           points="496.4,691.9 496.4,683.9 494.2,684.5 494.2,691 "
           id="polygon796"
           style="stroke:none" />
      </g>
      <g
         id="g804"
         style="stroke:none">
        <polygon
           class="tecget-dashboard-center-icon-styling-41"
           points="599.7,707.6 599.7,700.4 596.3,701.1 596.3,709.1 "
           id="polygon800"
           style="stroke:none" />
        <polygon
           class="tecget-dashboard-center-icon-styling-79"
           points="596.3,709.1 596.3,701.1 594,701.7 594,708.2 "
           id="polygon802"
           style="stroke:none" />
      </g>
      <path
         class="tecget-dashboard-center-icon-styling-79"
         d="m 601.9,689.5 v 5.7 c 0,3.4 -1.9,6.6 -4.9,8.3 l -33.5,18.4 c -2.6,1.4 -5.5,1 -7.6,-0.5 l -0.3,-0.2 C 554,719.9 553,718 553,715.7 v -40.1 0 c 0.2,-2.6 1,-4.9 2.2,-7 1.4,-2.5 3.5,-4.7 6.2,-6.3 0.8,-0.5 1.7,-0.7 2.6,-0.8 h 1.4 l 2.7,1.5 c 1,0.9 1.6,2.2 1.6,3.8 v 26 c 0,2.4 2.6,3.8 4.6,2.6 l 18.4,-11.3 c 1.1,-0.7 2.3,-0.9 3.5,-0.8 0.6,0 1.3,0.2 1.9,0.4 v 0 l 1.5,0.9 c 1.4,1.1 2.3,2.8 2.3,4.8 v 0 z"
         id="path806"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-71"
         d="m 564,661.6 c -0.9,0 -1.8,0.3 -2.6,0.8 -2.6,1.5 -4.7,3.7 -6.2,6.3 -1.2,2.1 -1.9,4.4 -2.2,6.9 v 0 0.7 l -15.4,-8.8 -18.3,-10.4 -11.1,-6.3 -16.6,-9.5 v 0 -0.5 c 0.2,-2.3 1,-4.5 2.1,-6.5 1.4,-2.5 3.5,-4.7 6.2,-6.3 1.3,-0.8 2.8,-0.9 4.1,-0.6 l 2.6,1.5 57.2,32.9 z"
         id="path808"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-41"
         d="m 555.7,721.2 -60,-34.4 v 0 c -2.3,-1.1 -4,-3.5 -4,-6.4 v -39.3 0 l 16.6,9.5 11.1,6.3 18.3,10.4 15.4,8.8 v 39.5 c 0,2.3 1.1,4.3 2.6,5.5 v 0 z"
         id="path810"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-41"
         d="m 598.1,684.5 c -1.7,-0.7 -3.6,-0.6 -5.4,0.4 l -18.4,11.4 c -2,1.2 -4.6,-0.2 -4.6,-2.6 v -25.8 z"
         id="path812"
         style="stroke:none" />
    </g>
    <g
       id="g868"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none">
      <g
         id="g844"
         style="stroke:none">
        <polygon
           class="tecget-dashboard-center-icon-styling-20"
           points="677.8,685.1 712.4,706.3 683.2,722.9 648.6,701.6 "
           id="polygon816"
           style="stroke:none" />
        <g
           id="g842"
           style="stroke:none">
          <polygon
             class="tecget-dashboard-center-icon-styling-79"
             points="648.6,701.6 656,696.3 652.3,694.6 646.7,700.4 "
             id="polygon818"
             style="stroke:none" />
          <g
             id="g824"
             style="stroke:none">
            <polygon
               class="tecget-dashboard-center-icon-styling-41"
               points="676.5,717.8 673,706.3 676.5,708.2 678.3,716.9 "
               id="polygon820"
               style="stroke:none" />
            <polygon
               class="tecget-dashboard-center-icon-styling-79"
               points="673.9,716.9 668.9,704.7 673,706.3 676.5,717.8 "
               id="polygon822"
               style="stroke:none" />
          </g>
          <g
             id="g830"
             style="stroke:none">
            <polygon
               class="tecget-dashboard-center-icon-styling-41"
               points="702.8,702.5 699.3,691.1 702.8,692.9 704.5,701.7 "
               id="polygon826"
               style="stroke:none" />
            <polygon
               class="tecget-dashboard-center-icon-styling-79"
               points="699.3,700.7 692,689.3 699.3,691.1 702.8,702.5 "
               id="polygon828"
               style="stroke:none" />
          </g>
          <g
             id="g840"
             style="stroke:none">
            <polygon
               class="tecget-dashboard-center-icon-styling-41"
               points="677.8,647.6 704.5,664.1 675.3,680.6 648.6,664.2 "
               id="polygon832"
               style="stroke:none" />
            <polygon
               class="tecget-dashboard-center-icon-styling-79"
               points="675.3,708.8 675.3,680.6 704.5,664.1 704.5,692.3 "
               id="polygon834"
               style="stroke:none" />
            <polygon
               class="tecget-dashboard-center-icon-styling-71"
               points="675.3,708.8 648.6,692.4 648.6,664.2 675.3,680.6 "
               id="polygon836"
               style="stroke:none" />
            <polygon
               class="tecget-dashboard-center-icon-styling-79"
               points="672,703.3 651.9,690.9 651.9,669.7 672,682.1 "
               id="polygon838"
               style="stroke:none" />
          </g>
        </g>
      </g>
      <g
         id="g866"
         style="stroke:none">
        <g
           id="g850"
           style="stroke:none">
          <path
             class="tecget-dashboard-center-icon-styling-72"
             d="m 684.6,660.8 v 0 0.2 0 0.2 0 0.2 0 0.2 0 0.2 0 0.2 0 0.2 0 c 0,0 0,0.2 -0.2,0.2 v 0 l -0.2,0.2 h -0.7 c -0.2,0 -0.4,0.2 -0.5,0.3 v 0 c -0.2,0 -0.3,0.2 -0.5,0.2 v 0 c -0.2,0 -0.4,0 -0.6,0.2 h -7.5 c -0.2,0 -0.3,0 -0.5,-0.2 v 0 c 0,0 -0.3,0 -0.4,-0.2 h -0.2 c -0.2,0 -0.4,-0.2 -0.6,-0.3 -1.6,-0.9 -2.4,-2.1 -2.4,-3.3 v 3.5 c 0,1.2 0.8,2.4 2.4,3.3 0.2,0 0.4,0.2 0.6,0.3 h 0.2 c 0,0 0.2,0 0.4,0.2 v 0 c 0.2,0 0.3,0 0.5,0.2 h 7.5 c 0.2,0 0.3,0 0.5,-0.2 v 0 c 0.2,0 0.3,0 0.5,-0.2 v 0 c 0.2,0 0.4,-0.2 0.5,-0.3 h 0.7 c 0,0 0,-0.2 0.2,-0.3 v 0 c 0,0 0,-0.2 0.2,-0.2 v 0 -0.2 0 -0.2 0 -0.2 0 -0.2 0 -0.2 0 -0.2 0 -3.5 0 l 0.3,-0.3 z"
             id="path846"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-64"
             d="m 682.2,657.3 c 3.1,1.8 3.2,4.8 0,6.6 -3.1,1.8 -8.2,1.8 -11.3,0 -3.1,-1.8 -3.2,-4.8 0,-6.6 3.1,-1.8 8.2,-1.8 11.3,0 z"
             id="path848"
             style="stroke:none" />
        </g>
        <g
           id="g864"
           style="stroke:none">
          <g
             id="g856"
             style="stroke:none">
            <path
               class="tecget-dashboard-center-icon-styling-27"
               d="M 679.1,630.4 H 676 c -0.5,-0.3 -0.7,-0.7 -0.7,-1 v 29.9 c 0,0.4 0.2,0.8 0.7,1 h 2.3 v -29.9 z"
               id="path852"
               style="stroke:none" />
            <path
               class="tecget-dashboard-center-icon-styling-64"
               d="m 678.3,629.3 c 1,0.6 1,1.5 0,2.1 -1,0.6 -2.6,0.5 -3.6,0 -1,-0.6 -1,-1.5 0,-2.1 1,-0.6 2.6,-0.5 3.6,0 z"
               id="path854"
               style="stroke:none" />
          </g>
          <g
             id="g862"
             style="stroke:none">
            <path
               class="tecget-dashboard-center-icon-styling-72"
               d="m 691,596 v 2.4 c 0,0 0,0.2 -0.2,0.3 v 0.2 c 0,0 0,0.2 -0.2,0.3 v 0 c 0,0.2 -0.2,0.4 -0.4,0.5 v 0 c 0,0.2 -0.2,0.3 -0.3,0.4 h -0.2 l -0.2,0.2 -0.2,0.2 -0.2,0.2 -0.2,0.2 c 0,0 -0.2,0 -0.2,0.2 0,0 -0.2,0 -0.2,0.2 0,0 -0.2,0 -0.3,0.2 0,0 -0.2,0 -0.3,0.2 -0.3,0.2 -0.6,0.4 -1,0.5 h -0.3 c -0.3,0 -0.6,0.3 -0.9,0.4 v 0 c -0.3,0 -0.7,0.2 -1,0.4 -0.2,0 -0.5,0 -0.7,0.2 -0.2,0 -0.4,0 -0.6,0.2 -0.3,0 -0.5,0 -0.8,0.2 h -9.9 c -0.3,0 -0.6,0 -0.9,-0.2 -0.2,0 -0.4,0 -0.6,-0.2 h -0.3 c -0.3,0 -0.6,-0.2 -0.9,-0.3 h -0.3 c -0.3,0 -0.5,-0.2 -0.8,-0.3 0,0 -0.3,0 -0.4,-0.2 -0.4,-0.2 -0.7,-0.4 -1.1,-0.6 -2.9,-1.6 -4.3,-3.8 -4.3,-6 l -5.7,27.8 c 0,3 2,6 5.9,8.3 0.5,0.3 1,0.5 1.5,0.8 0.2,0 0.3,0.2 0.5,0.2 0.3,0 0.6,0.3 0.9,0.4 h 0.6 c 0.4,0 0.8,0.3 1.2,0.4 h 1.2 c 0.4,0 0.8,0.2 1.2,0.3 h 0.8 c 0.4,0 0.7,0 1.1,0.2 h 9.2 c 0.5,0 0.9,0 1.4,-0.2 h 1.1 c 0.4,0 0.7,0 1.1,-0.2 0.3,0 0.5,0 0.8,-0.2 0.3,0 0.7,-0.2 1,-0.3 h 0.2 c 0.4,0 0.8,-0.3 1.2,-0.4 h 0.2 c 0.4,-0.2 0.9,-0.4 1.3,-0.6 0,0 0.2,0 0.4,-0.2 0.5,-0.2 0.9,-0.5 1.4,-0.7 h 0.4 c 0,0 0.2,-0.2 0.4,-0.2 0.2,0 0.2,0 0.3,-0.2 0,0 0.2,-0.2 0.3,-0.2 0.1,0 0.2,0 0.3,-0.2 0,0 0.2,-0.2 0.3,-0.2 0,0 0.2,-0.2 0.3,-0.2 l 0.3,-0.3 v 0 c 0.2,-0.3 0.3,-0.4 0.5,-0.6 v -0.2 c 0.2,-0.2 0.4,-0.4 0.5,-0.6 v 0 c 0,-0.2 0.2,-0.4 0.3,-0.5 v -0.2 c 0,0 0.2,-0.2 0.2,-0.4 v 0 c 0,-0.2 0,-0.3 0.2,-0.4 v -0.6 0 -1.3 0 -1.4 l -5.6,-27.8 v 0.3 l 0.5,-0.5 z"
               id="path858"
               style="stroke:none" />
            <path
               class="tecget-dashboard-center-icon-styling-64"
               d="m 686.8,589.8 c 5.7,3.3 5.7,8.6 0,11.9 -5.6,3.3 -14.8,3.3 -20.5,0 -5.7,-3.3 -5.7,-8.6 0,-11.9 5.6,-3.3 14.8,-3.3 20.5,0 z"
               id="path860"
               style="stroke:none" />
          </g>
        </g>
      </g>
    </g>
    <g
       id="g882"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none">
      <path
         class="tecget-dashboard-center-icon-styling-48"
         d="m 454.1,583.6 v 0 l 5,-2.9 c 0.8,-0.4 1.9,-0.3 3.1,0.4 l 10,5.8 c 2.8,1.6 5,5.9 5,9.6 v 21.1 c 0,1.9 -0.6,3.2 -1.5,3.9 l -5.1,2.9 v 0 c -0.9,0.6 -2.1,0.6 -3.5,0 l -10,-5.8 c -2.8,-1.6 -5,-5.9 -5,-9.6 v -21.1 c 0,-2.1 0.8,-3.6 1.9,-4.2 h 0.1 z"
         id="path870"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-40"
         d="m 454.1,583.6 v 0 l 5,-2.9 c 0.8,-0.4 1.9,-0.3 3.1,0.4 l 10,5.8 c 2.8,1.6 5,5.9 5,9.6 v 21.1 c 0,1.9 -0.6,3.2 -1.5,3.9 l -5.1,2.9 v 0 c -0.9,0.6 -2.1,0.6 -3.5,0 l -10,-5.8 c -2.8,-1.6 -5,-5.9 -5,-9.6 v -21.1 c 0,-2.1 0.8,-3.6 1.9,-4.2 h 0.1 z"
         id="path872"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-48"
         d="m 466.8,590.9 -9.2,-5.3 c -2.5,-1.5 -4.6,0 -4.6,3.5 v 19.4 c 0,3.4 2.1,7.3 4.6,8.8 l 9.2,5.3 c 2.5,1.5 4.6,0 4.6,-3.5 v -19.4 c 0,-3.4 -2.1,-7.3 -4.6,-8.8 z"
         id="path874"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-45"
         d="m 466.8,590.9 -9.2,-5.3 c -2.5,-1.5 -4.6,0 -4.6,3.5 v 19.4 c 0,3.4 2.1,7.3 4.6,8.8 l 9.2,5.3 c 2.5,1.5 4.6,0 4.6,-3.5 v -19.4 c 0,-3.4 -2.1,-7.3 -4.6,-8.8 z"
         id="path876"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-40"
         d="m 454.1,583.6 v 0 l 5,-2.9 c 0.8,-0.4 1.9,-0.3 3.1,0.4 l 10,5.8 c 2.8,1.6 5,5.9 5,9.6 v 21.1 c 0,1.9 -0.6,3.2 -1.5,3.9 l -5.1,2.9 v 0 c -0.9,0.6 -2.1,0.6 -3.5,0 l -10,-5.8 c -2.8,-1.6 -5,-5.9 -5,-9.6 v -21.1 c 0,-2.1 0.8,-3.6 1.9,-4.2 h 0.1 z"
         id="path878"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-45"
         d="m 466.8,590.9 -9.2,-5.3 c -2.5,-1.5 -4.6,0 -4.6,3.5 v 19.4 c 0,3.4 2.1,7.3 4.6,8.8 l 9.2,5.3 c 2.5,1.5 4.6,0 4.6,-3.5 v -19.4 c 0,-3.4 -2.1,-7.3 -4.6,-8.8 z"
         id="path880"
         style="stroke:none" />
    </g>
    <g
       class="tecget-dashboard-center-icon-styling-53"
       clip-path="url(#clippath-1)"
       id="g900"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none">
      <g
         id="g898"
         style="stroke:none">
        <polygon
           class="tecget-dashboard-center-icon-styling-45"
           points="451,672.2 451.1,625.1 423.1,609 414.8,613.9 414.7,660.7 442.6,676.8 "
           id="polygon884"
           style="stroke:none" />
        <polygon
           class="tecget-dashboard-center-icon-styling-11"
           points="437.6,655 403.7,635.8 403.7,635.4 437.6,654.6 "
           id="polygon886"
           style="stroke:none" />
        <polygon
           class="tecget-dashboard-center-icon-styling-11"
           points="437.6,664.4 403.7,645.2 403.7,644.7 437.6,663.9 "
           id="polygon888"
           style="stroke:none" />
        <polygon
           class="tecget-dashboard-center-icon-styling-11"
           points="437.6,645.7 403.7,626.5 403.7,626 437.6,645.2 "
           id="polygon890"
           style="stroke:none" />
        <polygon
           class="tecget-dashboard-center-icon-styling-11"
           points="437.6,636.3 403.7,617.1 403.7,616.6 437.6,635.8 "
           id="polygon892"
           style="stroke:none" />
        <polygon
           class="tecget-dashboard-center-icon-styling-40"
           points="451,672.2 451.1,625.1 442.7,630 442.6,676.8 "
           id="polygon894"
           style="stroke:none" />
        <polygon
           class="tecget-dashboard-center-icon-styling-40"
           points="451.1,625.1 423.1,609 414.8,613.9 442.7,630 "
           id="polygon896"
           style="stroke:none" />
      </g>
    </g>
    <g
       id="g934"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none">
      <polygon
         class="tecget-dashboard-center-icon-styling-40"
         points="760.9,702.5 741.7,691.3 741.7,687.6 743,682.9 742.9,642.6 792.6,613.8 811.8,625 812,664.7 813.3,667.9 813.3,672.3 804.7,677.2 798.1,673.3 768.1,690.6 769.5,693.8 769.5,697.6 "
         id="polygon902"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-45"
         points="743,682.9 742.9,642.6 762.1,653.7 762.2,693.5 "
         id="polygon904"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-17"
         points="741.7,691.3 760.9,702.5 760.9,698.2 741.7,687.6 "
         id="polygon906"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-39"
         points="798.1,673.3 804.7,677.2 804.7,672.9 801.3,670.9 "
         id="polygon908"
         style="stroke:none" />
      <g
         class="tecget-dashboard-center-icon-styling-31"
         id="g912"
         style="stroke:none">
        <polygon
           class="tecget-dashboard-center-icon-styling-38"
           points="741.7,687.6 760.9,698.2 762.2,693.5 743,682.9 "
           id="polygon910"
           style="stroke:none" />
      </g>
      <polygon
         class="tecget-dashboard-center-icon-styling-17"
         points="769.5,693.8 768.1,690.6 762.2,693.5 760.9,698.2 "
         id="polygon914"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-17"
         points="813.3,667.9 804.7,672.9 806,668.2 812,664.7 "
         id="polygon916"
         style="stroke:none" />
      <polygon
         class="tecget-dashboard-center-icon-styling-45"
         points="742.9,642.6 792.6,613.8 811.8,625 762.1,653.7 "
         id="polygon918"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-39"
         d="m 794.6,640 c 3.6,-2.1 6.9,-2.4 9.5,-0.9 2.6,1.5 4,4.5 4,8.6 0,8.2 -5.8,18.2 -12.9,22.4 -2.1,1.2 -4.1,1.8 -6,1.8 -1.9,0 -2.5,-0.3 -3.6,-0.9 -2.6,-1.5 -4,-4.5 -4,-8.6 0,-8.2 5.8,-18.2 12.9,-22.4 v 0 z"
         id="path920"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-79"
         d="m 768.4,657.2 6.5,-3.8 h 0.5 c 0.2,0 0.3,0.3 0.3,0.4 v 5.3 c 0,0.2 0,0.4 -0.2,0.4 l -6.5,3.8 h -0.6 c -0.2,0 -0.3,-0.3 -0.3,-0.4 v -5.3 c 0,-0.2 0,-0.4 0.2,-0.4 v 0 z"
         id="path922"
         style="stroke:none" />
      <rect
         class="tecget-dashboard-center-icon-styling-64"
         x="768.20001"
         y="668.90002"
         width="7.5"
         height="1"
         transform="rotate(-30,772.01828,669.46168)"
         id="rect924"
         style="stroke:none" />
      <rect
         class="tecget-dashboard-center-icon-styling-64"
         x="768.20001"
         y="673.40002"
         width="7.5"
         height="1"
         transform="rotate(-30,772.0379,673.86693)"
         id="rect926"
         style="stroke:none" />
      <rect
         class="tecget-dashboard-center-icon-styling-64"
         x="768.20001"
         y="677.90002"
         width="7.5"
         height="1"
         transform="rotate(-30,772.00752,678.45879)"
         id="rect928"
         style="stroke:none" />
      <g
         class="tecget-dashboard-center-icon-styling-31"
         id="g932"
         style="stroke:none">
        <polygon
           class="tecget-dashboard-center-icon-styling-38"
           points="801.3,670.9 804.7,672.9 806,668.2 "
           id="polygon930"
           style="stroke:none" />
      </g>
    </g>
    <g
       id="g940"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate">
      <path
         class="tecget-dashboard-center-icon-styling-4"
         d="m 842.5,324.6 v 79.8 c 0,7.3 -3.9,14 -10.2,17.6 l -161.6,94.6"
         id="path936" />
      <path
         class="tecget-dashboard-center-icon-styling-77"
         d="m 666.1,507.9 c -4.7,2.8 -6.3,8.8 -3.5,13.6 2.8,4.7 8.8,6.3 13.6,3.5 4.7,-2.8 6.3,-8.8 3.5,-13.6 -2.8,-4.7 -8.8,-6.3 -13.6,-3.5 z"
         id="path938" />
    </g>
    <g
       id="g946"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate">
      <line
         class="tecget-dashboard-center-icon-styling-4"
         x1="931.90002"
         y1="759.29999"
         x2="626.40002"
         y2="759.29999"
         id="line942" />
      <path
         class="tecget-dashboard-center-icon-styling-77"
         d="m 626.9,749.4 c -5.5,0 -9.9,4.4 -9.9,9.9 0,5.5 4.4,9.9 9.9,9.9 5.5,0 9.9,-4.4 9.9,-9.9 0,-5.5 -4.4,-9.9 -9.9,-9.9 z"
         id="path944" />
    </g>
    <g
       id="g956"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate">
      <line
         class="tecget-dashboard-center-icon-styling-3"
         x1="381.5"
         y1="658.29999"
         x2="381.5"
         y2="657.59998"
         id="line948" />
      <path
         class="tecget-dashboard-center-icon-styling-1"
         d="M 381.5,642.9 V 453.3 c 0,-7.3 -3.9,-14 -10.2,-17.6 L 283,383.3"
         id="path950" />
      <line
         class="tecget-dashboard-center-icon-styling-3"
         x1="276.60001"
         y1="379.5"
         x2="276.10001"
         y2="379.10001"
         id="line952" />
      <path
         class="tecget-dashboard-center-icon-styling-77"
         d="m 391.4,657.8 c 0,5.5 -4.4,9.9 -9.9,9.9 -5.5,0 -9.9,-4.4 -9.9,-9.9 0,-5.5 4.4,-9.9 9.9,-9.9 5.5,0 9.9,4.4 9.9,9.9 z"
         id="path954" />
    </g>
    <g
       id="g984"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate">
      <path
         class="tecget-dashboard-center-icon-styling-69"
         d="m 328.1,302.3 c -9,-8.8 -23.7,-13.2 -44.1,-13.2 -20.4,0 -35.1,4.4 -44.1,13.2 -9,8.8 -13.5,21.9 -13.5,39.2 0,17.3 4.5,30.4 13.5,39.2 9,8.8 23.7,13.2 44.1,13.2 20.4,0 35.1,-4.4 44.1,-13.2 9,-8.8 13.5,-21.9 13.5,-39.2 0,-17.3 -4.5,-30.4 -13.5,-39.2"
         id="path958" />
      <g
         id="g982">
        <line
           class="tecget-dashboard-center-icon-styling-6"
           x1="268.89999"
           y1="325.29999"
           x2="268.89999"
           y2="318.5"
           id="line960" />
        <g
           id="g980">
          <path
             class="tecget-dashboard-center-icon-styling-6"
             d="m 260.8,357.1 c 0,1.6 1.3,3 3,3 h 30.9 c 1.6,0 3,-1.3 3,-3 v -40.3 c 0,-1.6 -1.3,-3 -3,-3 h -30.9 c -1.6,0 -3,1.3 -3,3 z"
             id="path962" />
          <line
             class="tecget-dashboard-center-icon-styling-6"
             x1="289.89999"
             y1="325.29999"
             x2="289.89999"
             y2="318.5"
             id="line964" />
          <rect
             class="tecget-dashboard-center-icon-styling-6"
             x="272.20001"
             y="318.5"
             width="14.2"
             height="6.8000002"
             rx="1.4298005"
             ry="1.4298005"
             id="rect966" />
          <path
             class="tecget-dashboard-center-icon-styling-6"
             d="m 278.6,360.4 v 3.8 c 0,0.8 -0.7,1.5 -1.5,1.5 h -11.2 c -0.8,0 -1.5,-0.7 -1.5,-1.5 v -3.8"
             id="path968" />
          <g
             id="g974">
            <circle
               class="tecget-dashboard-center-icon-styling-6"
               cx="279.20001"
               cy="342.70001"
               r="11.3"
               id="circle970" />
            <polyline
               class="tecget-dashboard-center-icon-styling-6"
               points="280.6 336.6 276.7 343.2 282.6 343.2 278.8 349.8"
               id="polyline972" />
          </g>
          <path
             class="tecget-dashboard-center-icon-styling-6"
             d="M 309.9,345.6 V 363 c 0,5.9 -4.8,10.7 -10.7,10.7 v 0 c -5.9,0 -10.7,-4.8 -10.7,-10.7 v -3 0"
             id="path976" />
          <path
             class="tecget-dashboard-center-icon-styling-6"
             d="m 297.7,331 6.2,3 c 0.9,0.5 1.6,1.4 1.6,2.5 v 8.4 h 8.6 v -12.2 c 0,-4.6 -3.8,-8.4 -8.4,-8.4 h -8 z"
             id="path978" />
        </g>
      </g>
    </g>
    <g
       id="g990"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate">
      <path
         class="tecget-dashboard-center-icon-styling-4"
         d="m 572.4,261.5 v 254.8 c 0,7.3 -3.9,14 -10.2,17.6 l -91.3,52"
         id="path986" />
      <path
         class="tecget-dashboard-center-icon-styling-77"
         d="m 466.4,577.1 c -4.8,2.7 -6.4,8.8 -3.7,13.5 2.7,4.8 8.8,6.4 13.5,3.7 4.8,-2.7 6.4,-8.8 3.7,-13.5 -2.7,-4.8 -8.8,-6.4 -13.5,-3.7 z"
         id="path988" />
    </g>
    <g
       id="g996"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate">
      <line
         class="tecget-dashboard-center-icon-styling-4"
         x1="434.5"
         y1="336.79999"
         x2="434.5"
         y2="624.40002"
         id="line992" />
      <path
         class="tecget-dashboard-center-icon-styling-77"
         d="m 424.6,623.9 c 0,5.5 4.4,9.9 9.9,9.9 5.5,0 9.9,-4.4 9.9,-9.9 0,-5.5 -4.4,-9.9 -9.9,-9.9 -5.5,0 -9.9,4.4 -9.9,9.9 z"
         id="path994" />
    </g>
    <g
       id="g1002"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate">
      <line
         class="tecget-dashboard-center-icon-styling-4"
         x1="730.09998"
         y1="210.10001"
         x2="730.09998"
         y2="340.79999"
         id="line998" />
      <path
         class="tecget-dashboard-center-icon-styling-77"
         d="m 720.2,340.3 c 0,5.5 4.4,9.9 9.9,9.9 5.5,0 9.9,-4.4 9.9,-9.9 0,-5.5 -4.4,-9.9 -9.9,-9.9 -5.5,0 -9.9,4.4 -9.9,9.9 z"
         id="path1000" />
    </g>
    <g
       id="g1008"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate">
      <path
         class="tecget-dashboard-center-icon-styling-4"
         d="M 944,443.9 V 557 c 0,7.3 -3.9,14 -10.2,17.6 l -134.4,75.8"
         id="path1004" />
      <path
         class="tecget-dashboard-center-icon-styling-77"
         d="m 794.9,641.5 c -4.8,2.7 -6.5,8.7 -3.8,13.5 2.7,4.8 8.7,6.5 13.5,3.8 4.8,-2.7 6.5,-8.7 3.8,-13.5 -2.7,-4.8 -8.7,-6.5 -13.5,-3.8 z"
         id="path1006" />
    </g>
    <g
       id="g1028"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate">
      <path
         class="tecget-dashboard-center-icon-styling-69"
         d="m 948.9,719.3 c -9,-8.8 -23.7,-13.2 -44.1,-13.2 -20.4,0 -35.1,4.4 -44.1,13.2 -9,8.8 -13.5,21.9 -13.5,39.2 0,17.3 4.5,30.4 13.5,39.2 9,8.8 23.7,13.2 44.1,13.2 20.4,0 35.1,-4.4 44.1,-13.2 9,-8.8 13.5,-21.9 13.5,-39.2 0,-17.3 -4.5,-30.4 -13.5,-39.2"
         id="path1010" />
      <g
         id="g1026">
        <g
           id="g1016">
          <path
             class="tecget-dashboard-center-icon-styling-7"
             d="m 929,748.6 v 25.3 c 0,2.3 -1.9,4.1 -4.2,4.1 -2.3,0 -4.2,-1.9 -4.2,-4.1 v -21.2 0 c 0,-2.3 -1.9,-4.1 -4.2,-4.1 -2.3,0 -4.2,1.9 -4.2,4.1 v 21.2 c 0,2.3 -1.9,4.1 -4.2,4.1 -2.3,0 -4.2,-1.9 -4.2,-4.1 v -21.2 c 0,-2.3 -1.9,-4.1 -4.2,-4.1 -2.3,0 -4.2,1.9 -4.2,4.1 v 21.2 c 0,2.3 -1.9,4.1 -4.2,4.1 -2.3,0 -4.2,-1.9 -4.2,-4.1 v 0 -21.2 c 0,-2.3 -1.9,-4.1 -4.2,-4.1 -2.3,0 -4.2,1.9 -4.2,4.1 V 778"
             id="path1012" />
          <path
             class="tecget-dashboard-center-icon-styling-7"
             d="m 875.8,741.6 c -2.2,0 -4,1.8 -4,4 V 781 c 0,2.2 1.8,4 4,4 h 55.9 c 2.2,0 4,-1.8 4,-4 v -35.4 c 0,-2.2 -1.8,-4 -4,-4 z"
             id="path1014" />
        </g>
        <g
           id="g1024">
          <path
             class="tecget-dashboard-center-icon-styling-7"
             d="m 916,736 c -7.1,-4.4 7.1,-8.8 0,-13.2"
             id="path1018" />
          <path
             class="tecget-dashboard-center-icon-styling-7"
             d="m 903.7,736 c -7.1,-4.4 7.1,-8.8 0,-13.2"
             id="path1020" />
          <path
             class="tecget-dashboard-center-icon-styling-7"
             d="m 891.5,736 c -7.1,-4.4 7.1,-8.8 0,-13.2"
             id="path1022" />
        </g>
      </g>
    </g>
    <g
       id="g1060"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate">
      <path
         class="tecget-dashboard-center-icon-styling-69"
         d="m 988.6,360.6 c -9,-8.8 -23.7,-13.2 -44.1,-13.2 -20.4,0 -35.1,4.4 -44.1,13.2 -9,8.8 -13.5,21.9 -13.5,39.2 0,17.3 4.5,30.4 13.5,39.2 9,8.8 23.7,13.2 44.1,13.2 20.4,0 35.1,-4.4 44.1,-13.2 9,-8.8 13.5,-21.9 13.5,-39.2 0,-17.3 -4.5,-30.4 -13.5,-39.2"
         id="path1030" />
      <g
         id="g1058">
        <rect
           class="tecget-dashboard-center-icon-styling-7"
           x="910.70001"
           y="375.70001"
           width="67.400002"
           height="43.5"
           rx="3.4315209"
           ry="3.4315209"
           id="rect1032" />
        <polyline
           class="tecget-dashboard-center-icon-styling-7"
           points="933.8 419.4 933.8 426.6 923.9 426.6 923.9 419.4"
           id="polyline1034" />
        <polyline
           class="tecget-dashboard-center-icon-styling-7"
           points="965.5 419.4 965.5 426.6 955.6 426.6 955.6 419.4"
           id="polyline1036" />
        <line
           class="tecget-dashboard-center-icon-styling-7"
           x1="962.29999"
           y1="410.60001"
           x2="970.40002"
           y2="410.60001"
           id="line1038" />
        <line
           class="tecget-dashboard-center-icon-styling-7"
           x1="962.29999"
           y1="404.70001"
           x2="970.40002"
           y2="404.70001"
           id="line1040" />
        <line
           class="tecget-dashboard-center-icon-styling-7"
           x1="962.29999"
           y1="399"
           x2="970.40002"
           y2="399"
           id="line1042" />
        <line
           class="tecget-dashboard-center-icon-styling-7"
           x1="955.79999"
           y1="418.20001"
           x2="955.79999"
           y2="375.70001"
           id="line1044" />
        <circle
           class="tecget-dashboard-center-icon-styling-7"
           cx="933.70001"
           cy="397.60001"
           r="13.8"
           id="circle1046" />
        <g
           id="g1056">
          <line
             class="tecget-dashboard-center-icon-styling-7"
             x1="924.29999"
             y1="388.29999"
             x2="933.40002"
             y2="397.39999"
             id="line1048" />
          <line
             class="tecget-dashboard-center-icon-styling-7"
             x1="933.40002"
             y1="397.39999"
             x2="942.40002"
             y2="406.39999"
             id="line1050" />
          <line
             class="tecget-dashboard-center-icon-styling-7"
             x1="942.40002"
             y1="388.39999"
             x2="933.40002"
             y2="397.39999"
             id="line1052" />
          <line
             class="tecget-dashboard-center-icon-styling-7"
             x1="933.40002"
             y1="397.39999"
             x2="924.29999"
             y2="406.39999"
             id="line1054" />
        </g>
      </g>
    </g>
    <g
       id="g1088"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate">
      <path
         class="tecget-dashboard-center-icon-styling-69"
         d="m 886.8,223.5 c -9,-8.8 -23.7,-13.2 -44.1,-13.2 -20.4,0 -35.1,4.4 -44.1,13.2 -9,8.8 -13.5,21.9 -13.5,39.2 0,17.3 4.5,30.4 13.5,39.2 9,8.8 23.7,13.2 44.1,13.2 20.4,0 35.1,-4.4 44.1,-13.2 9,-8.8 13.5,-21.9 13.5,-39.2 0,-17.3 -4.5,-30.4 -13.5,-39.2"
         id="path1062" />
      <g
         id="g1086">
        <g
           id="g1070">
          <path
             class="tecget-dashboard-center-icon-styling-7"
             d="m 854.9,291.7 c -7.1,-4.4 7.1,-8.8 0,-13.2"
             id="path1064" />
          <path
             class="tecget-dashboard-center-icon-styling-7"
             d="m 842.7,291.7 c -7.1,-4.4 7.1,-8.8 0,-13.2"
             id="path1066" />
          <path
             class="tecget-dashboard-center-icon-styling-7"
             d="m 830.4,291.7 c -7.1,-4.4 7.1,-8.8 0,-13.2"
             id="path1068" />
        </g>
        <path
           class="tecget-dashboard-center-icon-styling-7"
           d="m 803.8,268.3 c 0,2 1.6,3.6 3.6,3.6 h 70.4 c 2,0 3.6,-1.6 3.6,-3.6 v -24.2 c 0,-2 -1.6,-3.6 -3.6,-3.6 h -70.4 c -2,0 -3.6,1.6 -3.6,3.6 z"
           id="path1072" />
        <circle
           class="tecget-dashboard-center-icon-styling-7"
           cx="871.70001"
           cy="249.7"
           r="2.7"
           id="circle1074" />
        <circle
           class="tecget-dashboard-center-icon-styling-7"
           cx="862.29999"
           cy="249.7"
           r="2.7"
           id="circle1076" />
        <path
           class="tecget-dashboard-center-icon-styling-7"
           d="m 813.3,271.5 2.1,-9.1 c 0.3,-1.5 1.7,-2.6 3.3,-2.6 h 49 c 1.6,0 2.9,1.1 3.3,2.6 l 2.1,9.1"
           id="path1078" />
        <line
           class="tecget-dashboard-center-icon-styling-7"
           x1="864.5"
           y1="265"
           x2="857.40002"
           y2="265"
           id="line1080" />
        <line
           class="tecget-dashboard-center-icon-styling-7"
           x1="828.90002"
           y1="265"
           x2="821.79999"
           y2="265"
           id="line1082" />
        <line
           class="tecget-dashboard-center-icon-styling-7"
           x1="852.59998"
           y1="265"
           x2="833.20001"
           y2="265"
           id="line1084" />
      </g>
    </g>
    <g
       id="g1120"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate">
      <path
         class="tecget-dashboard-center-icon-styling-69"
         d="m 773.5,142.5 c -9,-8.8 -23.7,-13.2 -44.1,-13.2 -20.4,0 -35.1,4.4 -44.1,13.2 -9,8.8 -13.5,21.9 -13.5,39.2 0,17.3 4.5,30.4 13.5,39.2 9,8.8 23.7,13.2 44.1,13.2 20.4,0 35.1,-4.4 44.1,-13.2 9,-8.8 13.5,-21.9 13.5,-39.2 0,-17.3 -4.5,-30.4 -13.5,-39.2"
         id="path1090" />
      <g
         id="g1118">
        <g
           id="g1102">
          <polygon
             class="tecget-dashboard-center-icon-styling-6"
             points="707.8,167.3 752.2,167.3 759.9,201.4 700.2,201.4 "
             id="polygon1092" />
          <line
             class="tecget-dashboard-center-icon-styling-6"
             x1="722.59998"
             y1="167.3"
             x2="720.09998"
             y2="201.39999"
             id="line1094" />
          <line
             class="tecget-dashboard-center-icon-styling-6"
             x1="737.40002"
             y1="167.3"
             x2="740"
             y2="201.39999"
             id="line1096" />
          <polyline
             class="tecget-dashboard-center-icon-styling-6"
             points="705.3 178.7 721.8 178.7 738.3 178.7 754.8 178.7"
             id="polyline1098" />
          <polyline
             class="tecget-dashboard-center-icon-styling-6"
             points="702.7 190.1 720.9 190.1 739.1 190.1 757.3 190.1"
             id="polyline1100" />
        </g>
        <g
           id="g1114">
          <line
             class="tecget-dashboard-center-icon-styling-6"
             x1="730"
             y1="146.2"
             x2="730"
             y2="149.39999"
             id="line1104" />
          <line
             class="tecget-dashboard-center-icon-styling-6"
             x1="745.40002"
             y1="161.60001"
             x2="742.20001"
             y2="161.60001"
             id="line1106" />
          <line
             class="tecget-dashboard-center-icon-styling-6"
             x1="717.79999"
             y1="161.60001"
             x2="714.59998"
             y2="161.60001"
             id="line1108" />
          <line
             class="tecget-dashboard-center-icon-styling-6"
             x1="740.90002"
             y1="150.7"
             x2="738.59998"
             y2="153"
             id="line1110" />
          <line
             class="tecget-dashboard-center-icon-styling-6"
             x1="721.40002"
             y1="153"
             x2="719.09998"
             y2="150.7"
             id="line1112" />
        </g>
        <path
           class="tecget-dashboard-center-icon-styling-6"
           d="m 722.8,161.2 c 0,-4 3.2,-7.2 7.2,-7.2 4,0 7.2,3.2 7.2,7.2"
           id="path1116" />
      </g>
    </g>
    <g
       id="g1140"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate">
      <path
         class="tecget-dashboard-center-icon-styling-69"
         d="m 616,179.1 c -9,-8.8 -23.7,-13.2 -44.1,-13.2 -20.4,0 -35.1,4.4 -44.1,13.2 -9,8.8 -13.5,21.9 -13.5,39.2 0,17.3 4.5,30.4 13.5,39.2 9,8.8 23.7,13.2 44.1,13.2 20.4,0 35.1,-4.4 44.1,-13.2 9,-8.8 13.5,-21.9 13.5,-39.2 0,-17.3 -4.5,-30.4 -13.5,-39.2"
         id="path1122" />
      <g
         id="g1138">
        <g
           id="g1130">
          <polyline
             class="tecget-dashboard-center-icon-styling-6"
             points="596 218.7 596 244.2 544.8 244.2 544.8 193 584.8 193"
             id="polyline1124" />
          <circle
             class="tecget-dashboard-center-icon-styling-6"
             cx="595.20001"
             cy="203.3"
             r="14.6"
             id="circle1126" />
          <polyline
             class="tecget-dashboard-center-icon-styling-6"
             points="597 195.3 591.9 204 599.5 204 594.7 212.6"
             id="polyline1128" />
        </g>
        <rect
           class="tecget-dashboard-center-icon-styling-6"
           x="550.5"
           y="202.2"
           width="19.9"
           height="9.6000004"
           rx="2.0017207"
           ry="2.0017207"
           id="rect1132" />
        <rect
           class="tecget-dashboard-center-icon-styling-6"
           x="551.59998"
           y="244.2"
           width="4.0999999"
           height="6.1999998"
           rx="0.85788023"
           ry="0.85788023"
           id="rect1134" />
        <rect
           class="tecget-dashboard-center-icon-styling-6"
           x="561.40002"
           y="244.3"
           width="4.0999999"
           height="6.1999998"
           rx="0.85788023"
           ry="0.85788023"
           id="rect1136" />
      </g>
    </g>
    <g
       id="g1166"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate">
      <path
         class="tecget-dashboard-center-icon-styling-69"
         d="m 478.7,238.6 c -9,-8.8 -23.7,-13.2 -44.1,-13.2 -20.4,0 -35.1,4.4 -44.1,13.2 -9,8.8 -13.5,21.9 -13.5,39.2 0,17.3 4.5,30.4 13.5,39.2 9,8.8 23.7,13.2 44.1,13.2 20.4,0 35.1,-4.4 44.1,-13.2 9,-8.8 13.5,-21.9 13.5,-39.2 0,-17.3 -4.5,-30.4 -13.5,-39.2"
         id="path1142" />
      <g
         id="g1164">
        <path
           class="tecget-dashboard-center-icon-styling-6"
           d="m 452.9,269.4 h 13.5 c 0.8,0 1.5,0.7 1.5,1.5 v 29.8 h -15 c -0.8,0 -1.5,-0.7 -1.5,-1.5 v -28.3 c 0,-0.8 0.7,-1.5 1.5,-1.5 z"
           id="path1144" />
        <rect
           class="tecget-dashboard-center-icon-styling-6"
           x="454.39999"
           y="263.5"
           width="10.6"
           height="5.8000002"
           id="rect1146" />
        <line
           class="tecget-dashboard-center-icon-styling-6"
           x1="467.89999"
           y1="300.70001"
           x2="404"
           y2="300.70001"
           id="line1148" />
        <rect
           class="tecget-dashboard-center-icon-styling-6"
           x="406.5"
           y="250.89999"
           width="23.700001"
           height="49.799999"
           id="rect1150" />
        <polyline
           class="tecget-dashboard-center-icon-styling-6"
           points="453.9 300.7 430.2 300.7 430.2 250.9 453.9 250.9 453.9 257.6"
           id="polyline1152" />
        <line
           class="tecget-dashboard-center-icon-styling-6"
           x1="456.5"
           y1="293"
           x2="462.89999"
           y2="293"
           id="line1154" />
        <line
           class="tecget-dashboard-center-icon-styling-6"
           x1="456.5"
           y1="285"
           x2="462.89999"
           y2="285"
           id="line1156" />
        <line
           class="tecget-dashboard-center-icon-styling-6"
           x1="456.5"
           y1="277"
           x2="462.89999"
           y2="277"
           id="line1158" />
        <polyline
           class="tecget-dashboard-center-icon-styling-6"
           points="419.1 266.8 415 275.3 421.5 275.3 417.7 282.6"
           id="polyline1160" />
        <polyline
           class="tecget-dashboard-center-icon-styling-6"
           points="442.8 266.8 438.7 275.3 445.2 275.3 441.4 282.6"
           id="polyline1162" />
      </g>
    </g>
    <g
       id="g1210"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none">
      <g
         id="g1174"
         style="stroke:none">
        <path
           class="tecget-dashboard-center-icon-styling-15"
           d="m 925,699.5 c 0,5.9 -18.4,10.7 -41,10.7 -22.6,0 -41,-4.8 -41,-10.7 0,-5.9 18.4,-10.7 41,-10.7 22.6,0 41,4.8 41,10.7 z"
           id="path1170"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-18"
           d="m 906.8,700.1 c 0,3.9 -13.8,7.1 -30.8,7.1 -17,0 -30.8,-3.2 -30.8,-7.1 0,-3.9 13.8,-7.1 30.8,-7.1 17,0 30.8,3.2 30.8,7.1 z"
           id="path1172"
           style="stroke:none" />
      </g>
      <path
         class="tecget-dashboard-center-icon-styling-45"
         d="m 885.9,690.7 c -0.9,-0.5 1,-6.3 1.2,-10.6 0,0 -4.5,8 -3.1,12.1 -2.1,1.5 -5.8,3.7 -8.2,4.9 -0.5,-6.6 -0.9,-11.2 -1.3,-14.3 0,-0.8 7.7,-14.7 7.3,-14.2 -3.2,4 -4.7,4.8 -7.4,9.6 -0.9,1.5 -2.9,-12.2 -2.9,-12.2 -1.1,0.9 0.2,10.3 -0.3,12.4 -0.3,1.3 -0.4,2.9 -0.5,4.6 0,1.9 -0.4,6.5 -0.6,8.4 -2,-0.5 -6,-5.1 -10.9,-14 0,0 3.8,15.3 10.3,17.2 v 2 c -8,-2.9 -22.2,-7 -28,-11.8 0,0 2.7,6.9 26.7,13.4 l 1,1.1 c 0,0 0,1.6 1.9,1.7 1.4,0 3.1,-0.2 3.9,0.9 0.8,1.2 1.6,-0.3 4,-1.8 0.8,-0.5 2.1,-1.9 2.1,-1.9 9.3,-7.1 19.4,-18.3 19.4,-18.3 -2.4,2.6 -12.4,8.9 -14.4,10.9 h -0.2 z"
         id="path1176"
         style="stroke:none" />
      <g
         id="g1208"
         style="stroke:none">
        <path
           class="tecget-dashboard-center-icon-styling-78"
           d="m 913.3,672.2 c -2.8,-2.6 -6.9,-3.2 -10.3,-1.6 -2,-7.1 -7.9,-12.5 -15.1,-13.5 2.2,-3.2 3.5,-7.2 3.4,-11.4 -0.3,-10.3 -8.7,-18.5 -18.8,-18.2 -9.5,0.3 -17.1,7.9 -17.7,17.5 -2.1,-0.8 -4.3,-1.2 -6.6,-1.1 -10.1,0.3 -18,8.9 -17.8,19.2 0,2.1 0.5,4.1 1.2,6 -1.6,2.9 -2.5,6.2 -2.4,9.7 0.3,10.3 8.7,18.5 18.8,18.2 3.2,0 6.1,-1 8.7,-2.5 0.2,0.2 0.3,0.3 0.4,0.5 4.6,4.3 11.9,4 16.3,-0.7 0.9,-0.9 1.5,-1.9 2,-3 3,2 6.7,3.2 10.5,3.1 2.3,0 4.5,-0.6 6.5,-1.4 0.3,1.3 0.9,2.5 2,3.5 2.8,2.6 7.2,2.4 9.9,-0.5 1.8,-2 2.3,-4.6 1.6,-7 2.8,0.2 5.7,-0.9 7.8,-3.1 3.7,-3.9 3.5,-10 -0.3,-13.6 h -0.1 z"
           id="path1178"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 878.5,638.2 c 0.5,2.4 -1.6,4.5 -4,4 -2.4,-0.5 -2.4,-1.3 -2.7,-2.7 -0.4,-2.4 1.6,-4.4 4,-4 2.4,0.4 2.4,1.3 2.7,2.6 v 0 z"
           id="path1180"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 870.6,637.3 c 0,0.9 -0.7,1.6 -1.6,1.6 -0.9,0 -1.6,-0.7 -1.6,-1.6 0,-0.9 0.7,-1.6 1.6,-1.6 0.9,0 1.6,0.7 1.6,1.6 z"
           id="path1182"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 908,673.3 c 0,0.9 -0.7,1.6 -1.6,1.6 -0.9,0 -1.6,-0.7 -1.6,-1.6 0,-0.9 0.7,-1.6 1.6,-1.6 0.9,0 1.6,0.7 1.6,1.6 z"
           id="path1184"
           style="stroke:none" />
        <g
           class="tecget-dashboard-center-icon-styling-65"
           id="g1198"
           style="stroke:none">
          <path
             class="tecget-dashboard-center-icon-styling-47"
             d="m 848,697.1 c 3.2,0 6.1,-1 8.7,-2.5 0.2,0.2 0.3,0.3 0.4,0.5 4.6,4.3 11.9,4 16.3,-0.7 0.9,-0.9 1.5,-1.9 2,-3 3,2 6.7,3.2 10.5,3.1 2.3,0 4.5,-0.6 6.5,-1.4 0.3,1.3 0.9,2.5 2,3.5 2.8,2.6 7.2,2.4 9.9,-0.5 1.8,-2 2.3,-4.6 1.6,-7 2.8,0.2 5.7,-0.9 7.8,-3.1 3.1,-3.4 3.5,-8.3 1.1,-11.9 -1.2,2.9 -2.9,6.4 -4.7,7.9 -3.3,2.7 -6.9,-3.4 -10.2,-6.6 -3.3,-3.3 -4.8,0.3 -9.4,2.6 -4.6,2.3 -9.1,-1.8 -16,-4 -6.9,-2.2 -19,7.6 -22.9,8.9 -3.9,1.3 -9.8,4.9 -17,1.6 -2.3,-1 -4,-2.5 -5.2,-4 1,9.6 9.1,17 18.7,16.7 v 0 z"
             id="path1186"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 888.5,671.8 c 0.5,2.8 -1.9,5.1 -4.6,4.6 -2.7,-0.5 -2.8,-1.5 -3.1,-3.1 -0.5,-2.8 1.8,-5.1 4.6,-4.6 2.8,0.5 2.8,1.5 3.1,3.1 z"
             id="path1188"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 844.1,667.5 c 0.4,2.3 -1.6,4.3 -3.9,3.9 -2.3,-0.4 -2.3,-1.3 -2.6,-2.6 -0.4,-2.3 1.5,-4.3 3.9,-3.9 1.3,0.2 2.3,1.3 2.6,2.6 z"
             id="path1190"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 893.3,671.4 c 0,1 -0.8,1.8 -1.8,1.8 -1,0 -1.8,-0.8 -1.8,-1.8 0,-1 0.8,-1.8 1.8,-1.8 1,0 1.8,0.8 1.8,1.8 z"
             id="path1192"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 836,667.8 c 0,1 -0.8,1.8 -1.8,1.8 -1,0 -1.8,-0.8 -1.8,-1.8 0,-1 0.8,-1.8 1.8,-1.8 1,0 1.8,0.8 1.8,1.8 z"
             id="path1194"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 846,662.8 c 0,1 -0.8,1.8 -1.8,1.8 -1,0 -1.8,-0.8 -1.8,-1.8 0,-1 0.8,-1.8 1.8,-1.8 1,0 1.8,0.8 1.8,1.8 z"
             id="path1196"
             style="stroke:none" />
        </g>
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 872.5,627.5 c -9.5,0.3 -17.1,7.9 -17.7,17.5 -2.1,-0.8 -4.3,-1.2 -6.6,-1.1 -7,0.2 -13,4.4 -15.9,10.4 7.9,-5.9 20.2,-4.2 26.2,-2.9 0.5,0 1,0 1.2,-0.5 0.3,-0.4 0.2,-1 0,-1.3 l -1.9,-2.2 c -0.6,-0.7 -0.7,-1.6 -0.2,-2.4 2.6,-4.4 12.6,-18.2 30.4,-9.6 -3.4,-4.9 -9.1,-8.1 -15.4,-7.9 v 0 z"
           id="path1200"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 887.9,657 c -10.1,1.1 -17.3,6.7 -17.3,6.7 0,0 11.6,-3.3 22.1,-2.3 1.5,0.2 3.9,0.7 6.2,1.6 -2.8,-3.2 -6.7,-5.4 -11.1,-6 v 0 z"
           id="path1202"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-78"
           d="m 867.9,682 c 0.5,2.4 -1.6,4.4 -4,4 -2.4,-0.4 -2.4,-1.3 -2.7,-2.7 -0.5,-2.4 1.6,-4.5 4,-4 1.3,0.3 2.4,1.3 2.7,2.7 z"
           id="path1204"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-78"
           d="m 869,677 c 0,0.9 -0.7,1.6 -1.6,1.6 -0.9,0 -1.6,-0.7 -1.6,-1.6 0,-0.9 0.7,-1.6 1.6,-1.6 0.9,0 1.6,0.7 1.6,1.6 z"
           id="path1206"
           style="stroke:none" />
      </g>
    </g>
    <g
       id="g1252"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none">
      <g
         id="g1216"
         style="stroke:none">
        <path
           class="tecget-dashboard-center-icon-styling-15"
           d="m 592.1,853.2 c 0,5.9 -18.4,10.7 -41,10.7 -22.6,0 -41,-4.8 -41,-10.7 0,-5.9 18.4,-10.7 41,-10.7 22.6,0 41,4.8 41,10.7 z"
           id="path1212"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-18"
           d="m 573.9,853.8 c 0,3.9 -13.8,7.1 -30.8,7.1 -17,0 -30.8,-3.2 -30.8,-7.1 0,-3.9 13.8,-7.1 30.8,-7.1 17,0 30.8,3.2 30.8,7.1 z"
           id="path1214"
           style="stroke:none" />
      </g>
      <path
         class="tecget-dashboard-center-icon-styling-45"
         d="m 553,844.4 c -0.9,-0.5 1,-6.3 1.2,-10.6 0,0 -4.5,8 -3.1,12.1 -2.1,1.5 -5.8,3.7 -8.2,4.9 -0.5,-6.6 -0.9,-11.2 -1.3,-14.3 0,-0.8 7.7,-14.7 7.3,-14.2 -3.2,4 -4.7,4.8 -7.4,9.6 -0.9,1.5 -2.9,-12.2 -2.9,-12.2 -1.1,0.9 0.2,10.3 -0.3,12.4 -0.3,1.3 -0.4,2.9 -0.5,4.6 0,1.9 -0.4,6.5 -0.6,8.4 -2,-0.5 -6,-5.1 -10.9,-14 0,0 3.8,15.3 10.3,17.2 v 2 c -8,-2.9 -22.2,-7 -28,-11.8 0,0 2.7,6.9 26.7,13.4 l 1,1.1 c 0,0 0,1.6 1.9,1.7 1.4,0 3.1,-0.2 3.9,0.9 0.8,1.2 1.6,-0.3 4,-1.8 0.8,-0.5 2.1,-1.9 2.1,-1.9 9.3,-7.1 19.4,-18.3 19.4,-18.3 -2.4,2.6 -12.4,8.9 -14.4,10.9 H 553 Z"
         id="path1218"
         style="stroke:none" />
      <g
         id="g1250"
         style="stroke:none">
        <path
           class="tecget-dashboard-center-icon-styling-78"
           d="m 580.4,825.9 c -2.8,-2.6 -6.9,-3.2 -10.3,-1.6 -2,-7.1 -7.9,-12.5 -15.1,-13.5 2.2,-3.2 3.5,-7.2 3.4,-11.4 -0.3,-10.3 -8.7,-18.5 -18.8,-18.2 -9.5,0.3 -17.1,7.9 -17.7,17.5 -2.1,-0.8 -4.3,-1.2 -6.6,-1.1 -10.1,0.3 -18,8.9 -17.8,19.2 0,2.1 0.5,4.1 1.2,6 -1.6,2.9 -2.5,6.2 -2.4,9.7 0.3,10.3 8.7,18.5 18.8,18.2 3.2,0 6.1,-1 8.7,-2.5 0.2,0.2 0.3,0.3 0.4,0.5 4.6,4.3 11.9,4 16.3,-0.7 0.9,-0.9 1.5,-1.9 2,-3 3,2 6.7,3.2 10.5,3.1 2.3,0 4.5,-0.6 6.5,-1.4 0.3,1.3 0.9,2.5 2,3.5 2.8,2.6 7.2,2.4 9.9,-0.5 1.8,-2 2.3,-4.6 1.6,-7 2.8,0.2 5.7,-0.9 7.8,-3.1 3.7,-3.9 3.5,-10 -0.3,-13.6 h -0.1 z"
           id="path1220"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 545.6,791.8 c 0.5,2.4 -1.6,4.5 -4,4 -2.4,-0.5 -2.4,-1.3 -2.7,-2.7 -0.4,-2.4 1.6,-4.4 4,-4 2.4,0.4 2.4,1.3 2.7,2.6 v 0 z"
           id="path1222"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 537.7,790.9 c 0,0.9 -0.7,1.6 -1.6,1.6 -0.9,0 -1.6,-0.7 -1.6,-1.6 0,-0.9 0.7,-1.6 1.6,-1.6 0.9,0 1.6,0.7 1.6,1.6 z"
           id="path1224"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 575.1,826.9 c 0,0.9 -0.7,1.6 -1.6,1.6 -0.9,0 -1.6,-0.7 -1.6,-1.6 0,-0.9 0.7,-1.6 1.6,-1.6 0.9,0 1.6,0.7 1.6,1.6 z"
           id="path1226"
           style="stroke:none" />
        <g
           class="tecget-dashboard-center-icon-styling-65"
           id="g1240"
           style="stroke:none">
          <path
             class="tecget-dashboard-center-icon-styling-47"
             d="m 515,850.7 c 3.2,0 6.1,-1 8.7,-2.5 0.2,0.2 0.3,0.3 0.4,0.5 4.6,4.3 11.9,4 16.3,-0.7 0.9,-0.9 1.5,-1.9 2,-3 3,2 6.7,3.2 10.5,3.1 2.3,0 4.5,-0.6 6.5,-1.4 0.3,1.3 0.9,2.5 2,3.5 2.8,2.6 7.2,2.4 9.9,-0.5 1.8,-2 2.3,-4.6 1.6,-7 2.8,0.2 5.7,-0.9 7.8,-3.1 3.1,-3.4 3.5,-8.3 1.1,-11.9 -1.2,2.9 -2.9,6.4 -4.7,7.9 -3.3,2.7 -6.9,-3.4 -10.2,-6.6 -3.3,-3.3 -4.8,0.3 -9.4,2.6 -4.6,2.3 -9.1,-1.8 -16,-4 -6.9,-2.2 -19,7.6 -22.9,8.9 -3.9,1.3 -9.8,4.9 -17,1.6 -2.3,-1 -4,-2.5 -5.2,-4 1,9.6 9.1,17 18.7,16.7 v 0 z"
             id="path1228"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 555.5,825.5 c 0.5,2.8 -1.9,5.1 -4.6,4.6 -2.7,-0.5 -2.8,-1.5 -3.1,-3.1 -0.5,-2.8 1.8,-5.1 4.6,-4.6 2.8,0.5 2.8,1.5 3.1,3.1 z"
             id="path1230"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 511.2,821.1 c 0.4,2.3 -1.6,4.3 -3.9,3.9 -2.3,-0.4 -2.3,-1.3 -2.6,-2.6 -0.4,-2.3 1.5,-4.3 3.9,-3.9 2.4,0.4 2.3,1.3 2.6,2.6 z"
             id="path1232"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 560.4,825.1 c 0,1 -0.8,1.8 -1.8,1.8 -1,0 -1.8,-0.8 -1.8,-1.8 0,-1 0.8,-1.8 1.8,-1.8 1,0 1.8,0.8 1.8,1.8 z"
             id="path1234"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 503.1,821.5 c 0,1 -0.8,1.8 -1.8,1.8 -1,0 -1.8,-0.8 -1.8,-1.8 0,-1 0.8,-1.8 1.8,-1.8 1,0 1.8,0.8 1.8,1.8 z"
             id="path1236"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-22"
             d="m 513.1,816.5 c 0,1 -0.8,1.8 -1.8,1.8 -1,0 -1.8,-0.8 -1.8,-1.8 0,-1 0.8,-1.8 1.8,-1.8 1,0 1.8,0.8 1.8,1.8 z"
             id="path1238"
             style="stroke:none" />
        </g>
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 539.6,781.1 c -9.5,0.3 -17.1,7.9 -17.7,17.5 -2.1,-0.8 -4.3,-1.2 -6.6,-1.1 -7,0.2 -13,4.4 -15.9,10.4 7.9,-5.9 20.2,-4.2 26.2,-2.9 0.5,0 1,0 1.2,-0.5 0.3,-0.4 0.2,-1 0,-1.3 l -1.9,-2.2 c -0.6,-0.7 -0.7,-1.6 -0.2,-2.4 2.6,-4.4 12.6,-18.2 30.4,-9.6 -3.4,-4.9 -9.1,-8.1 -15.4,-7.9 v 0 z"
           id="path1242"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-14"
           d="m 555,810.7 c -10.1,1.1 -17.3,6.7 -17.3,6.7 0,0 11.6,-3.3 22.1,-2.3 1.5,0.2 3.9,0.7 6.2,1.6 -2.8,-3.2 -6.7,-5.4 -11.1,-6 v 0 z"
           id="path1244"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-78"
           d="m 535,835.7 c 0.5,2.4 -1.6,4.4 -4,4 -2.4,-0.4 -2.4,-1.3 -2.7,-2.7 -0.5,-2.4 1.6,-4.5 4,-4 2.4,0.5 2.4,1.3 2.7,2.7 z"
           id="path1246"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-78"
           d="m 536.1,830.6 c 0,0.9 -0.7,1.6 -1.6,1.6 -0.9,0 -1.6,-0.7 -1.6,-1.6 0,-0.9 0.7,-1.6 1.6,-1.6 0.9,0 1.6,0.7 1.6,1.6 z"
           id="path1248"
           style="stroke:none" />
      </g>
    </g>
    <g
       id="g1334"
       transform="matrix(1.0490975,0,0,1.0490975,-26.51265,-26.51265)"
       style="isolation:isolate;stroke:none">
      <path
         class="tecget-dashboard-center-icon-styling-59"
         d="m 190.5,821 c 4.1,2.1 13.9,7 4,9.8 -9.9,2.8 -22.6,6.5 -36.3,4 -13.6,-2.5 -19.9,-8.3 -3,-15.9 12.4,-5.6 24.4,-3.4 35.2,2.1 z"
         id="path1254"
         style="stroke:none" />
      <path
         class="tecget-dashboard-center-icon-styling-21"
         d="m 182.1,824.4 c 3.3,2.7 6.7,3.3 2.8,4.5 -3.9,1.2 -5.1,0.9 -8.9,0.9 -3.8,0 -2.6,0.4 -5.3,1.5 -4.7,1.8 -8.9,3.4 -12.7,0.5 -3.8,-2.9 -6.4,-5.5 -1.2,-7.7 5.1,-2.3 6.8,-0.2 10.7,-0.4 3.9,-0.2 -0.8,-3.4 9.1,-2.4 2.5,0.3 5.6,3.3 5.6,3.3 v -0.2 z"
         id="path1256"
         style="stroke:none" />
      <g
         id="g1332"
         style="stroke:none">
        <path
           class="tecget-dashboard-center-icon-styling-50"
           d="m 181.7,750.5 c 0,0 -0.7,1.1 -1.2,1.5 -0.5,0.5 -0.7,1.8 -0.8,2.7 -0.2,1 -0.3,1.4 0.6,1.1 0.9,-0.3 1.3,-2.2 1.3,-2.2 l -0.2,2.4 -0.6,2.3 c 0,0 -0.3,0.8 0.1,1 0.4,0.2 1.6,0.3 2.3,0.2 0.7,-0.1 1.9,-1.3 1.9,-1.3 l 1,-2.8 c 0,0 0.2,-3.2 -0.5,-5.4 -0.7,-2.2 -0.7,-3.2 -0.7,-3.2 l -2.5,0.2 z"
           id="path1258"
           style="stroke:none" />
        <g
           id="g1266"
           style="stroke:none">
          <path
             class="tecget-dashboard-center-icon-styling-41"
             d="m 176.5,697.4 c 3.5,1 8.4,2.5 8.4,12.5 0,10 0.3,6.8 0.8,12.6 0.2,3 0.5,9 0.3,10.1 -0.8,6.8 -0.5,16.7 -0.5,16.7 -0.1,1.7 -5.6,2 -5.5,-1.9 0,-1.9 -2.9,-5 -3,-5.9 0,-1.1 0.3,-6.1 0.3,-6.1 l 0.9,-3.7 V 726 l 1,-13.5 -2.7,-15.2 v 0 z"
             id="path1260"
             style="stroke:none" />
          <g
             class="tecget-dashboard-center-icon-styling-56"
             clip-path="url(#clippath-2)"
             id="g1264"
             style="stroke:none">
            <path
               class="tecget-dashboard-center-icon-styling-60"
               d="m 184.2,751.6 c 0,0 -0.4,-2.6 -0.6,-5.8 -0.1,-3.2 0,-4.9 0,-7.7 0,-2.8 0.2,-4.1 0,-5.7 -0.2,-1.6 0.8,-1.7 0.3,-4.5 -0.5,-2.8 0.7,-7.4 -0.3,-9.6 -1,-2.2 0.6,-12.5 -2.7,-15.4 -3.3,-2.9 -3,-2 -3,-2 0,0 -1.1,31.7 -1.3,32.4 -0.2,0.7 1.6,19.9 1.6,19.9 z"
               id="path1262"
               style="stroke:none" />
          </g>
        </g>
        <path
           class="tecget-dashboard-center-icon-styling-12"
           d="m 162.1,820.5 c 0,0 1.5,3.8 2.3,4.7 0.8,0.9 1.9,3.4 2,4 0.1,0.6 0.4,2.3 -0.2,2.8 -0.5,0.5 -4.1,1.3 -7.2,-0.6 -3.1,-1.9 -4.4,-5 -5,-5.6 -0.6,-0.6 -0.4,-5.8 -0.4,-6.8 0,-1 8.1,-1.4 8.1,-1.4 z"
           id="path1268"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-12"
           d="m 169.7,816.1 c 0,0 -0.4,4.8 -0.4,5.3 0,0.5 1.3,1.8 2.8,2.1 1.4,0.3 2.4,0.9 3.1,1.7 2,2.1 5.3,3.1 6.6,3.5 1.3,0.4 3.9,-0.4 3.8,-2.5 -0.1,-2.1 -4,-4.4 -4.6,-5.2 -0.6,-0.8 -1.8,-3 -2.1,-3.9 -0.3,-0.9 -1.3,-3.4 -1.3,-3.4 h -6.4 l -1.4,2.5 h -0.1 z"
           id="path1270"
           style="stroke:none" />
        <g
           id="g1278"
           style="stroke:none">
          <path
             class="tecget-dashboard-center-icon-styling-39"
             d="m 163.3,821.5 c 0,0 -1.1,-0.3 -2.8,-0.2 -1.7,0.2 -5.1,2 -5.9,1.7 -0.8,-0.3 -2,-1.4 -2,-1.4 0,0 -1.1,-13 -1.1,-15.5 0,-2.5 -0.8,-12.5 -0.6,-14.6 0.2,-2 0.5,-4.3 0.3,-5.6 -0.2,-1.3 0.3,-20.4 -0.2,-23.7 -0.5,-3.3 -0.6,-8.7 -0.4,-13.2 0.2,-4.5 2.3,-10.3 2.3,-10.3 0,0 2.2,3.2 6.5,3.4 4.3,0.2 13.2,0.5 16.3,-0.6 3.1,-1.1 3.6,-2.8 3.6,-2.8 0,0 2.6,13.2 2.8,15.5 0.2,2.3 -1.4,25.1 -1.5,28 -0.2,2.9 -1.5,6 -1.4,8.1 0.2,2 -1.2,17.5 -1.2,19.2 0,1.7 1.5,2.5 1.4,3.7 -0.2,1.2 0.3,3.9 -2,3.9 -2.3,0 -4.2,2.2 -5.6,2.3 -1.4,0.1 -3.3,-0.8 -3.3,-0.8 0,0 0.2,-2.5 0.6,-4.5 0.5,-2 0.3,-4 0.5,-5 0.2,-0.9 -1.1,-13.5 -1.1,-16.6 0,-3.1 0.8,-6.5 0.5,-7.7 -0.3,-1.2 -1.5,-18.6 -1.5,-18.6 0,0 -4.3,19.7 -4.5,21.8 -0.2,2.2 -1.1,4.8 -0.8,6.8 0.3,2 -0.7,22.5 -0.3,22.6 0.4,0.2 1.6,3.9 1.6,3.9 z"
             id="path1272"
             style="stroke:none" />
          <g
             class="tecget-dashboard-center-icon-styling-54"
             clip-path="url(#clippath-3)"
             id="g1276"
             style="stroke:none">
            <path
               class="tecget-dashboard-center-icon-styling-16"
               d="m 155.5,746.3 c 0,0 0.5,3.2 -0.9,6.1 -1.4,2.9 -1.6,5.6 -1.6,5.6 0,0 1.7,18 1.6,21.8 0,3.8 0,7.1 -0.3,8.7 -0.3,1.6 1.2,5.1 0,6.6 -1.2,1.6 -1.1,22.1 1,23.7 2.1,1.6 7.5,0 8.7,0 1.2,0 3.3,-52.6 3.3,-52.6 l 0.7,21.9 c 0,0 3.8,3.2 3.6,6.3 -0.2,3 1.5,10.2 1.1,11.9 -0.4,1.7 0.8,6.8 1.1,8.2 0.4,1.4 4.2,1.8 5.7,0.3 1.5,-1.5 1.7,-24.8 2.5,-30 0.8,-5.2 -2.5,-15.9 -2.5,-20.4 0,-4.5 3.2,-9.1 1,-12.5 -2.3,-3.4 -4,-12.6 -4,-12.6 l -15.2,-0.3 -5.8,7.2 v 0 z"
               id="path1274"
               style="stroke:none" />
          </g>
        </g>
        <g
           id="g1286"
           style="stroke:none">
          <path
             class="tecget-dashboard-center-icon-styling-41"
             d="m 148.5,714.3 c -0.6,-3.7 -2.5,-11.6 -0.9,-13.3 1.5,-1.7 7.1,-3.5 7.1,-3.5 l 2.4,-3.5 2.5,-0.4 h 2.2 l 4.7,0.8 3.4,0.7 2.3,-0.7 2.6,2.4 6.3,2.7 c 0,0 -1.7,7.2 -0.7,10.7 0.9,3.6 0,10.8 -0.8,12.4 -0.8,1.5 1,3.2 0.7,5.7 -0.3,2.5 -0.3,4.5 0.5,6 0.8,1.5 -1.1,2.8 -1.4,4.5 0,0 0.3,0.8 -2.4,2.6 -2.6,1.9 -6.7,1.8 -11.6,1.8 -4.9,0 -12.7,-2.7 -12.7,-2.7 0,0 -1.4,-2.5 -1.4,-3.3 0,-0.8 0.4,-2.2 0.9,-2.2 -0.4,-0.5 -0.9,-1.5 -0.9,-2.2 0,-1.2 1.2,-1.9 1.1,-5.9 -0.2,-4 -3.3,-9 -3.9,-12.7 v 0 z"
             id="path1280"
             style="stroke:none" />
          <g
             class="tecget-dashboard-center-icon-styling-55"
             clip-path="url(#clippath-4)"
             id="g1284"
             style="stroke:none">
            <path
               class="tecget-dashboard-center-icon-styling-41"
               d="m 149.5,708.8 c 1.7,-3.5 1.4,-3.5 2.7,-5.9 1.3,-2.4 -0.8,-1.9 2.5,-3.1 3.3,-1.2 17.1,-2.1 19.2,-1.1 2.1,1 3.3,0.5 4.8,2.2 1.1,1.2 3,1.9 2.6,7.3 -0.4,5.4 0.9,14 -0.9,18.1 -1.9,4.1 -4.8,5.5 -2.1,5.5 2.7,0 6.3,3.8 3,5 -3.3,1.3 -7.6,3.2 -4.8,2.5 2.8,-0.6 4.5,2.2 1.7,4.3 -2.8,2.1 -12.9,3.4 -15.5,3 -2.6,-0.4 -16.4,-2.6 -13.2,-4.5 3.2,-1.9 4.4,0 6.7,-2.6 2.3,-2.7 4.7,-6 0,-7 -4.7,-1 -6.9,-2.9 -3.9,-5.8 3.1,-2.9 6.2,-2.4 3.9,-4.4 -2.3,-2 -6.7,-13.7 -6.7,-13.7 z"
               id="path1282"
               style="stroke:none" />
          </g>
        </g>
        <path
           class="tecget-dashboard-center-icon-styling-41"
           d="m 179.3,739.7 c 0,0 -2.6,3.7 -8.4,4.1 -5.9,0.5 -14.1,-1 -18.3,-2.4 l -0.5,1.8 c 5.3,2.7 12.6,3.3 18.7,3 4.9,-0.3 8.7,-3.3 8.7,-5.1 l -0.3,-1.3 h 0.1 z"
           id="path1288"
           style="stroke:none" />
        <rect
           class="tecget-dashboard-center-icon-styling-58"
           x="159"
           y="745.20001"
           width="3.3"
           height="0.5"
           transform="rotate(-79.4,160.64618,745.41535)"
           id="rect1290"
           style="stroke:none" />
        <rect
           class="tecget-dashboard-center-icon-styling-58"
           x="152.8"
           y="743.59998"
           width="3.5"
           height="0.5"
           transform="rotate(-72.6,154.5485,743.87151)"
           id="rect1292"
           style="stroke:none" />
        <rect
           class="tecget-dashboard-center-icon-styling-58"
           x="174.7"
           y="742.5"
           width="0.5"
           height="3.5999999"
           transform="rotate(-13,174.83511,744.07748)"
           id="rect1294"
           style="stroke:none" />
        <rect
           class="tecget-dashboard-center-icon-styling-58"
           x="177.60001"
           y="740.70001"
           width="0.5"
           height="3.0999999"
           transform="rotate(-12.8,178.09506,742.16607)"
           id="rect1296"
           style="stroke:none" />
        <polygon
           class="tecget-dashboard-center-icon-styling-8"
           points="171.8,743.5 168.5,743.6 168.5,746.8 171.7,746.5 "
           id="polygon1298"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-61"
           d="m 165.8,707.2 c 0,0 2.1,-2.3 3.7,2.8 0.3,1.1 1,6.8 1,8.1 0,1.3 0.2,2.6 -0.1,5 -0.3,2.4 -0.5,8.2 -0.4,9.3 0.1,1.1 1,2.3 1.1,3.7 0.1,1.4 1.4,1.2 0.6,2.4 -0.8,1.2 -2.6,2.4 -2.8,3 -0.2,0.6 0,1.5 0,1.5 h 0.9 c 0,0 -0.2,-0.6 0,-1.1 0.2,-0.5 1.7,-2.3 2.3,-3.3 0.6,-1 0,-1.7 -0.2,-2.6 -0.2,-0.9 -0.8,-3.2 -0.8,-6.4 0,-3.2 -0.2,-5.2 0,-6 0.1,-0.8 0.8,-4.2 0.6,-5.8 -0.2,-1.5 0,-6.5 0.2,-9.7 0.3,-3.2 1.9,-2.7 1.9,-2.7 l -0.9,-2.8 -15.4,-6.7 -3,1.5 c 0,0 3.4,4.5 6.3,6.8 2.9,2.3 4.9,2.9 4.9,2.9 v 0 z"
           id="path1300"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-46"
           d="m 155.5,698 c 0,0 3,-1.8 4.4,-5.6 0.8,-2.2 0.9,-6.4 0.9,-6.4 l 6.7,0.3 c 0,0 3.4,0 4,1.2 0.9,1.7 0,5.2 0.6,6.8 0.6,1.6 2.8,3.2 2.8,3.2 l -3,5 -1.5,6.3 -2.4,-5.9 -12.5,-5 v 0 z"
           id="path1302"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-50"
           d="m 159.2,688.2 c 0,0 -1.3,-2.9 -1.5,-5.5 -1.3,-16.8 13.4,-10.9 15.4,-8.4 2,2.6 2.3,6.6 2.3,7.6 0,1 -0.2,2.4 -0.2,2.4 0,0 -0.4,1 -0.4,1.5 0,0.5 0.3,1.4 0,2.5 -0.2,1.1 -0.6,2 -1,3 -0.9,2.5 -1.9,4.4 -2.8,4.5 -1.6,0 -2.6,0.4 -4,-0.3 -2.4,-1.3 -6.4,-6.1 -6.4,-6.1 l -1.3,-1.3 h -0.1 z"
           id="path1304"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-40"
           d="m 174.8,680.3 c 0,0 0.2,-3.4 -1.4,-2.5 -1.5,0.9 -0.9,2.2 -2.3,2 -1.4,-0.2 -8.2,-4.2 -8.1,-1.2 0.2,2.9 -0.8,4.8 -0.9,5.3 -0.1,0.5 -0.8,2.5 -0.8,2.5 l -1.5,-4 c 0,0 -2.2,-1.1 -2.2,0.4 0,1.5 0.6,3.4 0.6,3.4 0,0 -1.9,-2.8 -2,-6.7 -0.2,-3.9 1.4,-7.4 4.3,-8.7 2.9,-1.2 5,-0.8 5,-0.8 0,0 1.4,-1.5 4.2,-0.3 2.8,1.2 5.9,3.1 5.9,5.9 0,2.8 -0.8,4.8 -0.8,4.8 v 0 z"
           id="path1306"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-41"
           d="m 158.6,693.6 c -0.8,0.6 -1.7,1.5 0.7,3.3 2.4,1.8 8.7,6 8.7,6 l -2.4,3.4 c 0,0 -10.3,-6.5 -11,-8.8 l 2.4,-3.5 1.7,-0.3 v 0 z"
           id="path1308"
           style="stroke:none" />
        <path
           class="tecget-dashboard-center-icon-styling-41"
           d="m 172.2,694.3 c 1.5,1 0.5,6.6 -0.2,8.2 l 1.9,2.8 c 1,-3.8 1.6,-7.2 1,-9 l -2.6,-2 v 0 z"
           id="path1310"
           style="stroke:none" />
        <g
           id="g1316"
           style="stroke:none">
          <path
             class="tecget-dashboard-center-icon-styling-40"
             d="m 177.7,720.7 -0.4,-0.3 c -0.2,-0.2 -0.5,-0.2 -0.7,-0.2 l -5.8,0.7 c -0.6,0 -1.1,0.5 -1.4,1.1 l -3.8,9.2 v 0.7 l 0.3,0.5 11.9,-11.7 z"
             id="path1312"
             style="stroke:none" />
          <path
             class="tecget-dashboard-center-icon-styling-45"
             d="m 177.4,720.6 -6.5,0.9 c -0.5,0 -1,0.4 -1.2,0.9 l -3.8,9.3 c -0.2,0.5 0.2,1.1 0.8,1 l 5.7,-1.6 5.4,-10.1 c 0.1,-0.3 0,-0.6 -0.4,-0.5 v 0 z"
             id="path1314"
             style="stroke:none" />
        </g>
        <path
           class="tecget-dashboard-center-icon-styling-50"
           d="m 174.2,725.6 -3.5,1.1 -2.9,-1 c 0.3,-1 1.1,-2.1 1.1,-2.8 0,-1.1 -1.3,0.2 -1.9,0.7 -0.3,0.3 -2.5,2.8 -2.8,3.5 l -1.9,0.5 -4.4,0.7 0.5,5 c 0,0 4.5,-0.4 6.1,-0.7 0.7,0 5.5,0.7 5.5,0.7 l 4.1,-2.4 c 0,0 2.5,-4.2 2.9,-6.3 0.4,-2.1 -2.9,1.1 -2.9,1.1 v 0 z"
           id="path1318"
           style="stroke:none" />
        <g
           id="g1330"
           style="stroke:none">
          <path
             class="tecget-dashboard-center-icon-styling-41"
             d="m 147.5,700.9 c 0,0 -1.8,1.1 -2.9,3.4 -2.9,6 -3.3,12.9 -3.6,15 -0.3,2.2 -1.8,9.2 -1.9,11.4 0,1.5 -0.3,3.6 -0.2,4.1 1,2.7 3.1,4.8 9.3,4.5 6.2,-0.3 9.5,-3.3 11.1,-3.6 1.5,-0.3 4.1,-2.3 4.1,-2.3 -1.7,-1.9 -3.9,-4.4 -1.1,-6.4 h -2.2 l -10.4,1.2 c 0,0 1.9,-2.3 2.2,-5.6 0.3,-3.3 -0.2,-12.7 -0.6,-13.8 -0.5,-1.1 -3.7,-8.1 -3.7,-8.1 v 0.2 z"
             id="path1320"
             style="stroke:none" />
          <g
             class="tecget-dashboard-center-icon-styling-57"
             clip-path="url(#clippath-5)"
             id="g1328"
             style="stroke:none">
            <g
               id="g1326"
               style="stroke:none">
              <path
                 class="tecget-dashboard-center-icon-styling-41"
                 d="m 151.2,705.3 c 0,0 -3.7,6.4 -5,10.5 -1.3,4.1 -2.4,9.3 -0.4,10.9 2,1.5 3.9,1.7 3.9,1.7 0,0 3.7,-1.8 4.2,-3.1 0.5,-1.3 -0.6,-12.5 -0.6,-13.4 0,-0.9 -2.1,-6.5 -2.1,-6.5 v 0 z"
                 id="path1322"
                 style="stroke:none" />
              <path
                 class="tecget-dashboard-center-icon-styling-41"
                 d="m 138.1,727.9 c 0,0 1.6,4.4 3.1,5.4 1.6,1 2.7,1.4 7.9,0 5.2,-1.4 10,-2 11.1,-2.6 1.1,-0.5 3.4,-0.3 3.4,-0.3 l 1.1,2.1 c 0,0 -8.3,6.9 -8.4,7.2 0,0.3 -10,2.4 -10,2.4 l -8.2,-0.7 c 0,0 -2,-6.4 -1.8,-6.4 0.2,0 1.8,-7.1 1.8,-7.1 z"
                 id="path1324"
                 style="stroke:none" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
  `
]
export const factory = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .factory-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g3"
     transform="matrix(0.43525571,0,0,0.43525571,-14.173014,-18.824809)">
    <polygon
       class="factory-styling"
       points="140.7,95.2 132.1,45 117.4,45 106.8,95.5 97.1,95.5 97.1,71.9 68.8,95.5 68.8,71.9 39.3,95.5 39.3,133.4 140.7,133.4 "
       id="polygon1" />
    <rect
       class="factory-styling"
       x="55"
       y="106"
       width="15.6"
       height="15.6"
       id="rect1" />
    <rect
       class="factory-styling"
       x="82.199997"
       y="106"
       width="15.6"
       height="15.6"
       id="rect2" />
    <rect
       class="factory-styling"
       x="109.5"
       y="106"
       width="15.6"
       height="15.6"
       id="rect3" />
    <line
       class="factory-styling"
       x1="140.7"
       y1="95.5"
       x2="97.099998"
       y2="95.5"
       id="line3" />
  </g>
  `
]
export const fuelcell = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .fuelcell-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g5"
     transform="matrix(0.43196546,0,0,0.43196546,-16.943846,-20.15119)">
    <polyline
       class="fuelcell-styling"
       points="127.2 96.4 127.2 137.5 44.8 137.5 44.8 55.1 109.2 55.1"
       id="polyline1" />
    <circle
       class="fuelcell-styling"
       cx="126"
       cy="71.800003"
       r="23.4"
       id="circle1" />
    <circle
       class="fuelcell-styling"
       cx="65.199997"
       cy="71.800003"
       r="6.1999998"
       id="circle2" />
    <circle
       class="fuelcell-styling"
       cx="106.9"
       cy="120.7"
       r="6.1999998"
       id="circle3" />
    <path
       class="fuelcell-styling"
       d="m 73.8,96.6 h 26.8 c 3.4,0 6.2,2.8 6.2,6.2 0,3.4 -2.8,6.2 -6.2,6.2 H 73.8 c -3.4,0 -6.2,2.8 -6.2,6.2 0,3.4 2.8,6.2 6.2,6.2 h 26.8"
       id="path3" />
    <path
       class="fuelcell-styling"
       d="m 73.8,96.6 c -3.4,0 -6.2,-2.8 -6.2,-6.2 0,-3.4 2.8,-6.2 6.2,-6.2 h 30.7"
       id="path4" />
    <path
       class="fuelcell-styling"
       d="m 72.4,71.8 h 28.3"
       id="path5" />
    <polyline
       class="fuelcell-styling"
       points="128.7 58.9 120.7 72.8 132.9 72.8 125.1 86.6"
       id="polyline5" />
  </g>
  `
]
export const generic = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .generic-icon-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g5"
     transform="matrix(0.96480435,0,0,0.96480435,-62.025354,-64.951018)">
    <line
       class="generic-icon-styling"
       x1="90.025078"
       y1="89.945045"
       x2="90.025078"
       y2="69.070404"
       id="line1" />
    <line
       class="generic-icon-styling"
       x1="90.025078"
       y1="89.945045"
       x2="102.3866"
       y2="107.02959"
       id="line2" />
    <line
       class="generic-icon-styling"
       x1="90.025078"
       y1="89.945045"
       x2="77.780174"
       y2="107.02959"
       id="line3" />
    <line
       class="generic-icon-styling"
       x1="90.025078"
       y1="89.945045"
       x2="70.258308"
       y2="83.356125"
       id="line4" />
    <line
       class="generic-icon-styling"
       x1="90.025078"
       y1="89.945045"
       x2="110.14169"
       y2="83.356125"
       id="line5" />
  </g>
  `
]
export const grid = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .grid-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <polygon
     class="grid-styling"
     points="96.3,47.1 62.4,95.8 83.7,95.8 83.7,132.9 117.6,84.2 96.3,84.2 "
     id="polygon1"
     transform="matrix(0.44793217,0,0,0.44793217,-15.313895,-20.313895)" />
  `
]
export const gridOffgrid = [
  '50 40',
  `
  <defs
     id="defs7" />
  
  <path
     style="fill-opacity:1;stroke-miterlimit:10;stroke-width:0.49889764;stroke-dasharray:none"
     d="m 27.989964,1.8849786 -9.81e-4,0.00276 -3.976158,10.6362314 -0.685137,1.832745 1.898203,-0.474553 8.971079,-2.242968 -12.327559,26.43119 c -0.0076,0.01506 -0.01385,0.02591 -0.01622,0.0317 -0.0028,6.27e-4 -0.0061,0.0013 -0.0098,0.002 l 4.529467,-18.413484 0.405487,-1.648394 -1.648904,0.403456 -9.222663,2.256609 -0.146989,-2.45e-4 -0.0024,-0.0024 4.620853,-18.7784409 c 0.07029,-0.032489 0.09176,-0.036186 0.124875,-0.036186 h 7.486806 m 0.06789,-1.0286956 h -7.554705 c -0.298214,0 -0.49702,0.099408 -0.695826,0.1988158 -0.198806,0.099398 -0.298214,0.298204 -0.397622,0.4970198 L 14.737676,20.53831 c -0.09941,0.397621 0,0.695825 0.298214,0.894641 0.198806,0.198806 0.397612,0.298204 0.695825,0.298204 h 0.298214 l 9.34402,-2.286284 -4.572587,18.588569 c -0.05514,0.259576 0,0.497019 0.09941,0.695825 0.0994,0.198806 0.257949,0.35161 0.568901,0.397612 0.07167,0.0106 0.153236,0.01684 0.229903,0.01684 0.03267,0 0.06446,-0.0012 0.09418,-0.0035 0.486782,-0.01613 0.796881,-0.212104 0.995687,-0.609716 L 35.214947,11.890166 c 0.09941,-0.298214 0.111146,-0.771767 0,-0.99404 -0.125728,-0.251476 -0.453185,-0.336282 -0.751399,-0.336282 -0.0994,0 -0.242052,0.01211 -0.342039,0.03807 l -9.145172,2.286293 3.976158,-10.6362322 c 0.0994,-0.099408 0.0994,-0.2982139 0.0994,-0.3976218 0,-0.298204 -0.0994,-0.4970198 -0.298204,-0.6958258 C 28.554883,0.9556909 28.356077,0.856283 28.057864,0.856283 Z"
     id="path1" />
  <path
     style="fill-opacity:1;fill:none;stroke-width:2;stroke-opacity:1;stroke-linecap:round"
     d="M 11.137823,1.440028 21.144192,14.840365 38.85654,38.560402 v 0 0"
     id="path2"
     sodipodi:nodetypes="ccccc" />
  `
]
export const heatingelement = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .heatingelement-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g10"
     transform="matrix(0.41450777,0,0,0.41450777,-12.305699,-17.305699)">
    <path
       class="heatingelement-styling"
       d="m 108.6,111.7 c -10.7,-14.5 10.7,-29 0,-43.4"
       id="path1" />
    <path
       class="heatingelement-styling"
       d="M 90,111.7 C 79.3,97.2 100.7,82.7 90,68.3"
       id="path2" />
    <path
       class="heatingelement-styling"
       d="m 71.4,111.7 c -10.7,-14.5 10.7,-29 0,-43.4"
       id="path3" />
    <path
       class="heatingelement-styling"
       d="m 43.5,49.7 c 0,-3.4 2.8,-6.2 6.2,-6.2"
       id="path4" />
    <path
       class="heatingelement-styling"
       d="m 136.5,49.7 c 0,-3.4 -2.8,-6.2 -6.2,-6.2"
       id="path5" />
    <path
       class="heatingelement-styling"
       d="m 43.5,130.3 c 0,3.4 2.8,6.2 6.2,6.2"
       id="path6" />
    <path
       class="heatingelement-styling"
       d="m 136.5,130.3 c 0,3.4 -2.8,6.2 -6.2,6.2"
       id="path7" />
    <line
       class="heatingelement-styling"
       x1="43.5"
       y1="49.700001"
       x2="43.5"
       y2="130.3"
       id="line7" />
    <line
       class="heatingelement-styling"
       x1="49.700001"
       y1="136.5"
       x2="130.3"
       y2="136.5"
       id="line8" />
    <line
       class="heatingelement-styling"
       x1="136.5"
       y1="130.3"
       x2="136.5"
       y2="49.700001"
       id="line9" />
    <line
       class="heatingelement-styling"
       x1="130.3"
       y1="43.5"
       x2="49.700001"
       y2="43.5"
       id="line10" />
  </g>
  `
]
export const heatpump = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .heatpump-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g9"
     transform="matrix(0.46040516,0,0,0.46040516,-16.413444,-21.436464)">
    <rect
       class="heatpump-styling"
       x="50.299999"
       y="-142.5"
       width="67.800003"
       height="105.1"
       rx="5.6999998"
       ry="5.6999998"
       transform="rotate(90)"
       id="rect1" />
    <polyline
       class="heatpump-styling"
       points="73.3 118.5 73.3 129.7 57.9 129.7 57.9 118.5"
       id="polyline1" />
    <polyline
       class="heatpump-styling"
       points="122.7 118.5 122.7 129.7 107.3 129.7 107.3 118.5"
       id="polyline2" />
    <line
       class="heatpump-styling"
       x1="117.8"
       y1="104.8"
       x2="130.5"
       y2="104.8"
       id="line2" />
    <line
       class="heatpump-styling"
       x1="117.8"
       y1="95.5"
       x2="130.5"
       y2="95.5"
       id="line3" />
    <line
       class="heatpump-styling"
       x1="117.8"
       y1="86.699997"
       x2="130.5"
       y2="86.699997"
       id="line4" />
    <line
       class="heatpump-styling"
       x1="107.6"
       y1="116.6"
       x2="107.6"
       y2="50.400002"
       id="line5" />
    <circle
       class="heatpump-styling"
       cx="72.699997"
       cy="84.099998"
       id="circle5"
       r="21.6" />
    <line
       class="heatpump-styling"
       x1="58.5"
       y1="70"
       x2="72.699997"
       y2="84.099998"
       id="line6" />
    <line
       class="heatpump-styling"
       x1="72.699997"
       y1="84.099998"
       x2="86.800003"
       y2="98.300003"
       id="line7" />
    <line
       class="heatpump-styling"
       x1="86.800003"
       y1="70.099998"
       x2="72.699997"
       y2="84.199997"
       id="line8" />
    <line
       class="heatpump-styling"
       x1="72.699997"
       y1="84.099998"
       x2="58.599998"
       y2="98.300003"
       id="line9" />
  </g>
  `
]
export const pv = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .pv-icon-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g7"
     transform="matrix(0.41194644,0,0,0.41194644,-12.07518,-15.427395)">
    <polygon
       class="pv-icon-styling"
       points="127.6,75 140.6,132.8 39.4,132.8 52.4,75 "
       id="polygon1" />
    <line
       class="pv-icon-styling"
       x1="77.5"
       y1="75"
       x2="73.099998"
       y2="132.8"
       id="line1" />
    <line
       class="pv-icon-styling"
       x1="102.5"
       y1="75"
       x2="106.9"
       y2="132.8"
       id="line2" />
    <polyline
       class="pv-icon-styling"
       points="48 94.3 76 94.3 104 94.3 132 94.3"
       id="polyline2" />
    <polyline
       class="pv-icon-styling"
       points="43.7 113.5 74.5 113.5 105.5 113.5 136.3 113.5"
       id="polyline3" />
    <line
       class="pv-icon-styling"
       x1="90"
       y1="39.200001"
       x2="90"
       y2="44.599998"
       id="line3" />
    <line
       class="pv-icon-styling"
       x1="116.1"
       y1="65.300003"
       x2="110.7"
       y2="65.300003"
       id="line4" />
    <line
       class="pv-icon-styling"
       x1="69.300003"
       y1="65.300003"
       x2="63.900002"
       y2="65.300003"
       id="line5" />
    <line
       class="pv-icon-styling"
       x1="108.4"
       y1="46.799999"
       x2="104.6"
       y2="50.599998"
       id="line6" />
    <line
       class="pv-icon-styling"
       x1="75.400002"
       y1="50.599998"
       x2="71.599998"
       y2="46.799999"
       id="line7" />
    <path
       class="pv-icon-styling"
       d="m 77.7,64.7 c 0,-6.8 5.5,-12.3 12.3,-12.3 6.8,0 12.3,5.5 12.3,12.3"
       id="path7" />
  </g>
  `
]
export const rest = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .rest-icon-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g1"
     transform="matrix(0.48019206,0,0,0.48019206,-18.217285,-23.217285)">
    <circle
       class="rest-icon-styling"
       cx="90"
       cy="90"
       r="39.900002"
       id="circle1" />
    <path
       class="rest-icon-styling"
       d="m 90.2,103.2 v -5.1 c 0,-1.8 1.2,-3.3 2.9,-3.7 5.2,-1.3 8.9,-6.2 8.6,-11.9 -0.4,-5.7 -5,-10.4 -10.7,-10.7 -5.6,-0.3 -10.3,3.3 -11.8,8.3"
       id="path1" />
    <line
       class="rest-icon-styling"
       x1="90.199997"
       y1="110.2"
       x2="90.199997"
       y2="110.2"
       id="line1" />
  </g>
  `
]
export const trafo = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .trafo-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g13"
     transform="matrix(0.39721948,0,0,0.39721948,-10.749755,-15.749753)">
    <rect
       class="trafo-styling"
       x="55.400002"
       y="78.199997"
       width="69.199997"
       height="60.400002"
       id="rect1" />
    <line
       class="trafo-styling"
       x1="129.10001"
       y1="78.199997"
       x2="50.900002"
       y2="78.199997"
       id="line1" />
    <line
       class="trafo-styling"
       x1="111.8"
       y1="41.400002"
       x2="111.8"
       y2="78.199997"
       id="line2" />
    <line
       class="trafo-styling"
       x1="105.6"
       y1="47.200001"
       x2="118"
       y2="47.200001"
       id="line3" />
    <line
       class="trafo-styling"
       x1="105.6"
       y1="56.200001"
       x2="118"
       y2="56.200001"
       id="line4" />
    <line
       class="trafo-styling"
       x1="105.6"
       y1="64.800003"
       x2="118"
       y2="64.800003"
       id="line5" />
    <polygon
       class="trafo-styling"
       points="93.2,84.5 75.7,109.7 86.8,109.7 86.8,128.9 104.3,103.7 93.2,103.7 "
       id="polygon5" />
    <line
       class="trafo-styling"
       x1="91.300003"
       y1="41.400002"
       x2="91.300003"
       y2="78.199997"
       id="line6" />
    <line
       class="trafo-styling"
       x1="85.099998"
       y1="47.200001"
       x2="97.5"
       y2="47.200001"
       id="line7" />
    <line
       class="trafo-styling"
       x1="85.099998"
       y1="56.200001"
       x2="97.5"
       y2="56.200001"
       id="line8" />
    <line
       class="trafo-styling"
       x1="85.099998"
       y1="64.800003"
       x2="97.5"
       y2="64.800003"
       id="line9" />
    <line
       class="trafo-styling"
       x1="70.800003"
       y1="41.400002"
       x2="70.800003"
       y2="78.199997"
       id="line10" />
    <line
       class="trafo-styling"
       x1="64.599998"
       y1="47.200001"
       x2="77"
       y2="47.200001"
       id="line11" />
    <line
       class="trafo-styling"
       x1="64.599998"
       y1="56.200001"
       x2="77"
       y2="56.200001"
       id="line12" />
    <line
       class="trafo-styling"
       x1="64.599998"
       y1="64.800003"
       x2="77"
       y2="64.800003"
       id="line13" />
  </g>
  `
]
export const user = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .user-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g1"
     transform="matrix(0.40609135,0,0,0.40609135,-11.560663,-16.548222)">
    <path
       class="user-styling"
       d="m 137.7,91.6 h -9.4 v 45.9 H 51.7 V 91.6 h -9.4 c -1.5,0 -2.2,-1.8 -1.2,-2.9 L 88.9,43 c 0.3,-0.3 0.7,-0.5 1.2,-0.5 0.5,0 0.8,0.2 1.2,0.5 l 19.8,19 3.1,3 10.2,9.8 4,3.9 10.5,10.1 c 1.1,1.1 0.4,2.9 -1.2,2.9 z"
       id="path1" />
    <rect
       class="user-styling"
       x="75.300003"
       y="97.800003"
       width="29.4"
       height="39.700001"
       id="rect1" />
  </g>
  `
]
export const wallbox = [
  '50 40',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.3.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 146)  -->
  <defs
     id="defs1">
    <style
       id="style1">
      .wallbox-styling {
        fill: none;
        stroke: inherit;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3.5px;
      }
    </style>
  </defs>
  <g
     id="g3"
     transform="matrix(0.46457608,0,0,0.46457608,-21.712858,-21.811849)">
    <rect
       class="wallbox-styling"
       x="-110.8"
       y="-119.9"
       width="45.900002"
       height="71.199997"
       rx="3.8"
       ry="3.8"
       transform="scale(-1)"
       id="rect1" />
    <polygon
       class="wallbox-styling"
       points="90.5,66.2 75.8,87.5 85.1,87.5 85.1,103.6 99.8,82.4 90.5,82.4 "
       id="polygon1" />
    <rect
       class="wallbox-styling"
       x="-119"
       y="-131.3"
       width="62.299999"
       height="11.4"
       rx="1.8"
       ry="1.8"
       transform="scale(-1)"
       id="rect2" />
    <path
       class="wallbox-styling"
       d="m 131.9,73.7 v 28.4 c 0,3.1 -2.5,5.7 -5.7,5.7 v 0 c -3.1,0 -5.7,-2.5 -5.7,-5.7 v -23.7 0 c 0,-3.1 -2.5,-5.7 -5.7,-5.7 h -4.1"
       id="path2" />
    <path
       class="wallbox-styling"
       d="m 144.4,63.4 -8.2,2.2 c -0.7,0.4 -1.1,1.1 -1.1,1.9 v 6.2 h -6.4 v -9 c 0,-3.4 2.8,-6.2 6.2,-6.2 h 9.4 v 4.9 z"
       id="path3" />
  </g>
  `
]
export const wallboxPlugged = [
  '50 40',
  `
  <defs
     id="defs13" />
  
  <defs
     id="defs137">
    <style
       id="style135">
       .e-board-svg-ecar-plugged-0 {
         fill: none;
         stroke: inherit;
         stroke-linecap: round;
         stroke-linejoin: round;
         stroke-width: 3.5px;
       }
     </style>
  </defs>
  <g
     id="g5000"
     transform="matrix(0.34343286,0,0,0.34343286,-5.4338131,-11.200876)">
    <g
       id="g4472">
      <rect
         class="e-board-svg-ecar-plugged-0"
         x="24.5"
         y="60.099998"
         width="34.200001"
         height="53"
         rx="2.9000001"
         ry="2.9000001"
         transform="rotate(180,41.55,86.6)"
         id="rect4462" />
      <polygon
         class="e-board-svg-ecar-plugged-0"
         points="39.5,101 50.5,85.1 43.6,85.1 43.6,73.1 32.6,88.9 39.5,88.9 "
         id="polygon4464"/>
      <rect
         class="e-board-svg-ecar-plugged-0"
         x="18.4"
         y="113.1"
         width="46.400002"
         height="8.5"
         rx="1.3"
         ry="1.3"
         transform="rotate(180,41.55,117.3)"
         id="rect4466"/>
      <path
         class="e-board-svg-ecar-plugged-0"
         d="m 58.7,78 h 3 c 2.3,0 4.2,1.9 4.2,4.2 v 0 17.6 c 0,2.3 1.9,4.2 4.2,4.2 h 7.2"
         id="path4468" />
      <path
         class="e-board-svg-ecar-plugged-0"
         d="m 89.5,99 -6.1,1.6 c -0.5,0.3 -0.9,0.8 -0.9,1.4 v 4.6 h -4.7 v -6.7 c 0,-2.6 2.1,-4.6 4.6,-4.6 h 7 V 99 Z"
         id="path4470"/>
    </g>
    <g
       id="g4498">
      <path
         class="e-board-svg-ecar-plugged-0"
         d="m 96.3,85.6 1.4,-2.1 4.6,-9.3 c 0.7,-1.4 2.1,-2.4 3.7,-2.5 3.9,-0.3 11.3,-0.9 17.1,-0.9 5.8,0 13.2,0.6 17.1,0.9 1.6,0.1 3,1.1 3.7,2.5 l 4.6,9.3 1.4,2.1"
         id="path4474"/>
      <path
         class="e-board-svg-ecar-plugged-0"
         d="m 152.3,89.1 2.4,3.5 c 0,0.1 0.2,0.2 0.2,0.4 0.4,0.7 0.6,1.4 0.6,2.2 V 110 c 0,1.5 -0.7,2.8 -1.8,3.7 l -1.5,1.2 c -0.8,0.6 -1.8,0.9 -2.8,0.9 H 97 c -1,0 -2,-0.3 -2.8,-0.9 l -1.5,-1.2 c -1.2,-0.9 -1.8,-2.2 -1.8,-3.7 V 95.2 c 0,-0.8 0.2,-1.5 0.6,-2.2 0,-0.1 0.1,-0.2 0.2,-0.4 l 2.4,-3.5"
         id="path4476"/>
      <path
         class="e-board-svg-ecar-plugged-0"
         d="m 90.8,118.1 v 1.2 c 0,1.3 1,2.3 2.3,2.3 h 6.9 c 0.9,0 1.6,-0.5 2,-1.2"
         id="path4478" />
      <path
         class="e-board-svg-ecar-plugged-0"
         d="m 155.5,118.1 v 1.2 c 0,1.3 -1,2.3 -2.3,2.3 h -6.9 c -0.9,0 -1.6,-0.5 -2,-1.2"
         id="path4480" />
      <path
         class="e-board-svg-ecar-plugged-0"
         d="m 101.1,86.7 c 0.4,0.1 0.8,0.2 1.2,0.2 h 20.9"
         id="path4482"/>
      <path
         class="e-board-svg-ecar-plugged-0"
         d="M 123.1,86.9 H 144 c 0.4,0 0.8,0 1.2,-0.2"
         id="path4484"/>
      <path
         class="e-board-svg-ecar-plugged-0"
         d="m 152.6,81.1 h 3.1 c 1,0 1.9,0.5 2.3,1.3 l 0.7,1.3 c 0.6,1.1 0.1,2.5 -1.2,3.1 l -0.9,0.4 -4.3,1.9"
         id="path4486"/>
      <path
         class="e-board-svg-ecar-plugged-0"
         d="m 93.7,81.1 h -3.1 c -1,0 -1.9,0.5 -2.3,1.3 l -0.7,1.3 c -0.6,1.1 -0.1,2.5 1.2,3.1 l 0.9,0.4 4.3,1.9"
         id="path4488" />
      <path
         class="e-board-svg-ecar-plugged-0"
         d="m 98.4,97.4 8.6,0.9 c 0.8,0 1.3,0.9 1,1.6 l -1.2,2.9 c -0.4,0.9 -1.2,1.5 -2.2,1.5 h -7.3"
         id="path4490" />
      <path
         class="e-board-svg-ecar-plugged-0"
         d="m 148.9,104.2 h -7.2 c -1,0 -1.9,-0.6 -2.2,-1.5 l -1.2,-2.9 c -0.3,-0.7 0.2,-1.5 1,-1.6 l 8.6,-0.9"
         id="path4492" />
      <line
         class="e-board-svg-ecar-plugged-0"
         x1="112.7"
         y1="98.5"
         x2="133.5"
         y2="98.5"
         id="line4494" />
      <path
         class="e-board-svg-ecar-plugged-0"
         d="m 111.6,111.2 v -3.5 c 0,-0.6 0.5,-1.2 1.2,-1.2 h 20.8 c 0.6,0 1.2,0.5 1.2,1.2 v 3.5"
         id="path4496" />
    </g>
  </g>
  `
]
export const wallboxUnplugged = [
  '50 40',
  `
  <defs
   id="defs13" />
     <defs
   id="defs137">
  <style
     id="style135">
       .e-board-svg-ecar-unplugged-0 {
         fill: none;
         stroke: inherit;
         stroke-linecap: round;
         stroke-linejoin: round;
         stroke-width: 3.5px;
       }
     </style>
</defs>
<g
   id="g206"
   transform="matrix(0.4464717,0,0,0.4464717,-15.874485,-20.182453)"
   >
  <g
     data-name="Ebene 1"
     transform="matrix(5.6,0,0,5.6,200,2800)"
     clip-path="url(#clipPath5)"
     id=""/>
  <rect
     class="e-board-svg-ecar-unplugged-0"
     x="64.800003"
     y="48.700001"
     width="45.900002"
     height="71.199997"
     rx="3.8"
     ry="3.8"
     transform="rotate(180,87.8,84.3)"
     id="rect139"/>
  <polygon
     class="e-board-svg-ecar-unplugged-0"
     points="90.5,82.4 90.5,66.2 75.8,87.5 85.1,87.5 85.1,103.6 99.8,82.4 "
     id="polygon141" />
  <rect
     class="e-board-svg-ecar-unplugged-0"
     x="56.599998"
     y="119.9"
     width="62.299999"
     height="11.4"
     rx="1.8"
     ry="1.8"
     transform="rotate(180,87.8,125.6)"
     id="rect143" />
  <path
     class="e-board-svg-ecar-unplugged-0"
     d="m 123.3,71 v 36 c 0,1.9 -1.5,3.4 -3.4,3.4 v 0 c -1.9,0 -3.4,-1.5 -3.4,-3.4 v -30 0 c 0,-1.9 -1.5,-3.4 -3.4,-3.4 h -2.4"
     id="path145"/>
  <path
     class="e-board-svg-ecar-unplugged-0"
     d="m 111.1,60.4 8,2.1 c 0.7,0.3 1.1,1 1.1,1.8 v 6.1 c 0,0 6.2,0 6.2,0 v -8.8 c 0,-3.3 -2.7,-6.1 -6.1,-6.1 h -9.2 c 0,0 0,4.8 0,4.8 z"
     id="path147"/>
</g>
  `
]
export const wallboxWarning = [
  '50 40',
  `
  <defs
     id="defs13" />
  
  <defs
     id="defs137">
    <style
       id="style135">
       .e-board-svg-ecar-warning-0 {
         fill: none;
         stroke: inherit;
         stroke-linecap: round;
         stroke-linejoin: round;
         stroke-width: 3.5px;
       }
     </style>
  </defs>
  <g
     id="g4425"
     transform="matrix(0.44729427,0,0,0.44729427,-15.285664,-20.256484)">
    <g
       id="g3927">
      <path
         class="e-board-svg-ecar-warning-0"
         d="M 77.6,68.1 V 52.5 c 0,-2.1 1.7,-3.8 3.8,-3.8 h 38.3 c 2.1,0 3.8,1.7 3.8,3.8 V 116 c 0,2.1 -1.7,3.8 -3.8,3.8 H 81.4 c -2.1,0 -3.8,-1.7 -3.8,-3.8 v -4.6"
         id="path3917"/>
      <polygon
         class="e-board-svg-ecar-warning-0"
         points="112.6,82.4 103.3,82.4 103.3,66.2 88.5,87.5 97.8,87.5 97.8,103.6 "
         id="polygon3919"/>
      <rect
         class="e-board-svg-ecar-warning-0"
         x="69.400002"
         y="119.9"
         width="62.299999"
         height="11.4"
         rx="1.8"
         ry="1.8"
         transform="rotate(180,100.55,125.6)"
         id="rect3921" />
      <path
         class="e-board-svg-ecar-warning-0"
         d="m 136,71 v 36 c 0,1.9 -1.5,3.4 -3.4,3.4 v 0 c -1.9,0 -3.4,-1.5 -3.4,-3.4 v -30 0 c 0,-1.9 -1.5,-3.4 -3.4,-3.4 h -2.4"
         id="path3923" />
      <path
         class="e-board-svg-ecar-warning-0"
         d="m 123.9,60.4 8,2.1 c 0.7,0.3 1.1,1 1.1,1.8 v 6.1 c 0,0 6.2,0 6.2,0 v -8.8 c 0,-3.3 -2.7,-6.1 -6.1,-6.1 h -9.2 c 0,0 0,4.8 0,4.8 z"
         id="path3925"/>
    </g>
    <path
       class="e-board-svg-ecar-warning-0"
       d="m 63.4,64.8 -22.1,36.3 c -0.5,0.8 -0.5,1.8 0,2.6 0.5,0.8 1.3,1.3 2.2,1.3 h 44.2 c 0.9,0 1.8,-0.5 2.2,-1.3 0.5,-0.8 0.4,-1.8 0,-2.6 L 67.8,64.8 c -1,-1.6 -3.4,-1.6 -4.4,0 z"
       id="path3929"/>
    <path
       class="e-board-svg-ecar-warning-0"
       d="M 65.6,76.7 V 91.5"
       id="path3931"/>
    <path
       class="e-board-svg-ecar-warning-0"
       d="m 65.6,96.7 v 0"
       id="path3933" />
  </g>
  `
]
